var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _g3, _path10, _path11, _g4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g5, _path19, _g6, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g7, _path30, _g8, _path31, _g9, _path32, _path33, _path34, _g10, _path35, _g11, _path36, _path37, _path38, _path39, _g12, _path40, _path41, _g13, _g14, _path42, _path43, _g15, _path44, _g16, _g17, _g18, _g19, _g20, _g21, _path45, _g22, _path46, _path47, _g23, _path48, _path49, _g24, _path50, _g25, _g26, _g27, _g28, _g29, _g30, _path51, _g31, _path52, _path53, _path54, _path55, _g32, _path56, _path57, _g33, _path58, _path59, _path60, _g34, _g35, _path61, _path62, _g36, _path63, _g37, _g38, _g39, _g40, _g41, _g42, _path64, _g43, _path65, _path66, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenguinErrorLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 690,
    height: 287,
    viewBox: "0 0 690 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1342_37795)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.298 171.04V4.38965H576.738L447.258 179.03V217.39H570.348V282.93H620.308V217.39H664.668V171.03H620.308L620.298 171.04ZM498.258 171.04L570.338 69.8796V171.04H498.258Z",
    fill: "#A884F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.851 67.14C416.391 54.62 411.061 43.29 403.871 33.17C396.681 23.05 387.221 15.05 375.491 9.19C364.031 3.06 349.651 0 332.331 0C315.011 0 300.091 3.06 288.371 9.19C276.911 15.32 267.591 23.44 260.391 33.57C253.201 43.69 247.741 55.02 244.001 67.54C240.541 80.06 238.141 92.85 236.811 105.9C235.741 118.69 235.211 130.81 235.211 142.27C235.211 153.73 235.881 166.51 237.211 179.84C238.541 193.16 240.941 206.08 244.401 218.6C248.131 231.12 253.591 242.58 260.791 252.97C267.981 263.09 277.441 271.22 289.161 277.35C300.881 283.48 315.401 286.54 332.721 286.54C350.041 286.54 364.021 283.61 375.481 277.75C386.941 271.62 396.261 263.5 403.451 253.37C410.641 243.25 416.111 231.92 419.841 219.4C423.571 206.88 426.101 193.96 427.431 180.63C428.761 167.31 429.431 154.52 429.431 142.26C429.431 130 428.761 118.28 427.431 105.49C426.101 92.43 423.571 79.65 419.841 67.12L419.851 67.14ZM375.091 191.43C372.691 205.82 368.161 217.41 361.501 226.2C354.841 234.73 345.251 238.99 332.731 238.99C322.871 238.99 314.881 236.46 308.751 231.4C302.621 226.07 297.961 219.01 294.761 210.22C291.561 201.43 289.301 191.3 287.971 179.85C286.901 168.39 286.371 156.4 286.371 143.88C286.371 131.36 286.901 118.57 287.971 107.11C289.301 95.39 291.431 85.13 294.361 76.34C297.561 67.55 302.221 60.62 308.351 55.56C314.481 50.5 322.471 47.97 332.331 47.97C344.851 47.97 354.441 52.23 361.101 60.76C367.761 69.29 372.291 80.88 374.691 95.53C377.351 109.92 378.691 126.04 378.691 143.89C378.691 161.74 377.491 177.06 375.091 191.45V191.43Z",
    fill: "#A884F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.04 4.38965H129.48L0 179.04V217.4H123.09V282.94H173.05V217.4H217.41V171.04H173.05V4.38965H173.04ZM51.01 171.04L123.09 69.8796V171.04H51.01Z",
    fill: "#A884F7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M645.298 171.04V4.38965H601.738L472.258 179.03V217.39H595.348V282.93H645.308V217.39H689.668V171.03H645.308L645.298 171.04ZM523.258 171.04L595.338 69.8796V171.04H523.258Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.729 286.54C340.409 286.54 325.889 283.48 314.169 277.35C302.449 271.22 292.989 263.1 285.799 252.97C278.609 242.58 273.139 231.12 269.409 218.6C265.949 206.08 263.549 193.16 262.219 179.84C260.889 166.52 260.219 154 260.219 142.27C260.219 130.54 260.749 118.69 261.819 105.9C263.149 92.85 265.549 80.06 269.009 67.54C272.739 55.02 278.199 43.69 285.399 33.57C292.589 23.45 301.919 15.32 313.379 9.19C325.099 3.06 339.759 0 357.339 0C374.919 0 389.039 3.06 400.499 9.19C412.219 15.05 421.679 23.04 428.879 33.17C436.069 43.29 441.399 54.62 444.859 67.14C448.589 79.66 451.119 92.45 452.449 105.51C453.779 118.3 454.449 130.55 454.449 142.28C454.449 154.01 453.779 167.32 452.449 180.65C451.119 193.98 448.589 206.89 444.859 219.41C441.129 231.93 435.669 243.26 428.469 253.38C421.279 263.5 411.949 271.63 400.499 277.76C389.039 283.62 374.789 286.55 357.739 286.55L357.729 286.54ZM357.729 238.98C370.249 238.98 379.839 234.72 386.499 226.19C393.159 217.4 397.689 205.81 400.089 191.42C402.489 177.03 403.689 161.18 403.689 143.86C403.689 126.54 402.359 109.89 399.689 95.5C397.289 80.85 392.759 69.26 386.099 60.73C379.439 52.2 369.849 47.94 357.329 47.94C347.469 47.94 339.479 50.47 333.349 55.53C327.219 60.59 322.559 67.52 319.359 76.31C316.429 85.1 314.299 95.36 312.969 107.08C311.899 118.54 311.369 130.79 311.369 143.85C311.369 156.91 311.899 168.36 312.969 179.82C314.299 191.28 316.569 201.4 319.759 210.19C322.959 218.98 327.619 226.04 333.749 231.37C339.879 236.43 347.869 238.96 357.729 238.96V238.98Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.04 171.04V4.38965H154.48L25 179.04V217.4H148.09V282.94H198.05V217.4H242.41V171.04H198.05H198.04ZM76.01 171.04L148.09 69.8796V171.04H76.01Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M402.561 182C401.621 193 399.931 210.05 396.781 232.44C398.341 231.62 400.711 230.17 403.001 227.77C406.101 224.52 408.771 219.81 411.001 204.88C412.051 197.85 412.731 193.33 412.781 186.44C412.931 166.12 407.181 146.88 403.611 136.25C403.791 141.81 403.611 149.34 403.391 158.11C403.181 166.06 403.311 173.13 402.561 182Z",
    fill: "url(#paint0_radial_1342_37795)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M423.499 172.239C423.169 172.879 422.949 173.319 422.739 173.689C421.709 175.589 419.149 180.379 415.379 185.139C411.509 190.009 407.269 193.739 403.719 196.399C404.909 199.679 406.339 204.699 406.589 210.949C406.809 216.439 406.999 220.939 404.609 225.899C402.119 231.079 397.669 235.019 394.289 238.009C393.279 238.899 392.299 239.709 391.759 240.129C385.429 244.999 376.859 244.199 363.919 244.669C355.609 244.969 339.769 245.999 332.509 242.789C330.549 241.919 329.039 240.669 328.979 240.609C325.739 237.899 324.599 234.389 323.989 232.529C322.239 227.219 321.009 216.019 321.539 201.459C316.069 192.849 306.209 176.549 304.849 168.919C304.549 167.229 301.139 146.789 308.399 143.239C310.139 142.379 312.619 142.449 314.479 143.339C318.119 145.079 319.139 149.839 319.609 151.749C320.899 156.919 324.009 164.259 332.019 173.719C325.529 158.269 328.369 140.879 339.169 129.699C347.909 120.649 362.689 114.829 376.439 119.489C388.719 123.659 394.369 134.149 395.839 136.979C405.089 154.819 396.069 173.049 394.999 175.119C403.489 168.789 408.909 162.479 412.319 157.799C418.239 149.679 421.199 142.259 425.799 142.559C428.419 142.729 430.579 145.349 431.479 147.369C433.659 152.269 430.269 158.929 423.479 172.239H423.499Z",
    fill: "#584EA0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M424.479 172.24C424.099 172.98 423.769 173.6 423.719 173.69C422.689 175.59 420.129 180.38 416.359 185.14C412.489 190.01 408.249 193.74 404.699 196.4C405.889 199.68 407.319 204.7 407.569 210.95C407.789 216.44 407.979 220.94 405.589 225.9C403.099 231.08 398.649 235.02 395.269 238.01C394.259 238.9 393.279 239.71 392.739 240.13C386.409 245 377.839 244.2 364.899 244.67C356.589 244.97 340.749 246 333.489 242.79C331.529 241.92 330.019 240.67 329.959 240.61C326.719 237.9 325.579 234.39 324.969 232.53C323.219 227.22 321.989 216.02 322.519 201.46C317.049 192.85 307.189 176.55 305.829 168.92C304.259 160.12 303.969 145.49 309.379 143.24C310.529 142.76 312.629 142.55 314.479 143.34C315.939 143.96 317.099 145.13 319.069 148.69C320.749 151.72 321.579 153.24 322.459 156.01C323.609 159.66 326.289 165.25 333.009 173.72C326.939 158.19 329.639 141.02 340.159 129.7C348.369 120.87 363.199 113.62 377.409 118.43C389.849 122.65 395.329 133.92 396.829 136.99C405.499 154.82 397.249 172.54 395.989 175.13C404.449 168.88 409.859 162.6 413.309 157.81C418.829 150.16 422.129 142.47 426.679 142.9C429.249 143.14 430.889 145.85 431.159 146.29C434.699 152.12 429.819 161.72 424.469 172.25L424.479 172.24Z",
    fill: "#19124C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M427.931 172.24C427.691 172.72 427.451 173.19 427.171 173.69C426.141 175.59 423.581 180.38 419.811 185.14C415.941 190.01 411.701 193.74 408.151 196.4C409.341 199.68 410.771 204.7 411.021 210.95C411.241 216.44 411.431 220.94 409.041 225.9C406.551 231.08 402.101 235.02 398.721 238.01C397.711 238.9 396.731 239.71 396.191 240.13C389.861 245 381.291 244.2 368.351 244.67C360.041 244.97 344.201 246 336.941 242.79C334.981 241.92 333.471 240.67 333.411 240.61C330.171 237.9 329.031 234.39 328.421 232.53C326.671 227.22 325.441 216.02 325.971 201.46C320.501 192.85 310.641 176.55 309.281 168.92C308.141 162.54 306.491 144.6 312.831 143.24C317.641 142.21 319.461 151.26 324.461 159.2C328.091 164.97 333.161 170.43 336.451 173.72C329.961 158.27 332.801 140.88 343.601 129.7C352.341 120.65 367.121 114.83 380.871 119.49C393.151 123.66 398.801 134.15 400.271 136.98C409.521 154.82 400.501 173.05 399.431 175.12C407.901 168.68 413.341 162.38 416.751 157.8C422.101 150.61 425.551 143.5 428.951 144.2C430.781 144.58 431.681 147.02 432.381 148.98C435.301 157.23 431.101 165.9 427.921 172.25L427.931 172.24Z",
    fill: "#4F3F99"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 379,
    y: 144,
    width: 55,
    height: 101
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M398.718 238.01C402.088 235.03 406.548 231.09 409.038 225.9C411.418 220.94 411.238 216.44 411.018 210.95C410.768 204.7 409.338 199.68 408.148 196.4C411.698 193.73 415.938 190.01 419.808 185.14C423.578 180.39 426.138 175.6 427.168 173.69C427.438 173.19 427.688 172.71 427.928 172.24C431.108 165.89 435.308 157.22 432.388 148.97C431.698 147.02 430.788 144.57 428.958 144.19C428.198 144.03 427.428 144.27 426.638 144.82C427.228 146.78 427.038 149.17 427.148 151.1C427.478 157.45 425.308 163.46 421.638 169.14C416.798 176.49 411.948 182.5 404.768 187.68C401.928 189.85 398.918 192.69 395.248 192.69C395.578 193.69 396.588 194.03 396.748 194.69C398.248 201.87 396.748 208.55 394.748 215.23C391.058 226.88 388.668 236.06 379.828 244.46C386.338 243.52 390.938 243.57 396.188 240.11C396.618 239.83 397.568 239.01 398.718 237.99V238.01Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.598 144.04L376.188 216.75V144.04H395.598Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.908 144.04L376.188 217.9V216.75L395.598 144.04H395.908Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.217 144.04L376.188 219.05V217.9L395.908 144.04H396.217Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.527 144.04L376.188 220.21V219.05L396.217 144.04H396.527Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.837 144.04L376.188 221.36V220.21L396.527 144.04H396.837Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.147 144.04L376.188 222.52V221.36L396.837 144.04H397.147Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.448 144.04L376.188 223.67V222.52L397.147 144.04H397.448Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.758 144.04L376.188 224.83V223.67L397.448 144.04H397.758Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.068 144.04L376.188 225.98V224.83L397.758 144.04H398.068Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.378 144.04L376.188 227.14V225.98L398.068 144.04H398.378Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.688 144.04L376.188 228.29V227.14L398.378 144.04H398.688Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.987 144.04L376.188 229.44V228.29L398.688 144.04H398.987Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.297 144.04L376.188 230.6V229.44L398.987 144.04H399.297Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.607 144.04L376.188 231.75V230.6L399.297 144.04H399.607Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.918 144.04L376.188 232.91V231.75L399.607 144.04H399.918Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.228 144.04L376.188 234.06V232.91L399.918 144.04H400.228Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.538 144.04L376.188 235.22V234.06L400.228 144.04H400.538Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.837 144.04L376.188 236.37V235.22L400.538 144.04H400.837Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.147 144.04L376.188 237.53V236.37L400.837 144.04H401.147Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.457 144.04L376.188 238.68V237.53L401.147 144.04H401.457Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.767 144.04L376.188 239.83V238.68L401.457 144.04H401.767Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.077 144.04L376.188 240.99V239.83L401.767 144.04H402.077Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.388 144.04L376.188 242.14V240.99L402.077 144.04H402.388Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.688 144.04L376.188 243.3V242.14L402.388 144.04H402.688Z",
    fill: "#50409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.997 144.04L376.188 244.45V243.3L402.688 144.04H402.997Z",
    fill: "#50409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.307 144.04L376.188 245.61V244.45L402.997 144.04H403.307Z",
    fill: "#50409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.617 144.04L376.318 246.29H376.188V245.61L403.307 144.04H403.617Z",
    fill: "#50409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.93 144.04L376.63 246.29H376.32L403.62 144.04H403.93Z",
    fill: "#50419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.225 144.04L376.935 246.29H376.625L403.925 144.04H404.225Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.538 144.04L377.237 246.29H376.938L404.228 144.04H404.538Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.844 144.04L377.544 246.29H377.234L404.534 144.04H404.844Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.157 144.04L377.857 246.29H377.547L404.847 144.04H405.157Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.469 144.04L378.169 246.29H377.859L405.159 144.04H405.469Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.774 144.04L378.474 246.29H378.164L405.464 144.04H405.774Z",
    fill: "#51429A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.077 144.04L378.777 246.29H378.477L405.777 144.04H406.077Z",
    fill: "#52429A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.391 144.04L379.091 246.29H378.781L406.081 144.04H406.391Z",
    fill: "#52429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.696 144.04L379.396 246.29H379.086L406.386 144.04H406.696Z",
    fill: "#52429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.008 144.04L379.708 246.29H379.398L406.698 144.04H407.008Z",
    fill: "#52429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.321 144.04L380.021 246.29H379.711L407.011 144.04H407.321Z",
    fill: "#52439B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.626 144.04L380.326 246.29H380.016L407.316 144.04H407.626Z",
    fill: "#53439B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.928 144.04L380.628 246.29H380.328L407.628 144.04H407.928Z",
    fill: "#53439B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.235 144.04L380.935 246.29H380.625L407.925 144.04H408.235Z",
    fill: "#53439B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.547 144.04L381.247 246.29H380.938L408.237 144.04H408.547Z",
    fill: "#53449B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.86 144.04L381.56 246.29H381.25L408.55 144.04H408.86Z",
    fill: "#53449C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.165 144.04L381.865 246.29H381.555L408.855 144.04H409.165Z",
    fill: "#54449C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.467 144.04L382.177 246.29H381.867L409.167 144.04H409.467Z",
    fill: "#54449C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.78 144.04L382.48 246.29H382.18L409.47 144.04H409.78Z",
    fill: "#54459C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.087 144.04L382.787 246.29H382.477L409.777 144.04H410.087Z",
    fill: "#55459C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.399 144.04L383.099 246.29H382.789L410.089 144.04H410.399Z",
    fill: "#55459C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.704 144.04L383.404 246.29H383.094L410.394 144.04H410.704Z",
    fill: "#55469D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.016 144.04L383.716 246.29H383.406L410.706 144.04H411.016Z",
    fill: "#56469D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.319 144.04L384.019 246.29H383.719L411.019 144.04H411.319Z",
    fill: "#56469D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.626 144.04L384.326 246.29H384.016L411.316 144.04H411.626Z",
    fill: "#56479D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.938 144.04L384.638 246.29H384.328L411.628 144.04H411.938Z",
    fill: "#57479D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.251 144.04L384.951 246.29H384.641L411.941 144.04H412.251Z",
    fill: "#57489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.555 144.04L385.255 246.29H384.945L412.245 144.04H412.555Z",
    fill: "#57489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.868 144.04L385.568 246.29H385.258L412.558 144.04H412.868Z",
    fill: "#58489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.17 144.04L385.87 246.29H385.57L412.87 144.04H413.17Z",
    fill: "#58499E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.477 144.04L386.177 246.29H385.867L413.167 144.04H413.477Z",
    fill: "#58499E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.79 144.04L386.49 246.29H386.18L413.48 144.04H413.79Z",
    fill: "#594A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.094 144.04L386.794 246.29H386.484L413.784 144.04H414.094Z",
    fill: "#594A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.407 144.04L387.107 246.29H386.797L414.097 144.04H414.407Z",
    fill: "#5A4B9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.709 144.04L387.419 246.29H387.109L414.409 144.04H414.709Z",
    fill: "#5A4B9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.014 144.04L387.714 246.29H387.414L414.704 144.04H415.014Z",
    fill: "#5B4CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.329 144.04L388.029 246.29H387.719L415.019 144.04H415.329Z",
    fill: "#5B4CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.641 144.04L388.341 246.29H388.031L415.331 144.04H415.641Z",
    fill: "#5B4DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.946 144.04L388.646 246.29H388.336L415.636 144.04H415.946Z",
    fill: "#5C4DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.258 144.04L388.958 246.29H388.648L415.948 144.04H416.258Z",
    fill: "#5C4EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.561 144.04L389.261 246.29H388.961L416.261 144.04H416.561Z",
    fill: "#5D4EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.868 144.04L389.568 246.29H389.258L416.558 144.04H416.868Z",
    fill: "#5D4FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18 144.04L389.88 246.29H389.57L416.87 144.04H417.18Z",
    fill: "#5E4FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.485 144.04L390.185 246.29H389.875L417.175 144.04H417.485Z",
    fill: "#5E50A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.797 144.04L390.497 246.29H390.188L417.487 144.04H417.797Z",
    fill: "#5F50A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.11 144.04L390.81 246.29H390.5L417.8 144.04H418.11Z",
    fill: "#6051A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.405 144.04L391.105 246.29H390.805L418.105 144.04H418.405Z",
    fill: "#6052A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.719 144.04L391.419 246.29H391.109L418.409 144.04H418.719Z",
    fill: "#6152A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.024 144.04L391.724 246.29H391.414L418.714 144.04H419.024Z",
    fill: "#6153A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.337 144.04L392.037 246.29H391.727L419.027 144.04H419.337Z",
    fill: "#6254A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.649 144.04L392.349 246.29H392.039L419.339 144.04H419.649Z",
    fill: "#6254A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.944 144.04L392.654 246.29H392.344L419.644 144.04H419.944Z",
    fill: "#6355A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.256 144.04L392.956 246.29H392.656L419.946 144.04H420.256Z",
    fill: "#6456A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.571 144.04L393.271 246.29H392.961L420.261 144.04H420.571Z",
    fill: "#6456A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.876 144.04L393.576 246.29H393.266L420.566 144.04H420.876Z",
    fill: "#6557A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.188 144.04L393.888 246.29H393.578L420.878 144.04H421.188Z",
    fill: "#6658A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.501 144.04L394.201 246.29H393.891L421.191 144.04H421.501Z",
    fill: "#6659A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.795 144.04L394.495 246.29H394.195L421.495 144.04H421.795Z",
    fill: "#6759A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11 144.04L394.81 246.29H394.5L421.8 144.04H422.11Z",
    fill: "#685AA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.415 144.04L395.115 246.29H394.805L422.105 144.04H422.415Z",
    fill: "#685BA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.727 144.04L395.427 246.29H395.117L422.417 144.04H422.727Z",
    fill: "#695CA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.04 144.04L395.74 246.29H395.43L422.73 144.04H423.04Z",
    fill: "#6A5CA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.344 144.04L396.044 246.29H395.734L423.034 144.04H423.344Z",
    fill: "#6B5DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.647 144.04L396.347 246.29H396.047L423.347 144.04H423.647Z",
    fill: "#6B5EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.954 144.04L396.654 246.29H396.344L423.644 144.04H423.954Z",
    fill: "#6C5FAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.266 144.04L396.966 246.29H396.656L423.956 144.04H424.266Z",
    fill: "#6D60AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.579 144.04L397.279 246.29H396.969L424.269 144.04H424.579Z",
    fill: "#6E61AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.891 144.04L397.591 246.29H397.281L424.581 144.04H424.891Z",
    fill: "#6F61AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.186 144.04L397.886 246.29H397.586L424.886 144.04H425.186Z",
    fill: "#6F62AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.501 144.04L398.201 246.29H397.891L425.191 144.04H425.501Z",
    fill: "#7063AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.805 144.04L398.505 246.29H398.195L425.495 144.04H425.805Z",
    fill: "#7164AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.118 144.04L398.818 246.29H398.508L425.808 144.04H426.118Z",
    fill: "#7265AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43 144.04L399.13 246.29H398.82L426.12 144.04H426.43Z",
    fill: "#7366AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.735 144.04L399.435 246.29H399.125L426.425 144.04H426.735Z",
    fill: "#7467AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.038 144.04L399.737 246.29H399.438L426.737 144.04H427.038Z",
    fill: "#7568AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.344 144.04L400.044 246.29H399.734L427.034 144.04H427.344Z",
    fill: "#7669AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.657 144.04L400.357 246.29H400.047L427.347 144.04H427.657Z",
    fill: "#766AB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.969 144.04L400.669 246.29H400.359L427.659 144.04H427.969Z",
    fill: "#776BB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.274 144.04L400.974 246.29H400.664L427.964 144.04H428.274Z",
    fill: "#786CB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.587 144.04L401.287 246.29H400.977L428.277 144.04H428.587Z",
    fill: "#796DB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.889 144.04L401.589 246.29H401.289L428.589 144.04H428.889Z",
    fill: "#7A6EB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.196 144.04L401.896 246.29H401.586L428.886 144.04H429.196Z",
    fill: "#7B6FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.508 144.04L402.208 246.29H401.898L429.198 144.04H429.508Z",
    fill: "#7C70B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.821 144.04L402.521 246.29H402.211L429.511 144.04H429.821Z",
    fill: "#7D71B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.126 144.04L402.826 246.29H402.516L429.816 144.04H430.126Z",
    fill: "#7E73B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.428 144.04L403.128 246.29H402.828L430.128 144.04H430.428Z",
    fill: "#7F74B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.735 144.04L403.435 246.29H403.125L430.425 144.04H430.735Z",
    fill: "#8075B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.047 144.04L403.747 246.29H403.438L430.737 144.04H431.047Z",
    fill: "#8176B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.36 144.04L404.06 246.29H403.75L431.05 144.04H431.36Z",
    fill: "#8377B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.665 144.04L404.365 246.29H404.055L431.355 144.04H431.665Z",
    fill: "#8478B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.977 144.04L404.677 246.29H404.367L431.667 144.04H431.977Z",
    fill: "#857AB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.28 144.04L404.98 246.29H404.68L431.98 144.04H432.28Z",
    fill: "#867BB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.587 144.04L405.287 246.29H404.977L432.277 144.04H432.587Z",
    fill: "#877CB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.599 144.04L432.879 144.12L405.599 246.29H405.289L432.589 144.04H432.599Z",
    fill: "#887DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.874 144.12L433.164 144.19L405.904 246.29H405.594L432.874 144.12Z",
    fill: "#897FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.166 144.19L433.456 144.27L406.216 246.29H405.906L433.166 144.19Z",
    fill: "#8A80BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.459 144.271L433.739 144.351L406.529 246.29H406.219L433.459 144.271Z",
    fill: "#8C81BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.741 144.35L434.031 144.42L406.831 246.29H406.531L433.741 144.35Z",
    fill: "#8D82BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.028 144.42L434.318 144.5L407.138 246.29H406.828L434.028 144.42Z",
    fill: "#8E84BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.321 144.5L434.611 144.58L407.451 246.29H407.141L434.321 144.5Z",
    fill: "#8F85BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.605 144.58L434.885 144.66L407.755 246.29H407.445L434.605 144.58Z",
    fill: "#9186BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.888 144.66L435.178 144.73L408.068 246.29H407.758L434.888 144.66Z",
    fill: "#9288C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.18 144.73L435.31 144.76V145.42L408.37 246.29H408.07L435.18 144.73Z",
    fill: "#9389C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 146.58L408.677 246.29H408.367L435.307 145.42V146.58Z",
    fill: "#948BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 147.73L408.99 246.29H408.68L435.31 146.58V147.73Z",
    fill: "#968CC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.304 148.89L409.294 246.29H408.984L435.304 147.73V148.89Z",
    fill: "#978DC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 150.04L409.607 246.29H409.297L435.307 148.89V150.04Z",
    fill: "#988FC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.309 151.2L409.919 246.29H409.609L435.309 150.04V151.2Z",
    fill: "#9A90C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.304 152.35L410.214 246.29H409.914L435.304 151.2V152.35Z",
    fill: "#9B92C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.309 153.51L410.529 246.29H410.219L435.309 152.35V153.51Z",
    fill: "#9C93C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 154.66L410.841 246.29H410.531L435.311 153.51V154.66Z",
    fill: "#9E95C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.306 155.81L411.146 246.29H410.836L435.306 154.66V155.81Z",
    fill: "#9F96C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.308 156.97L411.458 246.29H411.148L435.308 155.81V156.97Z",
    fill: "#A198C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 158.12L411.771 246.29H411.461L435.311 156.97V158.12Z",
    fill: "#A299C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.306 159.28L412.066 246.29H411.766L435.306 158.12V159.28Z",
    fill: "#A39BCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 160.43L412.38 246.29H412.07L435.31 159.28V160.43Z",
    fill: "#A59DCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.305 161.59L412.685 246.29H412.375L435.305 160.43V161.59Z",
    fill: "#A69ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 162.74L412.997 246.29H412.688L435.307 161.59V162.74Z",
    fill: "#A8A0CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 163.9L413.31 246.29H413L435.31 162.74V163.9Z",
    fill: "#A9A2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.305 165.05L413.605 246.29H413.305L435.305 163.9V165.05Z",
    fill: "#ABA3CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.309 166.2L413.919 246.29H413.609L435.309 165.05V166.2Z",
    fill: "#ACA5CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.304 167.36L414.224 246.29H413.914L435.304 166.2V167.36Z",
    fill: "#AEA7D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 168.51L414.537 246.29H414.227L435.307 167.36V168.51Z",
    fill: "#AFA8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.309 169.67L414.849 246.29H414.539L435.309 168.51V169.67Z",
    fill: "#B1AAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.304 170.82L415.154 246.29H414.844L435.304 169.67V170.82Z",
    fill: "#B3ACD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.306 171.98L415.456 246.29H415.156L435.306 170.82V171.98Z",
    fill: "#B4ADD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 173.13L415.771 246.29H415.461L435.311 171.98V173.13Z",
    fill: "#B6AFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.306 174.29L416.076 246.29H415.766L435.306 173.13V174.29Z",
    fill: "#B7B1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.308 175.44L416.388 246.29H416.078L435.308 174.29V175.44Z",
    fill: "#B9B3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 176.59L416.701 246.29H416.391L435.311 175.44V176.59Z",
    fill: "#BBB5D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.305 177.75L417.005 246.29H416.695L435.305 176.59V177.75Z",
    fill: "#BCB6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.308 178.9L417.308 246.29H417.008L435.308 177.75V178.9Z",
    fill: "#BEB8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.305 180.06L417.615 246.29H417.305L435.305 178.9V180.06Z",
    fill: "#C0BADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 181.21L417.927 246.29H417.617L435.307 180.06V181.21Z",
    fill: "#C2BCDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 182.37L418.24 246.29H417.93L435.31 181.21V182.37Z",
    fill: "#C3BEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.304 183.52L418.544 246.29H418.234L435.304 182.37V183.52Z",
    fill: "#C5C0DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 184.68L418.847 246.29H418.547L435.307 183.521V184.68Z",
    fill: "#C7C2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.304 185.83L419.154 246.29H418.844L435.304 184.68V185.83Z",
    fill: "#C9C4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.306 186.98L419.466 246.29H419.156L435.306 185.83V186.98Z",
    fill: "#CAC6E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.309 188.14L419.779 246.29H419.469L435.309 186.98V188.14Z",
    fill: "#CCC8E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 189.29L420.091 246.29H419.781L435.311 188.14V189.29Z",
    fill: "#CECAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.306 190.45L420.396 246.29H420.086L435.306 189.29V190.45Z",
    fill: "#D0CCE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.308 191.6L420.698 246.29H420.398L435.308 190.45V191.6Z",
    fill: "#D2CEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.305 192.76L421.005 246.29H420.695L435.305 191.6V192.76Z",
    fill: "#D4D0E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.308 193.91L421.318 246.29H421.008L435.308 192.76V193.91Z",
    fill: "#D6D2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 195.07L421.63 246.29H421.32L435.31 193.91V195.07Z",
    fill: "#D8D4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.305 196.22L421.935 246.29H421.625L435.305 195.07V196.22Z",
    fill: "#D9D6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 197.37L422.247 246.29H421.938L435.307 196.22V197.37Z",
    fill: "#DBD8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 198.53L422.55 246.29H422.25L435.31 197.37V198.53Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 199.68L422.857 246.29H422.547L435.307 198.53V199.68Z",
    fill: "#DFDCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.309 200.84L423.169 246.29H422.859L435.309 199.68V200.84Z",
    fill: "#E1DFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.304 201.99L423.474 246.29H423.164L435.304 200.84V201.99Z",
    fill: "#E3E1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 203.15L423.787 246.29H423.477L435.307 201.99V203.15Z",
    fill: "#E5E3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.309 204.3L424.089 246.29H423.789L435.309 203.15V204.3Z",
    fill: "#E7E5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.306 205.46L424.396 246.29H424.086L435.306 204.3V205.46Z",
    fill: "#EAE8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.308 206.61L424.708 246.29H424.398L435.308 205.46V206.61Z",
    fill: "#ECEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 207.76L425.021 246.29H424.711L435.311 206.61V207.76Z",
    fill: "#EEECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.306 208.92L425.326 246.29H425.016L435.306 207.76V208.92Z",
    fill: "#F0EEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.308 210.07L425.638 246.29H425.328L435.308 208.92V210.07Z",
    fill: "#F2F1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 211.23L425.941 246.29H425.641L435.311 210.07V211.23Z",
    fill: "#F4F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 212.38L426.247 246.29H425.938L435.307 211.23V212.38Z",
    fill: "#F6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 213.54L426.56 246.29H426.25L435.31 212.38V213.54Z",
    fill: "#F8F8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.305 214.69L426.865 246.29H426.555L435.305 213.54V214.69Z",
    fill: "#FBFAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.307 215.85L427.177 246.29H426.867L435.307 214.69V215.85Z",
    fill: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 217L427.49 246.29H427.18L435.31 215.85V217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.484 246.29L435.304 217V246.29H427.484Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 117,
    width: 96,
    height: 128
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M403.552 147.04C401.292 134.17 392.622 123.59 380.882 119.49C360.782 112.47 344.402 128.88 343.612 129.7C332.812 140.88 329.972 158.26 336.462 173.72C333.172 170.43 328.102 164.97 324.472 159.2C319.472 151.26 317.652 142.21 312.842 143.24C306.502 144.6 308.162 162.54 309.292 168.92C310.652 176.55 320.512 192.85 325.982 201.46C325.442 216.02 326.682 227.22 328.432 232.53C329.042 234.39 330.182 237.9 333.422 240.61C333.422 240.61 334.932 241.88 336.952 242.79C344.282 246.08 361.442 244.47 362.942 244.33C362.062 229.66 361.842 191.1 388.182 161.08C393.122 155.45 398.372 150.84 403.552 147.05V147.04Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.5 165L342.64 246.07H306.5V165Z",
    fill: "#1C1548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 161.89L344.03 246.07H342.64L306.5 165V161.89Z",
    fill: "#1C1548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 158.77L345.42 246.07H344.03L306.5 161.89V158.77Z",
    fill: "#1D164A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 155.66L346.81 246.07H345.42L306.5 158.77V155.66Z",
    fill: "#1F174C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 152.54L348.2 246.07H346.81L306.5 155.66V152.54Z",
    fill: "#20184E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 149.43L349.59 246.07H348.2L306.5 152.54V149.43Z",
    fill: "#211950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 146.31L350.98 246.07H349.59L306.5 149.43V146.31Z",
    fill: "#231A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 143.189L352.37 246.069H350.98L306.5 146.309V143.189Z",
    fill: "#241B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 140.08L353.76 246.07H352.37L306.5 143.19V140.08Z",
    fill: "#251C56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 136.96L355.15 246.07H353.76L306.5 140.08V136.96Z",
    fill: "#261D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 135.6L307.15 135.31L356.54 246.07H355.15L306.5 136.96V135.6Z",
    fill: "#271E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.148 135.31L308.308 134.79L357.928 246.07H356.538L307.148 135.31Z",
    fill: "#291F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.312 134.79L309.473 134.27L359.312 246.07H357.932L308.312 134.79Z",
    fill: "#2A205E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.469 134.27L310.629 133.76L360.699 246.07H359.309L309.469 134.27Z",
    fill: "#2B2160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.633 133.759L311.783 133.239L361.983 245.819L361.433 246.069H360.703L310.633 133.759Z",
    fill: "#2C2261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.941 132.728L311.781 133.245L361.979 245.832L363.139 245.314L312.941 132.728Z",
    fill: "#2D2363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.105 132.21L312.945 132.728L363.143 245.314L364.303 244.797L314.105 132.21Z",
    fill: "#2E2465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.262 131.694L314.102 132.211L364.299 244.797L365.459 244.28L315.262 131.694Z",
    fill: "#2F2567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.426 131.175L315.266 131.692L365.463 244.279L366.623 243.762L316.426 131.175Z",
    fill: "#302668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.582 130.663L316.422 131.18L366.619 243.766L367.779 243.249L317.582 130.663Z",
    fill: "#31276A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.738 130.145L317.578 130.662L367.776 243.249L368.935 242.731L318.738 130.145Z",
    fill: "#32276B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.902 129.636L318.742 130.153L368.94 242.74L370.099 242.223L319.902 129.636Z",
    fill: "#33286D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.058 129.11L319.898 129.627L370.096 242.213L371.256 241.696L321.058 129.11Z",
    fill: "#34296F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.215 128.592L321.055 129.109L371.252 241.696L372.412 241.179L322.215 128.592Z",
    fill: "#352A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.379 128.083L322.219 128.601L372.416 241.187L373.576 240.67L323.379 128.083Z",
    fill: "#362B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.535 127.556L323.375 128.073L373.572 240.66L374.732 240.143L324.535 127.556Z",
    fill: "#372B73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.691 127.039L324.531 127.557L374.729 240.143L375.889 239.626L325.691 127.039Z",
    fill: "#382C74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.847 126.536L325.688 127.053L375.885 239.639L377.045 239.122L326.847 126.536Z",
    fill: "#392D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.004 126.018L326.844 126.535L377.041 239.122L378.201 238.604L328.004 126.018Z",
    fill: "#3A2D77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16 125.491L328 126.008L378.197 238.594L379.357 238.077L329.16 125.491Z",
    fill: "#3B2E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.324 124.983L329.164 125.5L379.361 238.086L380.521 237.569L330.324 124.983Z",
    fill: "#3B2F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.488 124.465L330.328 124.982L380.526 237.569L381.685 237.052L331.488 124.465Z",
    fill: "#3C307B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.644 123.938L331.484 124.455L381.682 237.042L382.842 236.524L332.644 123.938Z",
    fill: "#3D307C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.808 123.429L332.648 123.946L382.846 236.533L384.006 236.016L333.808 123.429Z",
    fill: "#3E317E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.965 122.913L333.805 123.43L384.002 236.016L385.162 235.499L334.965 122.913Z",
    fill: "#3F317F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.129 122.395L334.969 122.912L385.166 235.499L386.326 234.981L336.129 122.395Z",
    fill: "#3F3280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.277 121.881L336.117 122.398L386.315 234.985L387.474 234.468L337.277 121.881Z",
    fill: "#403381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.433 121.364L337.273 121.881L387.471 234.467L388.631 233.95L338.433 121.364Z",
    fill: "#413382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.59 120.846L338.43 121.363L388.627 233.95L389.787 233.433L339.59 120.846Z",
    fill: "#413483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.754 120.329L339.594 120.846L389.791 233.432L390.951 232.915L340.754 120.329Z",
    fill: "#423484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.91 119.811L340.75 120.328L390.947 232.915L392.107 232.397L341.91 119.811Z",
    fill: "#433585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.074 119.293L341.914 119.811L392.111 232.397L393.271 231.88L343.074 119.293Z",
    fill: "#433586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.246 118.786L343.086 119.303L393.283 231.889L394.443 231.372L344.246 118.786Z",
    fill: "#443687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.402 118.258L344.242 118.775L394.44 231.362L395.599 230.845L345.402 118.258Z",
    fill: "#453688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.558 117.741L345.398 118.258L395.596 230.844L396.756 230.327L346.558 117.741Z",
    fill: "#453789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.707 117.237L346.547 117.754L396.744 230.34L397.904 229.823L347.707 117.237Z",
    fill: "#46378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.871 116.709L347.711 117.227L397.908 229.813L399.068 229.296L348.871 116.709Z",
    fill: "#46388B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.027 116.192L348.867 116.709L399.065 229.295L400.224 228.778L350.027 116.192Z",
    fill: "#47388C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.191 115.684L350.031 116.201L400.229 228.788L401.389 228.27L351.191 115.684Z",
    fill: "#47398D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.347 115.166L351.188 115.684L401.385 228.27L402.545 227.753L352.347 115.166Z",
    fill: "#48398D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.344 115.15L353.504 114.64L403.554 226.88V227.29L402.544 227.74L352.344 115.15Z",
    fill: "#48398E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.5 114.64L354.66 114.12L403.55 223.76V226.88L353.5 114.64Z",
    fill: "#493A8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.656 114.12L355.816 113.6L403.546 220.64V223.76L354.656 114.12Z",
    fill: "#493A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.82 113.6L356.98 113.09L403.55 217.53V220.64L355.82 113.6Z",
    fill: "#4A3A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.977 113.089L358.137 112.569L403.547 214.409V217.529L356.977 113.089Z",
    fill: "#4A3B91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.141 112.57L358.361 112.47H359.481L403.551 211.3V214.41L358.141 112.57Z",
    fill: "#4A3B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.867 112.47L403.547 208.18V211.3L359.477 112.47H360.867Z",
    fill: "#4B3B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.257 112.47L403.547 205.07V208.18L360.867 112.47H362.257Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.648 112.47L403.548 201.95V205.07L362.258 112.47H363.648Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.038 112.47L403.548 198.83V201.95L363.648 112.47H365.038Z",
    fill: "#4C3C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.429 112.47L403.549 195.72V198.83L365.039 112.47H366.429Z",
    fill: "#4C3D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.82 112.47L403.55 192.6V195.72L366.43 112.47H367.82Z",
    fill: "#4C3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.21 112.47L403.55 189.49V192.6L367.82 112.47H369.21Z",
    fill: "#4D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.601 112.47L403.551 186.37V189.49L369.211 112.47H370.601Z",
    fill: "#4D3D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.992 112.47L403.552 183.25V186.37L370.602 112.47H371.992Z",
    fill: "#4D3D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.382 112.47L403.552 180.14V183.25L371.992 112.47H373.382Z",
    fill: "#4D3E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.773 112.47L403.553 177.02V180.14L373.383 112.47H374.773Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.153 112.47L403.553 173.91V177.02L374.773 112.47H376.153Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.538 112.47L403.548 170.79V173.91L376.148 112.47H377.538Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.929 112.47L403.549 167.68V170.79L377.539 112.47H378.929Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.32 112.47L403.55 164.56V167.68L378.93 112.47H380.32Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.71 112.47L403.55 161.44V164.56L380.32 112.47H381.71Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.101 112.47L403.551 158.33V161.44L381.711 112.47H383.101Z",
    fill: "#4F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.492 112.47L403.552 155.21V158.33L383.102 112.47H384.492Z",
    fill: "#4F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.882 112.47L403.552 152.1V155.21L384.492 112.47H385.882Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.273 112.47L403.553 148.98V152.1L385.883 112.47H387.273Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.663 112.47L403.553 145.87V148.98L387.273 112.47H388.663Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.046 112.47L403.546 142.75V145.87L388.656 112.47H390.046Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.437 112.47L403.547 139.63V142.75L390.047 112.47H391.437Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.827 112.47L403.547 136.52V139.63L391.438 112.47H392.827Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.218 112.47L403.548 133.4V136.52L392.828 112.47H394.218Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.599 112.47L403.549 130.29V133.4L394.219 112.47H395.599Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.552 130.29L395.602 112.47H403.552V130.29Z",
    fill: "#4F3F99"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M375.132 144.65C372.082 140.1 366.262 136.51 360.172 137.01C350.082 137.84 345.762 149.38 345.112 151.13C344.662 152.34 341.442 161.38 346.332 170.47C348.732 174.93 352.082 177.54 353.982 178.8C348.072 193.16 344.512 206.8 345.432 221.64C345.792 227.5 345.032 233.43 349.162 237.6C354.882 243.39 364.072 243.42 372.212 243.06C378.402 242.78 384.982 242.38 390.042 238.81C396.282 234.4 398.632 226.28 399.442 218.68C400.282 210.82 399.842 204.78 398.962 199.35C398.032 193.62 396.012 185.11 391.162 175.43C393.382 173.55 396.992 169.96 399.302 164.38C400.092 162.47 404.582 151.65 399.022 143.08C398.372 142.08 394.452 136.02 388.932 136.36C383.512 136.69 380.102 142.93 379.432 144.4C378.192 147.1 377.632 149.26 377.532 150.28C377.222 148.87 376.572 146.78 375.142 144.65H375.132Z",
    fill: "#F4F3F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 343,
    y: 136,
    width: 59,
    height: 108
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M375.132 144.65C372.082 140.1 366.262 136.51 360.172 137.01C350.082 137.84 345.762 149.38 345.112 151.13C344.662 152.34 341.442 161.38 346.332 170.47C348.732 174.93 352.082 177.54 353.982 178.8C348.072 193.16 344.512 206.8 345.432 221.64C345.792 227.5 345.032 233.43 349.162 237.6C354.882 243.39 364.072 243.42 372.212 243.06C378.402 242.78 384.982 242.38 390.042 238.81C396.282 234.4 398.632 226.28 399.442 218.68C400.282 210.82 399.842 204.78 398.962 199.35C398.032 193.62 396.012 185.11 391.162 175.43C393.382 173.55 396.992 169.96 399.302 164.38C400.092 162.47 404.582 151.65 399.022 143.08C398.372 142.08 394.452 136.02 388.932 136.36C383.512 136.69 380.102 142.93 379.432 144.4C378.192 147.1 377.632 149.26 377.532 150.28C377.222 148.87 376.572 146.78 375.142 144.65H375.132Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.003 250.74C392.356 250.74 407.233 234.175 407.233 213.74C407.233 193.306 392.356 176.74 374.003 176.74C355.651 176.74 340.773 193.306 340.773 213.74C340.773 234.175 355.651 250.74 374.003 250.74Z",
    fill: "url(#paint1_linear_1342_37795)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M393.896 153.395C394.311 149.451 392.083 145.984 388.919 145.651C385.756 145.318 382.854 148.245 382.439 152.189C382.024 156.132 384.252 159.599 387.416 159.932C390.58 160.265 393.481 157.338 393.896 153.395Z",
    fill: "#100D20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M370.723 153.395C370.945 149.436 368.549 146.082 365.373 145.905C362.197 145.727 359.442 148.793 359.221 152.752C359 156.711 361.395 160.065 364.571 160.242C367.748 160.42 370.502 157.354 370.723 153.395Z",
    fill: "#100D20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M362.758 153.267C363.583 153.198 364.183 152.308 364.098 151.279C364.012 150.25 363.274 149.471 362.448 149.54C361.622 149.608 361.022 150.498 361.108 151.528C361.193 152.557 361.932 153.336 362.758 153.267Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M367.431 157.508C367.777 157.479 368.029 157.103 367.993 156.668C367.957 156.234 367.646 155.904 367.3 155.933C366.953 155.962 366.701 156.338 366.737 156.773C366.773 157.207 367.084 157.537 367.431 157.508Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M385.914 152.631C386.74 152.563 387.339 151.673 387.254 150.643C387.168 149.614 386.43 148.836 385.604 148.904C384.779 148.973 384.179 149.863 384.264 150.892C384.35 151.921 385.088 152.7 385.914 152.631Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M390.587 156.872C390.934 156.843 391.185 156.467 391.149 156.033C391.113 155.598 390.803 155.269 390.456 155.297C390.109 155.326 389.857 155.702 389.894 156.137C389.93 156.572 390.24 156.901 390.587 156.872Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M376.477 159.18C375.667 159.7 371.827 162.99 372.807 164.73C373.327 165.65 374.907 165.63 377.757 165.59C380.257 165.56 381.507 165.54 381.957 164.77C382.937 163.07 379.047 159.7 378.417 159.23C377.957 158.89 377.577 158.86 377.487 158.86C377.007 158.84 376.647 159.07 376.487 159.17L376.477 159.18Z",
    fill: "#EDBF1C"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.71 164.13C375.54 162.63 375.87 159.95 377.71 159.12C377.82 159.07 377.94 159.05 378.07 159.03C377.77 158.88 377.54 158.87 377.47 158.86C376.99 158.84 376.63 159.07 376.47 159.17C375.66 159.69 371.82 162.98 372.8 164.72C373.32 165.64 374.9 165.62 377.75 165.58C378.22 165.58 378.65 165.57 379.04 165.56C378.09 165.39 377.24 165.04 376.71 164.12V164.13Z",
    fill: "#A84424"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M365.477 164.132C365.629 163.216 364.484 162.264 362.921 162.004C361.357 161.745 359.966 162.276 359.814 163.191C359.662 164.107 360.807 165.059 362.37 165.319C363.934 165.579 365.325 165.047 365.477 164.132Z",
    fill: "#CAA3CB"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.082 165.051C380.673 165.038 381.146 164.745 381.138 164.397C381.13 164.049 380.645 163.778 380.054 163.791C379.463 163.805 378.991 164.097 378.999 164.445C379.006 164.793 379.492 165.064 380.082 165.051Z",
    fill: "#F4F3F9"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M391.758 164.053C392.993 163.71 393.826 162.828 393.619 162.083C393.412 161.338 392.243 161.012 391.009 161.355C389.774 161.698 388.941 162.58 389.148 163.325C389.355 164.07 390.523 164.396 391.758 164.053Z",
    fill: "#CAA3CB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M354.119 179.15C354.289 178.48 354.269 177.901 354.229 177.521C354.129 177.851 353.969 178.29 353.699 178.79C353.559 179.05 351.969 181.871 349.759 181.821C349.439 181.821 349.189 181.751 349.049 181.711C349.179 181.821 349.299 181.941 349.429 182.051C349.539 182.141 349.649 182.201 349.749 182.241C350.939 182.711 352.499 181.03 352.619 180.9C351.579 181.81 351.199 182.671 351.059 183.321C350.859 184.261 351.039 185.351 350.339 185.861C350.189 185.971 350.039 186.021 349.939 186.051C350.079 186.221 350.249 186.291 350.359 186.241C350.379 186.231 350.409 186.211 350.439 186.171C350.379 186.271 350.329 186.361 350.269 186.461C350.179 186.621 350.269 186.761 350.389 186.811C350.369 186.881 350.339 186.951 350.309 187.021C350.309 187.041 350.289 187.051 350.289 187.071C350.279 187.101 350.059 187.721 350.009 187.851C349.679 188.841 349.289 193.061 346.989 194.741C346.739 194.921 346.299 195.201 345.619 195.381C345.939 195.621 346.209 195.691 346.409 195.711C347.389 195.781 348.479 194.67 349.019 192.9C348.849 193.28 348.569 193.941 348.259 194.771C347.439 197.021 347.259 198.32 346.419 198.54C346.279 198.58 346.049 198.601 345.739 198.491C345.959 198.981 346.479 199.191 346.859 199.031C347.249 198.871 347.329 198.371 347.329 198.351C347.219 199.291 347.079 200.051 346.969 200.601C346.639 202.251 346.419 203.301 345.729 204.441C345.409 204.971 345.079 205.361 344.859 205.601C345.659 204.991 345.999 204.9 346.119 205.01C346.709 205.49 343.009 210.211 344.149 211.471C344.279 211.611 344.439 211.681 344.569 211.711C344.329 211.381 344.329 210.941 344.569 210.631C344.779 210.351 345.129 210.211 345.489 210.281C345.499 210.721 345.489 212.231 344.399 213.321C344.139 213.581 343.859 213.771 343.609 213.911C344.099 213.871 344.599 213.83 345.089 213.79C345.209 214.16 345.579 215.421 344.939 216.641C344.769 216.961 344.569 217.21 344.379 217.4C344.529 217.42 344.689 217.431 344.839 217.451C344.949 217.46 345.049 217.471 345.159 217.48C345.229 217.91 345.299 218.78 344.909 219.76C344.679 220.35 344.359 220.771 344.119 221.051C344.919 221.301 345.329 221.171 345.559 221.001C346.829 220.041 345.889 215.061 345.989 214.581C346.019 214.401 346.049 214.22 346.079 214.04C346.079 214.04 346.079 214.02 346.079 214.01C346.079 213.99 346.079 213.971 346.079 213.941C346.089 213.821 346.009 213.731 345.899 213.711C346.049 212.991 346.169 212.261 346.269 211.531C346.269 211.511 346.269 211.491 346.269 211.461C346.299 211.231 345.999 211.151 345.849 211.281C346.049 210.561 346.209 209.831 346.309 209.081C346.309 209.041 346.309 209.001 346.309 208.961C346.429 208.691 346.549 208.421 346.649 208.141C346.739 207.901 346.409 207.741 346.249 207.881C346.599 207.021 346.859 206.131 346.999 205.221C347.239 204.561 347.489 203.911 347.729 203.251C347.829 202.971 347.419 202.831 347.269 203.061C347.229 203.121 347.189 203.181 347.149 203.241C347.149 203.051 347.149 202.861 347.129 202.661C347.129 202.551 347.049 202.471 346.959 202.441C346.959 202.371 346.939 202.311 346.899 202.271C346.909 202.191 346.919 202.11 346.939 202.04C346.959 202.02 346.979 201.991 346.989 201.951C347.689 199.461 348.389 196.961 349.089 194.471C349.639 193.081 350.089 191.64 350.429 190.18C350.479 189.95 350.259 189.831 350.089 189.891C350.429 189.071 350.779 188.261 351.119 187.441C351.169 187.311 351.059 187.171 350.949 187.131C350.889 187.111 350.829 187.13 350.779 187.15C350.899 186.79 351.019 186.431 351.139 186.071C351.469 185.601 351.809 185.141 352.139 184.671C352.299 184.451 352.009 184.231 351.799 184.331C352.049 183.951 352.279 183.561 352.489 183.161C352.859 182.831 353.189 182.461 353.479 182.051C353.609 181.871 353.439 181.691 353.269 181.691C353.259 181.651 353.239 181.621 353.209 181.59C353.189 181.57 353.179 181.561 353.159 181.551C353.189 181.501 353.229 181.441 353.259 181.391C353.329 181.281 353.279 181.111 353.169 181.051C353.139 181.031 353.109 181.021 353.079 181.021C353.359 180.711 353.849 180.08 354.089 179.15H354.119Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M399.538 201.67C399.538 201.67 399.538 201.61 399.528 201.6C399.318 201.16 399.348 200.64 399.208 200.18C398.988 199.43 398.688 197.4 398.458 196.01C398.238 194.71 397.948 192.95 397.448 190.9C396.688 187.77 396.508 188.36 396.278 186.75C396.038 185.11 395.538 183.51 395.058 181.93C395.038 181.86 395.008 181.78 394.958 181.73C394.828 181.61 394.588 181.71 394.518 181.87C394.448 182.04 394.478 182.23 394.518 182.4C394.428 181.87 394.008 177.65 393.448 177.69C393.338 177.69 393.258 177.8 393.198 177.9C393.058 178.12 392.918 178.33 392.788 178.55C392.948 178.3 392.788 175.05 392.518 175.07C392.548 175.07 392.648 174.63 392.478 174.54C392.398 174.5 392.278 174.56 392.098 174.68C391.548 175.04 391.268 175.22 391.138 175.45C390.888 175.87 391.128 176.04 390.898 176.43C390.578 177 389.818 177.12 389.828 177.15C389.838 177.18 390.278 177.08 390.798 176.82C391.188 176.62 391.478 176.4 391.658 176.23C391.528 177.11 391.268 178.25 390.668 179.47C390.418 179.99 390.138 180.45 389.868 180.84C390.258 180.53 390.718 180.09 391.178 179.51C391.718 178.82 392.048 178.16 392.268 177.65C392.378 178.09 392.478 178.67 392.458 179.34C392.418 180.69 391.938 181.72 391.618 182.27C392.198 181.38 392.778 180.49 393.358 179.6C393.358 179.77 393.478 179.88 393.608 179.87C393.318 182.31 393.638 184.3 394.198 185.89C394.218 185.95 394.238 186 394.258 186.05C394.218 185.87 394.068 185.18 394.468 184.54C394.598 184.33 394.758 184.18 394.898 184.08C395.528 189.31 396.118 191.39 396.588 192.19C396.718 192.42 397.378 193.46 397.298 194.8C397.288 194.97 397.268 195.11 397.248 195.2C397.348 194.83 397.448 194.46 397.558 194.08C398.408 197.17 398.938 199.47 399.008 200.07C399.068 200.62 399.008 201.1 399.008 201.1C398.968 201.36 398.908 201.56 398.868 201.68C399.038 201.38 399.118 201.32 399.158 201.33C399.208 201.34 399.188 201.44 399.278 201.54C399.368 201.64 399.518 201.69 399.548 201.65L399.538 201.67Z",
    fill: "#4F3F99"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M400.852 218.79C400.892 218.32 400.962 217.4 400.842 216.47C400.822 216.32 400.772 215.95 400.772 215.43C400.772 215.19 400.782 214.91 400.842 214.47C401.052 212.82 401.002 211.15 400.952 209.49C400.952 209.42 400.952 209.34 400.912 209.27C400.812 209.12 400.562 209.15 400.452 209.29C400.332 209.43 400.322 209.62 400.312 209.81C400.362 209.27 401.082 205.09 400.542 204.98C400.432 204.96 400.332 205.04 400.242 205.11C400.052 205.28 399.862 205.45 399.672 205.62C399.892 205.42 400.612 202.25 400.342 202.2C400.372 202.2 400.582 201.81 400.442 201.67C400.372 201.61 400.242 201.64 400.032 201.7C399.402 201.9 399.092 202 398.902 202.18C398.552 202.52 398.732 202.74 398.412 203.06C397.952 203.52 397.192 203.43 397.192 203.47C397.192 203.5 397.652 203.52 398.212 203.41C398.642 203.32 398.972 203.18 399.202 203.08C398.842 203.89 398.282 204.92 397.382 205.94C397.002 206.38 396.612 206.74 396.242 207.05C396.702 206.85 397.262 206.56 397.852 206.12C398.552 205.6 399.052 205.05 399.402 204.61C399.392 205.06 399.332 205.64 399.132 206.29C398.732 207.58 397.992 208.44 397.542 208.89C398.342 208.19 399.132 207.49 399.932 206.78C399.882 206.94 399.972 207.08 400.102 207.11C399.172 209.39 398.952 211.39 399.062 213.07C399.062 213.13 399.062 213.19 399.072 213.24C399.072 213.05 399.122 212.35 399.672 211.84C399.862 211.67 400.052 211.57 400.212 211.51C399.422 216.72 399.432 218.88 399.672 219.78C399.742 220.04 400.092 221.22 399.652 222.49C399.622 222.58 399.482 222.86 399.502 222.86C399.532 222.87 399.882 222.3 400.092 221.87C400.692 220.68 400.792 219.56 400.862 218.76L400.852 218.79Z",
    fill: "#4F3F99"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M404.318 149.98C403.148 145.59 400.028 136.77 391.788 131.19C375.698 120.3 352.628 130.32 345.668 140.66C343.888 143.3 342.648 146.44 342.648 146.44C340.448 151.98 339.888 157.96 340.838 163.74C337.308 154.13 338.128 143.24 344.008 134.33C352.398 121.62 374.958 115.82 390.198 126.17C401.378 133.76 403.808 146.77 404.308 149.97L404.318 149.98Z",
    fill: "#EDBF1C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M390.198 124.79C376.388 115.17 353.848 118.04 344.008 132.95C338.128 141.85 337.308 152.75 340.838 162.36C340.628 160.37 340.508 157.7 340.868 154.58C340.868 154.58 341.248 151.33 342.238 148.13C345.618 137.29 352.938 130.74 352.938 130.74C360.338 123.24 375.868 119.24 387.938 125.75C394.168 129.11 397.798 134.35 398.898 135.99C400.778 138.77 401.918 141.38 402.618 143.29C401.568 139.51 398.528 130.61 390.188 124.8L390.198 124.79Z",
    fill: "#E9AB21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M342.918 138.8C344.958 133.63 348.148 128.62 352.298 124.74C349.058 126.87 346.218 129.6 344.008 132.94C338.128 141.84 337.308 152.74 340.838 162.35C340.628 160.36 340.508 157.69 340.868 154.57C340.868 154.57 340.998 153.42 341.318 151.81C340.918 147.46 341.168 143.05 342.918 138.8Z",
    fill: "#FFCA65"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M399.623 153.76C399.933 162.19 403.523 165.18 406.063 162.49C407.713 160.74 408.643 156.77 408.593 153.06C408.543 149.28 407.473 145.2 405.693 143.56C402.873 140.97 399.293 144.92 399.623 153.76Z",
    fill: "#E9AB21"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M401.602 153.61C401.832 161.01 404.442 164.22 406.452 162.09C407.842 160.62 408.652 156.77 408.602 153.06C408.552 149.28 407.612 145.32 406.112 143.94C403.902 141.91 401.362 145.89 401.602 153.61Z",
    fill: "#EDBF1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 405,
    y: 144,
    width: 4,
    height: 19
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M406.726 144.68C407.006 145.19 407.346 145.9 407.656 146.78C407.846 147.32 408.046 148.01 408.236 149.11C408.656 151.51 408.616 153.53 408.606 153.96C408.606 153.96 408.526 157.5 407.566 160.12C407.406 160.56 407.246 160.85 407.096 161.12C406.516 162.16 406.056 162.43 405.916 162.51C405.686 162.64 405.466 162.7 405.336 162.73C405.726 162.02 406.206 161.04 406.626 159.82C406.806 159.28 407.436 157.37 407.626 154.7C407.766 152.63 407.526 150.73 407.046 146.92C406.926 145.98 406.816 145.2 406.736 144.67L406.726 144.68Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.336 162.739L408.646 152.529V162.739H408.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.32 162.74L408.65 152.1V152.53L408.34 162.74H408.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.305 162.74L408.645 151.67V152.1L408.315 162.74H408.305Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.297 162.739L408.647 151.239V151.669L408.307 162.739H408.297Z",
    fill: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.281 162.74L408.651 150.81V151.24L408.301 162.74H408.281Z",
    fill: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.266 162.74L408.646 150.39V150.81L408.276 162.74H408.266Z",
    fill: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.258 162.74L408.648 149.96V150.39L408.268 162.74H408.258Z",
    fill: "#FFFEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.234 162.739L408.644 149.529V149.959L408.254 162.739H408.234Z",
    fill: "#FFFDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.227 162.74L408.647 149.1V149.53L408.237 162.74H408.227Z",
    fill: "#FEFDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.219 162.74L408.649 148.67V149.1L408.229 162.74H408.219Z",
    fill: "#FEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.195 162.739L408.645 148.239V148.669L408.215 162.739H408.195Z",
    fill: "#FEFCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.188 162.739L408.648 147.819V148.239L408.198 162.739H408.188Z",
    fill: "#FEFCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.18 162.74L408.65 147.39V147.82L408.19 162.74H408.18Z",
    fill: "#FEFCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.156 162.74L408.646 146.96V147.39L408.176 162.74H408.156Z",
    fill: "#FEFCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.148 162.739L408.648 146.529V146.959L408.158 162.739H408.148Z",
    fill: "#FEFBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.141 162.74L408.651 146.1V146.53L408.151 162.74H408.141Z",
    fill: "#FEFBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.117 162.74L408.647 145.67V146.1L408.137 162.74H408.117Z",
    fill: "#FEFBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.109 162.739L408.649 145.239V145.669L408.119 162.739H408.109Z",
    fill: "#FEFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.102 162.739L408.652 144.819V145.239L408.112 162.739H408.102Z",
    fill: "#FEFAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.078 162.74L408.638 144.68H408.648V144.82L408.098 162.74H408.078Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.07 162.74L408.63 144.68H408.64L408.08 162.74H408.07Z",
    fill: "#FDFAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.055 162.74L408.615 144.68H408.625L408.065 162.74H408.055Z",
    fill: "#FDF9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.039 162.74L408.599 144.68H408.619L408.059 162.74H408.039Z",
    fill: "#FDF9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.031 162.74L408.591 144.68H408.601L408.041 162.74H408.031Z",
    fill: "#FDF9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.016 162.74L408.576 144.68H408.586L408.026 162.74H408.016Z",
    fill: "#FDF8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 162.74L408.56 144.68H408.58L408.02 162.74H408Z",
    fill: "#FDF8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.984 162.74L408.544 144.68H408.554L407.994 162.74H407.984Z",
    fill: "#FDF8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.977 162.74L408.537 144.68H408.547L407.987 162.74H407.977Z",
    fill: "#FDF8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.969 162.74L408.519 144.68H408.539L407.979 162.74H407.969Z",
    fill: "#FDF7E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.945 162.74L408.505 144.68H408.515L407.965 162.74H407.945Z",
    fill: "#FDF7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.938 162.74L408.497 144.68H408.508L407.948 162.74H407.938Z",
    fill: "#FDF7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.93 162.74L408.48 144.68H408.5L407.94 162.74H407.93Z",
    fill: "#FDF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.906 162.74L408.466 144.68H408.476L407.926 162.74H407.906Z",
    fill: "#FDF6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.898 162.74L408.458 144.68H408.468L407.908 162.74H407.898Z",
    fill: "#FCF6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.891 162.74L408.441 144.68H408.461L407.901 162.74H407.891Z",
    fill: "#FCF6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.867 162.74L408.427 144.68H408.437L407.887 162.74H407.867Z",
    fill: "#FCF5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.859 162.74L408.419 144.68H408.429L407.869 162.74H407.859Z",
    fill: "#FCF5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.852 162.74L408.402 144.68H408.422L407.862 162.74H407.852Z",
    fill: "#FCF5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.828 162.74L408.388 144.68H408.398L407.848 162.74H407.828Z",
    fill: "#FCF5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.82 162.74L408.38 144.68H408.39L407.83 162.74H407.82Z",
    fill: "#FCF4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.805 162.74L408.355 144.68H408.375L407.815 162.74H407.805Z",
    fill: "#FCF4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.789 162.74L408.349 144.68H408.359L407.809 162.74H407.789Z",
    fill: "#FCF4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.781 162.74L408.341 144.68H408.351L407.791 162.74H407.781Z",
    fill: "#FCF3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.766 162.74L408.316 144.68H408.336L407.776 162.74H407.766Z",
    fill: "#FCF3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.75 162.74L408.31 144.68H408.32L407.77 162.74H407.75Z",
    fill: "#FCF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.734 162.74L408.294 144.68H408.304L407.744 162.74H407.734Z",
    fill: "#FBF3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.727 162.74L408.277 144.68H408.297L407.737 162.74H407.727Z",
    fill: "#FBF2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.711 162.74L408.271 144.68H408.281L407.731 162.74H407.711Z",
    fill: "#FBF2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.695 162.74L408.255 144.68H408.265L407.705 162.74H407.695Z",
    fill: "#FBF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.688 162.74L408.247 144.68H408.258L407.698 162.74H407.688Z",
    fill: "#FBF1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.672 162.74L408.232 144.68H408.252L407.692 162.74H407.672Z",
    fill: "#FBF1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.656 162.74L408.216 144.68H408.226L407.666 162.74H407.656Z",
    fill: "#FBF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.648 162.74L408.208 144.68H408.218L407.658 162.74H407.648Z",
    fill: "#FBF1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.625 162.74L408.185 144.68H408.205L407.645 162.74H407.625Z",
    fill: "#FBF0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.617 162.74L408.177 144.68H408.187L407.627 162.74H407.617Z",
    fill: "#FBF0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.609 162.74L408.169 144.68H408.179L407.619 162.74H407.609Z",
    fill: "#FBF0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.586 162.74L408.146 144.68H408.166L407.606 162.74H407.586Z",
    fill: "#FBEFC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.578 162.74L408.138 144.68H408.148L407.588 162.74H407.578Z",
    fill: "#FBEFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57 162.74L408.13 144.68H408.14L407.58 162.74H407.57Z",
    fill: "#FAEFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.547 162.74L408.107 144.68H408.127L407.567 162.74H407.547Z",
    fill: "#FAEFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.539 162.74L408.099 144.68H408.109L407.549 162.74H407.539Z",
    fill: "#FAEEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.531 162.74L408.091 144.68H408.101L407.541 162.74H407.531Z",
    fill: "#FAEEC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.516 162.74L408.066 144.68H408.086L407.526 162.74H407.516Z",
    fill: "#FAEEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.5 162.74L408.06 144.68H408.07L407.52 162.74H407.5Z",
    fill: "#FAEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.484 162.74L408.044 144.68H408.054L407.494 162.74H407.484Z",
    fill: "#FAEDC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.477 162.74L408.027 144.68H408.047L407.487 162.74H407.477Z",
    fill: "#FAEDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.461 162.74L408.021 144.68H408.031L407.481 162.74H407.461Z",
    fill: "#FAEDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.445 162.74L408.005 144.68H408.015L407.455 162.74H407.445Z",
    fill: "#FAECBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.438 162.74L407.988 144.68H408.008L407.448 162.74H407.438Z",
    fill: "#FAECBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.422 162.74L407.982 144.68H407.992L407.442 162.74H407.422Z",
    fill: "#FAECBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.406 162.74L407.966 144.68H407.976L407.416 162.74H407.406Z",
    fill: "#FAEBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.398 162.74L407.948 144.68H407.968L407.408 162.74H407.398Z",
    fill: "#F9EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.375 162.74L407.935 144.68H407.945L407.395 162.74H407.375Z",
    fill: "#F9EBB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.367 162.74L407.927 144.68H407.937L407.377 162.74H407.367Z",
    fill: "#F9EBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.359 162.74L407.909 144.68H407.929L407.369 162.74H407.359Z",
    fill: "#F9EAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.336 162.74L407.896 144.68H407.906L407.356 162.74H407.336Z",
    fill: "#F9EAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.328 162.74L407.888 144.68H407.898L407.338 162.74H407.328Z",
    fill: "#F9EAB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.32 162.74L407.87 144.68H407.89L407.33 162.74H407.32Z",
    fill: "#F9E9B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.297 162.74L407.857 144.68H407.867L407.317 162.74H407.297Z",
    fill: "#F9E9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.289 162.74L407.849 144.68H407.859L407.299 162.74H407.289Z",
    fill: "#F9E9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.281 162.74L407.831 144.68H407.851L407.291 162.74H407.281Z",
    fill: "#F9E9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.258 162.74L407.818 144.68H407.828L407.278 162.74H407.258Z",
    fill: "#F9E8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.25 162.74L407.81 144.68H407.82L407.26 162.74H407.25Z",
    fill: "#F9E8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.234 162.74L407.784 144.68H407.804L407.244 162.74H407.234Z",
    fill: "#F8E8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.219 162.74L407.779 144.68H407.789L407.239 162.74H407.219Z",
    fill: "#F8E7AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.211 162.74L407.771 144.68H407.781L407.221 162.74H407.211Z",
    fill: "#F8E7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.195 162.74L407.755 144.68H407.765L407.205 162.74H407.195Z",
    fill: "#F8E7AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.18 162.74L407.74 144.68H407.76L407.2 162.74H407.18Z",
    fill: "#F8E7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.172 162.74L407.732 144.68H407.742L407.182 162.74H407.172Z",
    fill: "#F8E6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.156 162.74L407.716 144.68H407.726L407.166 162.74H407.156Z",
    fill: "#F8E6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.141 162.74L407.701 144.68H407.721L407.161 162.74H407.141Z",
    fill: "#F8E6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.125 162.74L407.685 144.68H407.695L407.135 162.74H407.125Z",
    fill: "#F8E6A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.117 162.74L407.677 144.68H407.687L407.127 162.74H407.117Z",
    fill: "#F8E5A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.102 162.74L407.662 144.68H407.682L407.122 162.74H407.102Z",
    fill: "#F8E5A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.086 162.74L407.646 144.68H407.656L407.096 162.74H407.086Z",
    fill: "#F8E5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.078 162.74L407.638 144.68H407.648L407.088 162.74H407.078Z",
    fill: "#F8E4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.07 162.74L407.62 144.68H407.64L407.08 162.74H407.07Z",
    fill: "#F7E4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.047 162.74L407.607 144.68H407.617L407.067 162.74H407.047Z",
    fill: "#F7E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.039 162.74L407.599 144.68H407.609L407.049 162.74H407.039Z",
    fill: "#F7E49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.031 162.74L407.581 144.68H407.601L407.041 162.74H407.031Z",
    fill: "#F7E39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.008 162.74L407.568 144.68H407.578L407.028 162.74H407.008Z",
    fill: "#F7E39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 162.74L407.56 144.68H407.57L407.01 162.74H407Z",
    fill: "#F7E39B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.984 162.74L407.534 144.68H407.554L406.994 162.74H406.984Z",
    fill: "#F7E29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.969 162.74L407.529 144.68H407.539L406.989 162.74H406.969Z",
    fill: "#F7E299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.961 162.74L407.521 144.68H407.531L406.971 162.74H406.961Z",
    fill: "#F7E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.945 162.74L407.495 144.68H407.515L406.955 162.74H406.945Z",
    fill: "#F7E297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.93 162.74L407.49 144.68H407.5L406.95 162.74H406.93Z",
    fill: "#F7E196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.922 162.74L407.482 144.68H407.492L406.932 162.74H406.922Z",
    fill: "#F7E195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.906 162.74L407.456 144.68H407.476L406.916 162.74H406.906Z",
    fill: "#F6E194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.891 162.74L407.451 144.68H407.461L406.911 162.74H406.891Z",
    fill: "#F6E093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.875 162.74L407.435 144.68H407.445L406.885 162.74H406.875Z",
    fill: "#F6E092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.867 162.74L407.417 144.68H407.437L406.877 162.74H406.867Z",
    fill: "#F6E091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.852 162.74L407.412 144.68H407.422L406.872 162.74H406.852Z",
    fill: "#F6E090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.836 162.74L407.396 144.68H407.406L406.846 162.74H406.836Z",
    fill: "#F6DF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.828 162.74L407.378 144.68H407.398L406.838 162.74H406.828Z",
    fill: "#F6DF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.805 162.74L407.365 144.68H407.375L406.825 162.74H406.805Z",
    fill: "#F6DF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.797 162.74L407.357 144.68H407.367L406.807 162.74H406.797Z",
    fill: "#F6DE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.789 162.74L407.339 144.68H407.359L406.799 162.74H406.789Z",
    fill: "#F6DE8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.766 162.74L407.326 144.68H407.336L406.786 162.74H406.766Z",
    fill: "#F6DE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.758 162.74L407.318 144.68H407.328L406.768 162.74H406.758Z",
    fill: "#F6DE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.75 162.74L407.31 144.68H407.32L406.76 162.74H406.75Z",
    fill: "#F6DD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.727 162.74L407.287 144.68H407.307L406.747 162.74H406.727Z",
    fill: "#F5DD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.719 162.74L407.279 144.68H407.289L406.729 162.74H406.719Z",
    fill: "#F5DD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.711 162.74L407.271 144.68H407.281L406.721 162.74H406.711Z",
    fill: "#F5DC84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.688 162.74L407.247 144.68H407.268L406.708 162.74H406.688Z",
    fill: "#F5DC83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.68 162.74L407.24 144.68H407.25L406.69 162.74H406.68Z",
    fill: "#F5DC82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.672 162.74L407.232 144.68H407.242L406.682 162.74H406.672Z",
    fill: "#F5DC81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.648 162.74L407.208 144.68H407.228L406.668 162.74H406.648Z",
    fill: "#F5DB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.641 162.74L407.201 144.68H407.211L406.651 162.74H406.641Z",
    fill: "#F5DB7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.625 162.74L407.185 144.68H407.195L406.635 162.74H406.625Z",
    fill: "#F5DB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.617 162.74L407.167 144.68H407.187L406.627 162.74H406.617Z",
    fill: "#F5DA7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.602 162.74L407.162 144.68H407.172L406.622 162.74H406.602Z",
    fill: "#F5DA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.586 162.74L407.146 144.68H407.156L406.596 162.74H406.586Z",
    fill: "#F5DA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.578 162.74L407.128 144.68H407.148L406.588 162.74H406.578Z",
    fill: "#F4DA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.555 162.74L407.115 144.68H407.125L406.575 162.74H406.555Z",
    fill: "#F4D979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.547 162.74L407.107 144.68H407.117L406.557 162.74H406.547Z",
    fill: "#F4D978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.539 162.74L407.089 144.68H407.109L406.549 162.74H406.539Z",
    fill: "#F4D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.516 162.74L407.076 144.68H407.086L406.536 162.74H406.516Z",
    fill: "#F4D876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.508 162.74L407.068 144.68H407.078L406.518 162.74H406.508Z",
    fill: "#F4D875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.5 162.74L407.05 144.68H407.07L406.51 162.74H406.5Z",
    fill: "#F4D874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.477 162.74L407.037 144.68H407.047L406.497 162.74H406.477Z",
    fill: "#F4D873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.469 162.74L407.029 144.68H407.039L406.479 162.74H406.469Z",
    fill: "#F4D772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.461 162.74L407.011 144.68H407.031L406.471 162.74H406.461Z",
    fill: "#F4D771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.438 162.74L406.997 144.68H407.008L406.458 162.74H406.438Z",
    fill: "#F4D770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.43 162.74L406.99 144.68H407L406.44 162.74H406.43Z",
    fill: "#F4D76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.422 162.74L406.972 144.68H406.992L406.432 162.74H406.422Z",
    fill: "#F4D66E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.398 162.74L406.958 144.68H406.968L406.418 162.74H406.398Z",
    fill: "#F3D66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.391 162.74L406.951 144.68H406.961L406.401 162.74H406.391Z",
    fill: "#F3D66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.375 162.74L406.925 144.68H406.945L406.385 162.74H406.375Z",
    fill: "#F3D56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.359 162.74L406.919 144.68H406.929L406.379 162.74H406.359Z",
    fill: "#F3D56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.352 162.74L406.912 144.68H406.922L406.362 162.74H406.352Z",
    fill: "#F3D569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.336 162.74L406.886 144.68H406.906L406.346 162.74H406.336Z",
    fill: "#F3D568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.32 162.74L406.88 144.68H406.89L406.34 162.74H406.32Z",
    fill: "#F3D467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.305 162.74L406.865 144.68H406.875L406.315 162.74H406.305Z",
    fill: "#F3D466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.297 162.74L406.857 144.68H406.867L406.307 162.74H406.297Z",
    fill: "#F3D465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.281 162.74L406.841 144.68H406.861L406.301 162.74H406.281Z",
    fill: "#F3D364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.266 162.74L406.826 144.68H406.836L406.276 162.74H406.266Z",
    fill: "#F3D363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.258 162.74L406.818 144.68H406.828L406.268 162.74H406.258Z",
    fill: "#F3D362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.234 162.74L406.794 144.68H406.814L406.254 162.74H406.234Z",
    fill: "#F2D361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.227 162.74L406.787 144.68H406.797L406.237 162.74H406.227Z",
    fill: "#F2D260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.219 162.74L406.779 144.68H406.789L406.229 162.74H406.219Z",
    fill: "#F2D25F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.195 162.74L406.755 144.68H406.775L406.215 162.74H406.195Z",
    fill: "#F2D25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.188 162.74L406.747 144.68H406.758L406.198 162.74H406.188Z",
    fill: "#F2D15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.18 162.74L406.74 144.68H406.75L406.19 162.74H406.18Z",
    fill: "#F2D15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.172 162.74L406.722 144.68H406.742L406.182 162.74H406.172Z",
    fill: "#F2D15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.148 162.74L406.708 144.68H406.718L406.168 162.74H406.148Z",
    fill: "#F2D15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.141 162.74L406.701 144.68H406.711L406.151 162.74H406.141Z",
    fill: "#F2D059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.125 162.74L406.675 144.68H406.695L406.135 162.74H406.125Z",
    fill: "#F2D058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.109 162.74L406.669 144.68H406.679L406.129 162.74H406.109Z",
    fill: "#F2D057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.102 162.74L406.662 144.68H406.672L406.112 162.74H406.102Z",
    fill: "#F2CF56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.086 162.74L406.636 144.68H406.656L406.096 162.74H406.086Z",
    fill: "#F2CF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.07 162.74L406.63 144.68H406.64L406.09 162.74H406.07Z",
    fill: "#F1CF54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.055 162.74L406.615 144.68H406.625L406.065 162.74H406.055Z",
    fill: "#F1CF53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.047 162.74L406.597 144.68H406.617L406.057 162.74H406.047Z",
    fill: "#F1CE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.031 162.74L406.591 144.68H406.601L406.051 162.74H406.031Z",
    fill: "#F1CE51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.016 162.74L406.576 144.68H406.586L406.026 162.74H406.016Z",
    fill: "#F1CE50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.008 162.74L406.558 144.68H406.578L406.018 162.74H406.008Z",
    fill: "#F1CD4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.984 162.74L406.544 144.68H406.554L406.004 162.74H405.984Z",
    fill: "#F1CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.977 162.74L406.537 144.68H406.547L405.987 162.74H405.977Z",
    fill: "#F1CD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.969 162.74L406.519 144.68H406.539L405.979 162.74H405.969Z",
    fill: "#F1CD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.945 162.74L406.505 144.68H406.515L405.965 162.74H405.945Z",
    fill: "#F1CC4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.938 162.74L406.497 144.68H406.508L405.948 162.74H405.938Z",
    fill: "#F1CC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.93 162.74L406.48 144.68H406.5L405.94 162.74H405.93Z",
    fill: "#F1CC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.906 162.74L406.466 144.68H406.476L405.926 162.74H405.906Z",
    fill: "#F1CB48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.898 162.74L406.458 144.68H406.468L405.908 162.74H405.898Z",
    fill: "#F0CB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.891 162.74L406.441 144.68H406.461L405.901 162.74H405.891Z",
    fill: "#F0CB46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.867 162.74L406.427 144.68H406.437L405.887 162.74H405.867Z",
    fill: "#F0CB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.859 162.74L406.419 144.68H406.429L405.869 162.74H405.859Z",
    fill: "#F0CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.852 162.74L406.412 144.68H406.422L405.862 162.74H405.852Z",
    fill: "#F0CA43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.828 162.74L406.388 144.68H406.408L405.848 162.74H405.828Z",
    fill: "#F0CA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.82 162.74L406.38 144.68H406.39L405.83 162.74H405.82Z",
    fill: "#F0C941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.805 162.74L406.365 144.68H406.375L405.815 162.74H405.805Z",
    fill: "#F0C940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.789 162.74L406.349 144.68H406.369L405.809 162.74H405.789Z",
    fill: "#F0C93F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.781 162.74L406.341 144.68H406.351L405.791 162.74H405.781Z",
    fill: "#F0C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.766 162.74L406.326 144.68H406.336L405.776 162.74H405.766Z",
    fill: "#F0C83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.75 162.74L406.31 144.68H406.33L405.77 162.74H405.75Z",
    fill: "#F0C83C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.734 162.74L406.294 144.68H406.304L405.744 162.74H405.734Z",
    fill: "#EFC83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.727 162.74L406.287 144.68H406.297L405.737 162.74H405.727Z",
    fill: "#EFC73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.719 162.74L406.269 144.68H406.289L405.729 162.74H405.719Z",
    fill: "#EFC739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.695 162.74L406.255 144.68H406.265L405.715 162.74H405.695Z",
    fill: "#EFC738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.688 162.74L406.247 144.68H406.258L405.698 162.74H405.688Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.68 162.74L406.23 144.68H406.25L405.69 162.74H405.68Z",
    fill: "#EFC636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.656 162.74L406.216 144.68H406.226L405.676 162.74H405.656Z",
    fill: "#EFC635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.648 162.74L406.208 144.68H406.218L405.658 162.74H405.648Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.641 162.74L406.191 144.68H406.211L405.651 162.74H405.641Z",
    fill: "#EFC633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.617 162.74L406.177 144.68H406.187L405.637 162.74H405.617Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.609 162.74L406.169 144.68H406.179L405.619 162.74H405.609Z",
    fill: "#EFC531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.602 162.74L406.152 144.68H406.172L405.612 162.74H405.602Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.578 162.74L406.138 144.68H406.148L405.598 162.74H405.578Z",
    fill: "#EFC42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.57 162.74L406.13 144.68H406.14L405.58 162.74H405.57Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.555 162.74L406.105 144.68H406.125L405.565 162.74H405.555Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.539 162.74L406.099 144.68H406.109L405.559 162.74H405.539Z",
    fill: "#EEC42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.531 162.74L406.091 144.68H406.101L405.541 162.74H405.531Z",
    fill: "#EEC32B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.516 162.74L406.066 144.68H406.086L405.526 162.74H405.516Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5 162.74L406.06 144.68H406.07L405.52 162.74H405.5Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.484 162.74L406.044 144.68H406.054L405.494 162.74H405.484Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.477 162.74L406.027 144.68H406.047L405.487 162.74H405.477Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.461 162.74L406.021 144.68H406.031L405.481 162.74H405.461Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.445 162.74L406.005 144.68H406.015L405.455 162.74H405.445Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.438 162.74L405.988 144.68H406.008L405.448 162.74H405.438Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.422 162.74L405.982 144.68H405.992L405.442 162.74H405.422Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.406 162.74L405.966 144.68H405.976L405.416 162.74H405.406Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.398 162.74L405.958 144.68H405.968L405.408 162.74H405.398Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.375 162.74L405.935 144.68H405.955L405.395 162.74H405.375Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.367 162.74L405.927 144.68H405.937L405.377 162.74H405.367Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.359 162.74L405.919 144.68H405.929L405.369 162.74H405.359Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.336 162.74L405.896 144.68H405.916L405.356 162.74H405.336Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.328 162.74L405.888 144.68H405.898L405.338 162.74H405.328Z",
    fill: "#EDBF1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.888 144.68L405.328 162.74V144.68H405.888Z",
    fill: "#EDBF1C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 373,
    y: 122,
    width: 13,
    height: 24
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M381.981 133.72C381.411 133.27 381.541 132.26 381.801 130.63C382.281 127.63 382.761 125.33 382.671 125.31C382.611 125.29 382.351 126.21 381.611 127.99C381.541 128.15 381.461 128.34 381.421 128.44C380.661 130.17 377.971 132.21 376.911 131.56C376.101 131.06 376.461 129.09 376.681 127.87C377.251 124.76 378.741 123.1 378.561 122.96C378.201 122.69 371.831 128.88 373.221 131.26C373.611 131.92 374.481 132.11 375.001 132.18C375.151 132.56 375.321 132.94 375.531 133.32C375.751 133.7 376.241 133.9 376.661 133.78C378.351 133.29 379.801 132.33 380.891 131.05C380.351 132.85 379.271 134.5 377.781 135.72C376.871 136.46 377.961 137.65 378.891 137.33C377.361 139.35 376.281 141.63 376.461 144.3C376.531 145.34 377.861 145.54 378.321 144.89C378.471 144.68 378.481 144.39 378.471 144.3C378.351 142.62 382.641 139.34 384.271 136.01C385.731 133.02 384.991 130.08 384.901 130.07C384.811 130.07 384.851 133.17 383.341 133.82C382.911 134 382.331 134.01 381.961 133.71L381.981 133.72Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.751 123.189L384.711 122.689H385.351L385.751 122.879V123.189Z",
    fill: "#231B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 123.489L384.078 122.689H384.708L385.748 123.189V123.489Z",
    fill: "#241C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.747 123.789L383.438 122.689H384.077L385.747 123.489V123.789Z",
    fill: "#251C56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.745 124.099L382.805 122.689H383.435L385.745 123.789V124.099Z",
    fill: "#261D57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 124.399L382.172 122.689H382.812L385.752 124.099V124.399Z",
    fill: "#261E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.749 124.699L381.539 122.689H382.169L385.749 124.399V124.699Z",
    fill: "#271E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 125.009L380.898 122.689H381.538L385.748 124.699V125.009Z",
    fill: "#281F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 125.309L380.258 122.689H380.898L385.748 125.009V125.309Z",
    fill: "#291F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.745 125.619L379.625 122.689H380.255L385.745 125.309V125.619Z",
    fill: "#29205D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.744 125.919L378.984 122.689H379.624L385.744 125.619V125.919Z",
    fill: "#2A215F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.749 126.219L378.359 122.689H378.989L385.749 125.919V126.219Z",
    fill: "#2B2160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.749 126.529L377.719 122.689H378.359L385.749 126.219V126.529Z",
    fill: "#2C2261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 126.829L377.078 122.689H377.718L385.748 126.529V126.829Z",
    fill: "#2D2362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.745 127.129L376.445 122.689H377.075L385.745 126.829V127.129Z",
    fill: "#2D2363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.745 127.439L375.805 122.689H376.445L385.745 127.129V127.439Z",
    fill: "#2E2465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.75 127.739L375.18 122.689H375.81L385.75 127.439V127.739Z",
    fill: "#2F2466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.749 128.049L374.539 122.689H375.179L385.749 127.739V128.049Z",
    fill: "#2F2567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 128.349L373.898 122.689H374.538L385.748 128.049V128.349Z",
    fill: "#302668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.747 128.649L373.617 122.859L373.697 122.689H373.897L385.747 128.349V128.649Z",
    fill: "#312669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.75 128.959L373.5 123.109L373.62 122.859L385.75 128.649V128.959Z",
    fill: "#32276A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.745 129.259L373.375 123.359L373.495 123.109L385.745 128.959V129.259Z",
    fill: "#32276C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.746 129.559L373.266 123.599L373.376 123.359L385.746 129.259V129.559Z",
    fill: "#33286D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 129.87L373.148 123.85L373.268 123.6L385.748 129.56V129.87Z",
    fill: "#34296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.751 130.17L373.031 124.1L373.151 123.85L385.751 129.87V130.17Z",
    fill: "#35296F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.746 130.47L372.906 124.34L373.026 124.1L385.746 130.17V130.47Z",
    fill: "#352A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.749 130.78L372.789 124.59L372.909 124.34L385.749 130.47V130.78Z",
    fill: "#362A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.75 131.08L372.68 124.84L372.79 124.59L385.75 130.78V131.08Z",
    fill: "#372B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.745 131.39L372.555 125.09L372.675 124.84L385.745 131.08V131.39Z",
    fill: "#372C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.747 131.69L372.438 125.33L372.557 125.09L385.747 131.39V131.69Z",
    fill: "#382C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.75 131.989L372.32 125.579L372.44 125.329L385.75 131.689V131.989Z",
    fill: "#392D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.745 132.299L372.195 125.829L372.315 125.579L385.745 131.989V132.299Z",
    fill: "#392D77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 132.599L372.078 126.079L372.198 125.829L385.748 132.299V132.599Z",
    fill: "#3A2E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.749 132.899L371.969 126.319L372.079 126.079L385.749 132.599V132.899Z",
    fill: "#3B2E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 133.209L371.852 126.569L371.972 126.319L385.752 132.899V133.209Z",
    fill: "#3B2F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 133.509L371.828 126.869V126.599L371.848 126.569L385.748 133.209V133.509Z",
    fill: "#3C2F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 133.819L371.828 127.169V126.869L385.748 133.509V133.819Z",
    fill: "#3D307C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 134.12L371.828 127.47V127.17L385.748 133.82V134.12Z",
    fill: "#3D307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 134.42L371.828 127.78V127.47L385.748 134.12V134.42Z",
    fill: "#3E317E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 134.729L371.828 128.079V127.779L385.748 134.419V134.729Z",
    fill: "#3F327F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 135.029L371.828 128.389V128.079L385.748 134.729V135.029Z",
    fill: "#3F3280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.748 135.3L385.728 135.33L371.828 128.69V128.39L385.748 135.03V135.3Z",
    fill: "#403381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.728 135.329L385.618 135.579L371.828 128.989V128.689L385.728 135.329Z",
    fill: "#413382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.618 135.579L385.498 135.819L371.828 129.299V128.989L385.618 135.579Z",
    fill: "#413483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.498 135.82L385.378 136.07L371.828 129.6V129.3L385.498 135.82Z",
    fill: "#423484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.378 136.07L385.258 136.32L371.828 129.9V129.6L385.378 136.07Z",
    fill: "#423585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.258 136.319L385.138 136.559L371.828 130.209V129.899L385.258 136.319Z",
    fill: "#433586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.138 136.559L385.018 136.809L371.828 130.509V130.209L385.138 136.559Z",
    fill: "#443687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.018 136.81L384.908 137.06L371.828 130.81V130.51L385.018 136.81Z",
    fill: "#443688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.908 137.06L384.788 137.31L371.828 131.12V130.81L384.908 137.06Z",
    fill: "#453789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.788 137.309L384.668 137.549L371.828 131.419V131.119L384.788 137.309Z",
    fill: "#45378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.668 137.55L384.548 137.8L371.828 131.73V131.42L384.668 137.55Z",
    fill: "#46378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.548 137.799L384.428 138.049L371.828 132.029V131.729L384.548 137.799Z",
    fill: "#46388B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.428 138.049L384.318 138.299L371.828 132.329V132.029L384.428 138.049Z",
    fill: "#47388C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.318 138.299L384.198 138.539L371.828 132.639V132.329L384.318 138.299Z",
    fill: "#47398D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.198 138.54L384.078 138.79L371.828 132.94V132.64L384.198 138.54Z",
    fill: "#48398E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.078 138.789L383.958 139.039L371.828 133.239V132.939L384.078 138.789Z",
    fill: "#493A8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.958 139.039L383.838 139.279L371.828 133.549V133.239L383.958 139.039Z",
    fill: "#493A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.838 139.28L383.728 139.53L371.828 133.85V133.55L383.838 139.28Z",
    fill: "#4A3B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.728 139.53L383.608 139.78L371.828 134.16V133.85L383.728 139.53Z",
    fill: "#4A3B91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.608 139.779L383.488 140.029L371.828 134.459V134.159L383.608 139.779Z",
    fill: "#4B3B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.488 140.029L383.368 140.269L371.828 134.759V134.459L383.488 140.029Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.368 140.27L383.248 140.52L371.828 135.07V134.76L383.368 140.27Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.248 140.519L383.138 140.769L371.828 135.369V135.069L383.248 140.519Z",
    fill: "#4C3C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.138 140.769L383.018 141.019L371.828 135.669V135.369L383.138 140.769Z",
    fill: "#4C3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.018 141.02L382.898 141.26L371.828 135.98V135.67L383.018 141.02Z",
    fill: "#4D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.898 141.259L382.778 141.509L371.828 136.279V135.979L382.898 141.259Z",
    fill: "#4D3D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.778 141.509L382.658 141.759L371.828 136.589V136.279L382.778 141.509Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.658 141.76L382.538 142L371.828 136.89V136.59L382.658 141.76Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.538 142L382.428 142.25L371.828 137.19V136.89L382.538 142Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.428 142.249L382.308 142.499L371.828 137.499V137.189L382.428 142.249Z",
    fill: "#4F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.308 142.499L382.188 142.749L371.828 137.799V137.499L382.308 142.499Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.188 142.75L382.068 142.99L371.828 138.1V137.8L382.188 142.75Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.068 142.99L380.848 145.55H371.828V138.1L382.068 142.99Z",
    fill: "#4F3F99"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 372,
    y: 122,
    width: 14,
    height: 29
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M381.567 133.48C380.997 133.03 381.127 132.02 381.387 130.39C381.867 127.39 382.347 125.09 382.257 125.07C382.197 125.05 381.937 125.97 381.197 127.75C381.127 127.91 381.047 128.1 381.007 128.2C380.247 129.93 377.557 131.97 376.497 131.32C375.687 130.82 376.047 128.85 376.267 127.63C376.837 124.52 378.327 122.86 378.147 122.72C377.787 122.45 371.417 128.64 372.807 131.02C373.197 131.68 374.067 131.87 374.587 131.94C374.737 132.32 374.907 132.7 375.117 133.08C375.337 133.46 375.827 133.66 376.247 133.54C377.937 133.05 379.387 132.09 380.477 130.81C379.937 132.61 378.857 134.26 377.367 135.48C376.457 136.22 377.547 137.41 378.477 137.09C375.867 140.69 375.957 143.2 376.047 144.06C376.137 144.9 376.497 146.63 376.897 148.13C377.117 148.98 377.337 149.68 377.487 150.17C377.737 148.69 378.197 146.97 379.007 145.16C379.007 145.16 379.847 143.28 381.067 141.58C381.717 140.67 382.387 139.95 382.387 139.95C382.657 139.68 382.847 139.47 382.907 139.41C383.697 138.61 384.457 137.06 384.817 135.65C385.487 133.01 384.787 130.69 384.487 129.83C384.627 131.69 383.977 133.19 382.927 133.58C382.867 133.6 382.067 133.88 381.547 133.47L381.567 133.48Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.505 122.72L384.945 122.45H385.505V122.72Z",
    fill: "#241C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.502 123.09L384.172 122.45H384.942L385.502 122.72V123.09Z",
    fill: "#251C56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.506 123.46L383.406 122.45H384.176L385.506 123.09V123.46Z",
    fill: "#261D57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.503 123.82L382.633 122.45H383.403L385.503 123.46V123.82Z",
    fill: "#261E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.507 124.19L381.867 122.45H382.637L385.507 123.82V124.19Z",
    fill: "#271E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 124.56L381.094 122.45H381.864L385.504 124.19V124.56Z",
    fill: "#281F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5 124.93L380.32 122.45H381.09L385.5 124.56V124.93Z",
    fill: "#291F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.505 125.29L379.555 122.45H380.325L385.505 124.93V125.29Z",
    fill: "#29205D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.501 125.66L378.781 122.45H379.551L385.501 125.29V125.66Z",
    fill: "#2A215F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.506 126.03L378.016 122.45H378.786L385.506 125.66V126.03Z",
    fill: "#2B2160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.502 126.4L377.242 122.45H378.012L385.502 126.03V126.4Z",
    fill: "#2C2261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.507 126.77L376.477 122.45H377.247L385.507 126.4V126.77Z",
    fill: "#2D2362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.503 127.13L375.703 122.45H376.473L385.503 126.77V127.13Z",
    fill: "#2D2363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.508 127.5L374.938 122.45H375.707L385.508 127.13V127.5Z",
    fill: "#2E2465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 127.87L374.164 122.45H374.934L385.504 127.5V127.87Z",
    fill: "#2F2466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.501 128.24L373.391 122.45H374.161L385.501 127.87V128.24Z",
    fill: "#2F2567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 128.61L373.164 122.71L373.284 122.45H373.394L385.504 128.24V128.61Z",
    fill: "#302668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.503 128.97L373.023 123.01L373.163 122.71L385.503 128.61V128.97Z",
    fill: "#312669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.505 129.34L372.875 123.31L373.025 123.01L385.505 128.97V129.34Z",
    fill: "#32276A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 129.711L372.734 123.611L372.874 123.311L385.504 129.341V129.711Z",
    fill: "#32276C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 130.08L372.594 123.91L372.734 123.61L385.504 129.71V130.08Z",
    fill: "#33286D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.505 130.44L372.445 124.21L372.595 123.91L385.505 130.08V130.44Z",
    fill: "#34296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.505 130.81L372.305 124.51L372.445 124.21L385.505 130.44V130.81Z",
    fill: "#35296F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 131.18L372.164 124.81L372.304 124.51L385.504 130.81V131.18Z",
    fill: "#352A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.506 131.551L372.016 125.111L372.166 124.811L385.506 131.181V131.551Z",
    fill: "#362A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.505 131.92L371.875 125.41L372.015 125.11L385.505 131.55V131.92Z",
    fill: "#372B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 132.28L371.734 125.7L371.874 125.41L385.504 131.92V132.28Z",
    fill: "#372C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 132.65L371.594 126L371.734 125.7L385.504 132.28V132.65Z",
    fill: "#382C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.505 133.02L371.445 126.3L371.595 126L385.505 132.65V133.02Z",
    fill: "#392D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 133.39L371.414 126.66V126.36L371.444 126.3L385.504 133.02V133.39Z",
    fill: "#392D77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 133.76L371.414 127.03V126.66L385.504 133.39V133.76Z",
    fill: "#3A2E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 134.12L371.414 127.39V127.03L385.504 133.76V134.12Z",
    fill: "#3B2E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 134.491L371.414 127.761V127.391L385.504 134.121V134.491Z",
    fill: "#3B2F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 134.86L371.414 128.13V127.76L385.504 134.49V134.86Z",
    fill: "#3C2F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 135.23L371.414 128.5V128.13L385.504 134.86V135.23Z",
    fill: "#3D307C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 135.59L371.414 128.87V128.5L385.504 135.23V135.59Z",
    fill: "#3D307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 135.96L371.414 129.23V128.87L385.504 135.59V135.96Z",
    fill: "#3E317E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 136.33L371.414 129.6V129.23L385.504 135.96V136.33Z",
    fill: "#3F327F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 136.701L371.414 129.971V129.601L385.504 136.331V136.701Z",
    fill: "#3F3280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 137.07L371.414 130.34V129.97L385.504 136.7V137.07Z",
    fill: "#403381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.504 137.19L385.414 137.39L371.414 130.7V130.34L385.504 137.07V137.19Z",
    fill: "#413382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.414 137.39L385.274 137.69L371.414 131.07V130.7L385.414 137.39Z",
    fill: "#413483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.274 137.69L385.124 137.99L371.414 131.44V131.07L385.274 137.69Z",
    fill: "#423484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.124 137.99L384.984 138.29L371.414 131.81V131.44L385.124 137.99Z",
    fill: "#423585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.984 138.291L384.844 138.591L371.414 132.181V131.811L384.984 138.291Z",
    fill: "#433586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.844 138.591L384.694 138.891L371.414 132.541V132.181L384.844 138.591Z",
    fill: "#443687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.694 138.89L384.554 139.19L371.414 132.91V132.54L384.694 138.89Z",
    fill: "#443688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.554 139.19L384.414 139.49L371.414 133.28V132.91L384.554 139.19Z",
    fill: "#453789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.414 139.49L384.264 139.78L371.414 133.65V133.28L384.414 139.49Z",
    fill: "#45378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.264 139.78L384.124 140.08L371.414 134.02V133.65L384.264 139.78Z",
    fill: "#46378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.124 140.081L383.984 140.381L371.414 134.381V134.021L384.124 140.081Z",
    fill: "#46388B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.984 140.38L383.844 140.68L371.414 134.75V134.38L383.984 140.38Z",
    fill: "#47388C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.844 140.68L383.694 140.98L371.414 135.12V134.75L383.844 140.68Z",
    fill: "#47398D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.694 140.98L383.554 141.28L371.414 135.49V135.12L383.694 140.98Z",
    fill: "#48398E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.554 141.28L383.414 141.58L371.414 135.85V135.49L383.554 141.28Z",
    fill: "#493A8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.414 141.581L383.264 141.881L371.414 136.221V135.851L383.414 141.581Z",
    fill: "#493A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.264 141.88L383.124 142.18L371.414 136.59V136.22L383.264 141.88Z",
    fill: "#4A3B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.124 142.18L382.984 142.48L371.414 136.96V136.59L383.124 142.18Z",
    fill: "#4A3B91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.984 142.48L382.834 142.78L371.414 137.33V136.96L382.984 142.48Z",
    fill: "#4B3B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.834 142.78L382.694 143.08L371.414 137.69V137.33L382.834 142.78Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.694 143.08L382.554 143.38L371.414 138.06V137.69L382.694 143.08Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.554 143.381L382.404 143.681L371.414 138.431V138.061L382.554 143.381Z",
    fill: "#4C3C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.404 143.681L382.264 143.981L371.414 138.801V138.431L382.404 143.681Z",
    fill: "#4C3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.264 143.98L382.124 144.28L371.414 139.17V138.8L382.264 143.98Z",
    fill: "#4D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.124 144.28L381.984 144.58L371.414 139.53V139.17L382.124 144.28Z",
    fill: "#4D3D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.984 144.58L381.834 144.88L371.414 139.9V139.53L381.984 144.58Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.834 144.88L381.694 145.18L371.414 140.27V139.9L381.834 144.88Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.694 145.18L381.554 145.48L371.414 140.641V140.271L381.694 145.18Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.554 145.481L381.404 145.781L371.414 141.001V140.641L381.554 145.481Z",
    fill: "#4F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.404 145.78L381.264 146.07L371.414 141.37V141L381.404 145.78Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.264 146.07L381.124 146.37L371.414 141.74V141.37L381.264 146.07Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.124 146.37L379.304 150.18H371.414V141.74L381.124 146.37Z",
    fill: "#4F3F99"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M348.483 156.734C348.525 150.157 344.054 144.796 338.499 144.761C332.943 144.726 328.405 150.03 328.364 156.608C328.323 163.185 332.793 168.546 338.349 168.581C343.905 168.616 348.442 163.312 348.483 156.734Z",
    fill: "#E9AB21"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M346.288 156.707C346.329 150.129 342.347 144.772 337.393 144.741C332.439 144.71 328.39 150.017 328.348 156.594C328.307 163.172 332.289 168.529 337.243 168.56C342.197 168.591 346.247 163.284 346.288 156.707Z",
    fill: "#EDBF1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 328,
    y: 144,
    width: 10,
    height: 25
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M337.5 168.61C337.42 168.61 337.33 168.61 337.25 168.61C332.3 168.58 328.32 163.22 328.36 156.64C328.4 150.06 332.37 144.86 337.26 144.79C334.8 147.45 333.31 151.27 332.81 154.61C332.22 159.63 333.26 165.59 337.5 168.61Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.44 144.79L328.32 163.23V144.79H328.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.48 144.79L328.33 168.62H328.32V163.23L328.44 144.79H328.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.518 144.79L328.368 168.62H328.328L328.478 144.79H328.518Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.557 144.79L328.407 168.62H328.367L328.517 144.79H328.557Z",
    fill: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.604 144.79L328.454 168.62H328.414L328.564 144.79H328.604Z",
    fill: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.643 144.79L328.493 168.62H328.453L328.603 144.79H328.643Z",
    fill: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.682 144.79L328.532 168.62H328.492L328.642 144.79H328.682Z",
    fill: "#FFFEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.721 144.79L328.571 168.62H328.531L328.681 144.79H328.721Z",
    fill: "#FFFDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.76 144.79L328.61 168.62H328.57L328.72 144.79H328.76Z",
    fill: "#FEFDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.799 144.79L328.649 168.62H328.609L328.759 144.79H328.799Z",
    fill: "#FEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.838 144.79L328.688 168.62H328.648L328.798 144.79H328.838Z",
    fill: "#FEFCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.878 144.79L328.728 168.62H328.688L328.837 144.79H328.878Z",
    fill: "#FEFCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.927 144.79L328.767 168.62H328.727L328.877 144.79H328.927Z",
    fill: "#FEFCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.973 144.79L328.823 168.62H328.773L328.933 144.79H328.973Z",
    fill: "#FEFCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.01 144.79L328.86 168.62H328.82L328.97 144.79H329.01Z",
    fill: "#FEFBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.049 144.79L328.899 168.62H328.859L329.009 144.79H329.049Z",
    fill: "#FEFBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.088 144.79L328.938 168.62H328.898L329.048 144.79H329.088Z",
    fill: "#FEFBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.128 144.79L328.978 168.62H328.938L329.087 144.79H329.128Z",
    fill: "#FEFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.167 144.79L329.017 168.62H328.977L329.127 144.79H329.167Z",
    fill: "#FEFAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.213 144.79L329.063 168.62H329.023L329.173 144.79H329.213Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.253 144.79L329.103 168.62H329.062L329.212 144.79H329.253Z",
    fill: "#FDFAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.292 144.79L329.142 168.62H329.102L329.252 144.79H329.292Z",
    fill: "#FDF9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.331 144.79L329.181 168.62H329.141L329.291 144.79H329.331Z",
    fill: "#FDF9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.37 144.79L329.22 168.62H329.18L329.33 144.79H329.37Z",
    fill: "#FDF9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.409 144.79L329.259 168.62H329.219L329.369 144.79H329.409Z",
    fill: "#FDF8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.448 144.79L329.298 168.62H329.258L329.408 144.79H329.448Z",
    fill: "#FDF8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.487 144.79L329.337 168.62H329.297L329.447 144.79H329.487Z",
    fill: "#FDF8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.534 144.79L329.384 168.62H329.344L329.494 144.79H329.534Z",
    fill: "#FDF8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.573 144.79L329.423 168.62H329.383L329.533 144.79H329.573Z",
    fill: "#FDF7E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.622 144.79L329.472 168.62H329.422L329.572 144.79H329.622Z",
    fill: "#FDF7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.659 144.79L329.509 168.62H329.469L329.619 144.79H329.659Z",
    fill: "#FDF7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.698 144.79L329.548 168.62H329.508L329.658 144.79H329.698Z",
    fill: "#FDF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.737 144.79L329.587 168.62H329.547L329.697 144.79H329.737Z",
    fill: "#FDF6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.784 144.79L329.634 168.62H329.594L329.744 144.79H329.784Z",
    fill: "#FCF6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.823 144.79L329.673 168.62H329.633L329.783 144.79H329.823Z",
    fill: "#FCF6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.862 144.79L329.712 168.62H329.672L329.822 144.79H329.862Z",
    fill: "#FCF5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.901 144.79L329.751 168.62H329.711L329.861 144.79H329.901Z",
    fill: "#FCF5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94 144.79L329.79 168.62H329.75L329.9 144.79H329.94Z",
    fill: "#FCF5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.979 144.79L329.829 168.62H329.789L329.939 144.79H329.979Z",
    fill: "#FCF5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.018 144.79L329.868 168.62H329.828L329.978 144.79H330.018Z",
    fill: "#FCF4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.057 144.79L329.907 168.62H329.867L330.017 144.79H330.057Z",
    fill: "#FCF4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.104 144.79L329.954 168.62H329.914L330.064 144.79H330.104Z",
    fill: "#FCF4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.143 144.79L329.993 168.62H329.953L330.103 144.79H330.143Z",
    fill: "#FCF3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.182 144.79L330.032 168.62H329.992L330.142 144.79H330.182Z",
    fill: "#FCF3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.221 144.79L330.071 168.62H330.031L330.181 144.79H330.221Z",
    fill: "#FCF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.27 144.79L330.11 168.62H330.07L330.22 144.79H330.27Z",
    fill: "#FBF3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.309 144.79L330.159 168.62H330.109L330.269 144.79H330.309Z",
    fill: "#FBF2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.354 144.79L330.204 168.62H330.164L330.314 144.79H330.354Z",
    fill: "#FBF2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.393 144.79L330.243 168.62H330.203L330.353 144.79H330.393Z",
    fill: "#FBF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.432 144.79L330.282 168.62H330.242L330.392 144.79H330.432Z",
    fill: "#FBF1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.471 144.79L330.321 168.62H330.281L330.431 144.79H330.471Z",
    fill: "#FBF1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.51 144.79L330.36 168.62H330.32L330.47 144.79H330.51Z",
    fill: "#FBF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.549 144.79L330.399 168.62H330.359L330.509 144.79H330.549Z",
    fill: "#FBF1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.588 144.79L330.438 168.62H330.398L330.548 144.79H330.588Z",
    fill: "#FBF0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.628 144.79L330.478 168.62H330.438L330.587 144.79H330.628Z",
    fill: "#FBF0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.667 144.79L330.517 168.62H330.477L330.627 144.79H330.667Z",
    fill: "#FBF0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.713 144.79L330.563 168.62H330.523L330.673 144.79H330.713Z",
    fill: "#FBEFC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.753 144.79L330.603 168.62H330.562L330.712 144.79H330.753Z",
    fill: "#FBEFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.792 144.79L330.642 168.62H330.602L330.752 144.79H330.792Z",
    fill: "#FAEFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.831 144.79L330.681 168.62H330.641L330.791 144.79H330.831Z",
    fill: "#FAEFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.87 144.79L330.72 168.62H330.68L330.83 144.79H330.87Z",
    fill: "#FAEEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.909 144.79L330.759 168.62H330.719L330.869 144.79H330.909Z",
    fill: "#FAEEC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.958 144.79L330.798 168.62H330.758L330.908 144.79H330.958Z",
    fill: "#FAEEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.997 144.79L330.847 168.62H330.797L330.957 144.79H330.997Z",
    fill: "#FAEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.042 144.79L330.892 168.62H330.852L331.002 144.79H331.042Z",
    fill: "#FAEDC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.081 144.79L330.931 168.62H330.891L331.041 144.79H331.081Z",
    fill: "#FAEDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.12 144.79L330.97 168.62H330.93L331.08 144.79H331.12Z",
    fill: "#FAEDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.159 144.79L331.009 168.62H330.969L331.119 144.79H331.159Z",
    fill: "#FAECBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.198 144.79L331.048 168.62H331.008L331.158 144.79H331.198Z",
    fill: "#FAECBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.237 144.79L331.087 168.62H331.047L331.197 144.79H331.237Z",
    fill: "#FAECBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.284 144.79L331.134 168.62H331.094L331.244 144.79H331.284Z",
    fill: "#FAEBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.323 144.79L331.173 168.62H331.133L331.283 144.79H331.323Z",
    fill: "#F9EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.362 144.79L331.212 168.62H331.172L331.322 144.79H331.362Z",
    fill: "#F9EBB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.401 144.79L331.251 168.62H331.211L331.361 144.79H331.401Z",
    fill: "#F9EBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.44 144.79L331.29 168.62H331.25L331.4 144.79H331.44Z",
    fill: "#F9EAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.479 144.79L331.329 168.62H331.289L331.439 144.79H331.479Z",
    fill: "#F9EAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.518 144.79L331.368 168.62H331.328L331.478 144.79H331.518Z",
    fill: "#F9EAB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.557 144.79L331.407 168.62H331.367L331.517 144.79H331.557Z",
    fill: "#F9E9B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.604 144.79L331.454 168.62H331.414L331.564 144.79H331.604Z",
    fill: "#F9E9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.653 144.79L331.493 168.62H331.453L331.603 144.79H331.653Z",
    fill: "#F9E9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.692 144.79L331.542 168.62H331.492L331.652 144.79H331.692Z",
    fill: "#F9E9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.729 144.79L331.579 168.62H331.539L331.689 144.79H331.729Z",
    fill: "#F9E8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.768 144.79L331.618 168.62H331.578L331.728 144.79H331.768Z",
    fill: "#F9E8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.807 144.79L331.657 168.62H331.617L331.767 144.79H331.807Z",
    fill: "#F8E8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.854 144.79L331.704 168.62H331.664L331.814 144.79H331.854Z",
    fill: "#F8E7AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.893 144.79L331.743 168.62H331.703L331.853 144.79H331.893Z",
    fill: "#F8E7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.932 144.79L331.782 168.62H331.742L331.892 144.79H331.932Z",
    fill: "#F8E7AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.971 144.79L331.821 168.62H331.781L331.931 144.79H331.971Z",
    fill: "#F8E7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.01 144.79L331.86 168.62H331.82L331.97 144.79H332.01Z",
    fill: "#F8E6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 144.79L331.899 168.62H331.859L332.009 144.79H332.049Z",
    fill: "#F8E6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.088 144.79L331.938 168.62H331.898L332.048 144.79H332.088Z",
    fill: "#F8E6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.128 144.79L331.978 168.62H331.938L332.087 144.79H332.128Z",
    fill: "#F8E6A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.167 144.79L332.017 168.62H331.977L332.127 144.79H332.167Z",
    fill: "#F8E5A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.213 144.79L332.063 168.62H332.023L332.173 144.79H332.213Z",
    fill: "#F8E5A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.253 144.79L332.103 168.62H332.062L332.212 144.79H332.253Z",
    fill: "#F8E5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.292 144.79L332.142 168.62H332.102L332.252 144.79H332.292Z",
    fill: "#F8E4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.341 144.79L332.191 168.62H332.141L332.291 144.79H332.341Z",
    fill: "#F7E4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.378 144.79L332.228 168.62H332.188L332.337 144.79H332.378Z",
    fill: "#F7E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.417 144.79L332.267 168.62H332.227L332.377 144.79H332.417Z",
    fill: "#F7E49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.463 144.79L332.313 168.62H332.273L332.423 144.79H332.463Z",
    fill: "#F7E39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.503 144.79L332.353 168.62H332.312L332.462 144.79H332.503Z",
    fill: "#F7E39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.542 144.79L332.392 168.62H332.352L332.502 144.79H332.542Z",
    fill: "#F7E39B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.581 144.79L332.431 168.62H332.391L332.541 144.79H332.581Z",
    fill: "#F7E29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.62 144.79L332.47 168.62H332.43L332.58 144.79H332.62Z",
    fill: "#F7E299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.659 144.79L332.509 168.62H332.469L332.619 144.79H332.659Z",
    fill: "#F7E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.698 144.79L332.548 168.62H332.508L332.658 144.79H332.698Z",
    fill: "#F7E297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.737 144.79L332.587 168.62H332.547L332.697 144.79H332.737Z",
    fill: "#F7E196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.784 144.79L332.634 168.62H332.594L332.744 144.79H332.784Z",
    fill: "#F7E195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.823 144.79L332.673 168.62H332.633L332.783 144.79H332.823Z",
    fill: "#F6E194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.862 144.79L332.712 168.62H332.672L332.822 144.79H332.862Z",
    fill: "#F6E093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.901 144.79L332.751 168.62H332.711L332.861 144.79H332.901Z",
    fill: "#F6E092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.94 144.79L332.79 168.62H332.75L332.9 144.79H332.94Z",
    fill: "#F6E091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.989 144.79L332.829 168.62H332.789L332.939 144.79H332.989Z",
    fill: "#F6E090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.028 144.79L332.878 168.62H332.828L332.988 144.79H333.028Z",
    fill: "#F6DF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.073 144.79L332.923 168.62H332.883L333.033 144.79H333.073Z",
    fill: "#F6DF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.112 144.79L332.962 168.62H332.922L333.072 144.79H333.112Z",
    fill: "#F6DF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.151 144.79L333.001 168.62H332.961L333.111 144.79H333.151Z",
    fill: "#F6DE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.19 144.79L333.04 168.62H333L333.15 144.79H333.19Z",
    fill: "#F6DE8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.229 144.79L333.079 168.62H333.039L333.189 144.79H333.229Z",
    fill: "#F6DE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.268 144.79L333.118 168.62H333.078L333.228 144.79H333.268Z",
    fill: "#F6DE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.307 144.79L333.157 168.62H333.117L333.267 144.79H333.307Z",
    fill: "#F6DD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.354 144.79L333.204 168.62H333.164L333.314 144.79H333.354Z",
    fill: "#F5DD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.393 144.79L333.243 168.62H333.203L333.353 144.79H333.393Z",
    fill: "#F5DD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.432 144.79L333.282 168.62H333.242L333.392 144.79H333.432Z",
    fill: "#F5DC84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.471 144.79L333.321 168.62H333.281L333.431 144.79H333.471Z",
    fill: "#F5DC83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.51 144.79L333.36 168.62H333.32L333.47 144.79H333.51Z",
    fill: "#F5DC82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.549 144.79L333.399 168.62H333.359L333.509 144.79H333.549Z",
    fill: "#F5DC81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.588 144.79L333.438 168.62H333.398L333.548 144.79H333.588Z",
    fill: "#F5DB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.628 144.79L333.478 168.62H333.438L333.587 144.79H333.628Z",
    fill: "#F5DB7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.677 144.79L333.517 168.62H333.477L333.627 144.79H333.677Z",
    fill: "#F5DB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.723 144.79L333.573 168.62H333.523L333.683 144.79H333.723Z",
    fill: "#F5DA7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.76 144.79L333.61 168.62H333.57L333.72 144.79H333.76Z",
    fill: "#F5DA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.799 144.79L333.649 168.62H333.609L333.759 144.79H333.799Z",
    fill: "#F5DA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.838 144.79L333.688 168.62H333.648L333.798 144.79H333.838Z",
    fill: "#F4DA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.878 144.79L333.728 168.62H333.688L333.837 144.79H333.878Z",
    fill: "#F4D979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.917 144.79L333.767 168.62H333.727L333.877 144.79H333.917Z",
    fill: "#F4D978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.963 144.79L333.813 168.62H333.773L333.923 144.79H333.963Z",
    fill: "#F4D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.003 144.79L333.853 168.62H333.812L333.962 144.79H334.003Z",
    fill: "#F4D876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.042 144.79L333.892 168.62H333.852L334.002 144.79H334.042Z",
    fill: "#F4D875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.081 144.79L333.931 168.62H333.891L334.041 144.79H334.081Z",
    fill: "#F4D874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.12 144.79L333.97 168.62H333.93L334.08 144.79H334.12Z",
    fill: "#F4D873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.159 144.79L334.009 168.62H333.969L334.119 144.79H334.159Z",
    fill: "#F4D772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.198 144.79L334.048 168.62H334.008L334.158 144.79H334.198Z",
    fill: "#F4D771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.237 144.79L334.087 168.62H334.047L334.197 144.79H334.237Z",
    fill: "#F4D770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.284 144.79L334.134 168.62H334.094L334.244 144.79H334.284Z",
    fill: "#F4D76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.323 144.79L334.173 168.62H334.133L334.283 144.79H334.323Z",
    fill: "#F4D66E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.372 144.79L334.212 168.62H334.172L334.322 144.79H334.372Z",
    fill: "#F3D66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.411 144.79L334.261 168.62H334.211L334.371 144.79H334.411Z",
    fill: "#F3D66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.448 144.79L334.298 168.62H334.258L334.408 144.79H334.448Z",
    fill: "#F3D56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.487 144.79L334.337 168.62H334.297L334.447 144.79H334.487Z",
    fill: "#F3D56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.534 144.79L334.384 168.62H334.344L334.494 144.79H334.534Z",
    fill: "#F3D569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.573 144.79L334.423 168.62H334.383L334.533 144.79H334.573Z",
    fill: "#F3D568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.612 144.79L334.462 168.62H334.422L334.572 144.79H334.612Z",
    fill: "#F3D467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.651 144.79L334.501 168.62H334.461L334.611 144.79H334.651Z",
    fill: "#F3D466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.69 144.79L334.54 168.62H334.5L334.65 144.79H334.69Z",
    fill: "#F3D465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.729 144.79L334.579 168.62H334.539L334.689 144.79H334.729Z",
    fill: "#F3D364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.768 144.79L334.618 168.62H334.578L334.728 144.79H334.768Z",
    fill: "#F3D363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.807 144.79L334.657 168.62H334.617L334.767 144.79H334.807Z",
    fill: "#F3D362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.854 144.79L334.704 168.62H334.664L334.814 144.79H334.854Z",
    fill: "#F2D361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.893 144.79L334.743 168.62H334.703L334.853 144.79H334.893Z",
    fill: "#F2D260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.932 144.79L334.782 168.62H334.742L334.892 144.79H334.932Z",
    fill: "#F2D25F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.971 144.79L334.821 168.62H334.781L334.931 144.79H334.971Z",
    fill: "#F2D25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.01 144.79L334.86 168.62H334.82L334.97 144.79H335.01Z",
    fill: "#F2D15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.059 144.79L334.909 168.62H334.859L335.009 144.79H335.059Z",
    fill: "#F2D15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.104 144.79L334.954 168.62H334.914L335.064 144.79H335.104Z",
    fill: "#F2D15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.143 144.79L334.993 168.62H334.953L335.103 144.79H335.143Z",
    fill: "#F2D15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.182 144.79L335.032 168.62H334.992L335.142 144.79H335.182Z",
    fill: "#F2D059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.221 144.79L335.071 168.62H335.031L335.181 144.79H335.221Z",
    fill: "#F2D058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.26 144.79L335.11 168.62H335.07L335.22 144.79H335.26Z",
    fill: "#F2D057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.299 144.79L335.149 168.62H335.109L335.259 144.79H335.299Z",
    fill: "#F2CF56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.338 144.79L335.188 168.62H335.148L335.298 144.79H335.338Z",
    fill: "#F2CF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.378 144.79L335.228 168.62H335.188L335.337 144.79H335.378Z",
    fill: "#F1CF54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.417 144.79L335.267 168.62H335.227L335.377 144.79H335.417Z",
    fill: "#F1CF53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.463 144.79L335.313 168.62H335.273L335.423 144.79H335.463Z",
    fill: "#F1CE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.503 144.79L335.353 168.62H335.312L335.462 144.79H335.503Z",
    fill: "#F1CE51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.542 144.79L335.392 168.62H335.352L335.502 144.79H335.542Z",
    fill: "#F1CE50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.581 144.79L335.431 168.62H335.391L335.541 144.79H335.581Z",
    fill: "#F1CD4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.62 144.79L335.47 168.62H335.43L335.58 144.79H335.62Z",
    fill: "#F1CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.659 144.79L335.509 168.62H335.469L335.619 144.79H335.659Z",
    fill: "#F1CD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.708 144.79L335.548 168.62H335.508L335.658 144.79H335.708Z",
    fill: "#F1CD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.747 144.79L335.597 168.62H335.547L335.707 144.79H335.747Z",
    fill: "#F1CC4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.792 144.79L335.642 168.62H335.602L335.752 144.79H335.792Z",
    fill: "#F1CC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.831 144.79L335.681 168.62H335.641L335.791 144.79H335.831Z",
    fill: "#F1CC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.87 144.79L335.72 168.62H335.68L335.83 144.79H335.87Z",
    fill: "#F1CB48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.909 144.79L335.759 168.62H335.719L335.869 144.79H335.909Z",
    fill: "#F0CB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.948 144.79L335.798 168.62H335.758L335.908 144.79H335.948Z",
    fill: "#F0CB46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.987 144.79L335.837 168.62H335.797L335.947 144.79H335.987Z",
    fill: "#F0CB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.034 144.79L335.884 168.62H335.844L335.994 144.79H336.034Z",
    fill: "#F0CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.073 144.79L335.923 168.62H335.883L336.033 144.79H336.073Z",
    fill: "#F0CA43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.112 144.79L335.962 168.62H335.922L336.072 144.79H336.112Z",
    fill: "#F0CA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.151 144.79L336.001 168.62H335.961L336.111 144.79H336.151Z",
    fill: "#F0C941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.19 144.79L336.04 168.62H336L336.15 144.79H336.19Z",
    fill: "#F0C940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.229 144.79L336.079 168.62H336.039L336.189 144.79H336.229Z",
    fill: "#F0C93F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.268 144.79L336.118 168.62H336.078L336.228 144.79H336.268Z",
    fill: "#F0C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.307 144.79L336.157 168.62H336.117L336.267 144.79H336.307Z",
    fill: "#F0C83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.354 144.79L336.204 168.62H336.164L336.314 144.79H336.354Z",
    fill: "#F0C83C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.403 144.79L336.243 168.62H336.203L336.353 144.79H336.403Z",
    fill: "#EFC83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.442 144.79L336.292 168.62H336.242L336.402 144.79H336.442Z",
    fill: "#EFC73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.479 144.79L336.329 168.62H336.289L336.439 144.79H336.479Z",
    fill: "#EFC739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.518 144.79L336.368 168.62H336.328L336.478 144.79H336.518Z",
    fill: "#EFC738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.557 144.79L336.407 168.62H336.367L336.517 144.79H336.557Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.604 144.79L336.454 168.62H336.414L336.564 144.79H336.604Z",
    fill: "#EFC636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.643 144.79L336.493 168.62H336.453L336.603 144.79H336.643Z",
    fill: "#EFC635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.682 144.79L336.532 168.62H336.492L336.642 144.79H336.682Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.721 144.79L336.571 168.62H336.531L336.681 144.79H336.721Z",
    fill: "#EFC633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.76 144.79L336.61 168.62H336.57L336.72 144.79H336.76Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.799 144.79L336.649 168.62H336.609L336.759 144.79H336.799Z",
    fill: "#EFC531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.838 144.79L336.688 168.62H336.648L336.798 144.79H336.838Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.878 144.79L336.728 168.62H336.688L336.837 144.79H336.878Z",
    fill: "#EFC42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.917 144.79L336.767 168.62H336.727L336.877 144.79H336.917Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.963 144.79L336.813 168.62H336.773L336.923 144.79H336.963Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.003 144.79L336.853 168.62H336.812L336.962 144.79H337.003Z",
    fill: "#EEC42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.042 144.79L336.892 168.62H336.852L337.002 144.79H337.042Z",
    fill: "#EEC32B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.091 144.79L336.941 168.62H336.891L337.041 144.79H337.091Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.128 144.79L336.978 168.62H336.938L337.087 144.79H337.128Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.167 144.79L337.017 168.62H336.977L337.127 144.79H337.167Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.213 144.79L337.063 168.62H337.023L337.173 144.79H337.213Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.253 144.79L337.103 168.62H337.062L337.212 144.79H337.253Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.292 144.79L337.142 168.62H337.102L337.252 144.79H337.292Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.331 144.79L337.181 168.62H337.141L337.291 144.79H337.331Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.37 144.79L337.22 168.62H337.18L337.33 144.79H337.37Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.409 144.79L337.259 168.62H337.219L337.369 144.79H337.409Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.448 144.79L337.298 168.62H337.258L337.408 144.79H337.448Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.487 144.79L337.337 168.62H337.297L337.447 144.79H337.487Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.504 149.32L337.384 168.62H337.344L337.494 144.79H337.504V149.32Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.503 155.75L337.423 168.62H337.383L337.503 149.32V155.75Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.502 162.18L337.462 168.62H337.422L337.502 155.75V162.18Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.501 168.61V168.62H337.461L337.501 162.18V168.61Z",
    fill: "#EDBF1C"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 337,
    y: 144,
    width: 12,
    height: 25
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M337.893 168.559C338.683 168.599 339.883 168.559 341.243 168.109C343.863 167.239 345.313 165.379 345.983 164.479C348.423 161.259 348.433 157.709 348.423 156.419C348.413 155.329 348.333 152.199 346.333 149.259C345.123 147.479 343.693 146.499 343.383 146.289C342.153 145.469 341.103 145.149 340.873 145.079C339.913 144.799 339.083 144.739 338.493 144.739C339.493 144.919 342.903 145.669 345.413 148.769C347.433 151.269 347.753 153.909 347.863 154.929C348.433 160.279 345.463 166.049 341.343 167.819C340.013 168.389 338.773 168.529 337.883 168.539L337.893 168.559Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.454 161.039L348.344 144.749H348.454V161.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.447 168.439L348.297 144.749H348.337L348.447 161.039V168.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.4 168.599L348.25 144.749H348.3L348.45 168.439V168.599H348.4Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.353 168.599L348.203 144.749H348.253L348.403 168.599H348.353Z",
    fill: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.314 168.599L348.164 144.749H348.204L348.354 168.599H348.314Z",
    fill: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.259 168.599L348.109 144.749H348.159L348.309 168.599H348.259Z",
    fill: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.212 168.599L348.062 144.749H348.112L348.263 168.599H348.212Z",
    fill: "#FFFEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.173 168.599L348.023 144.749H348.063L348.213 168.599H348.173Z",
    fill: "#FFFDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.119 168.599L347.969 144.749H348.019L348.169 168.599H348.119Z",
    fill: "#FEFDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.072 168.599L347.922 144.749H347.972L348.122 168.599H348.072Z",
    fill: "#FEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.033 168.599L347.883 144.749H347.923L348.073 168.599H348.033Z",
    fill: "#FEFCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.978 168.599L347.828 144.749H347.878L348.028 168.599H347.978Z",
    fill: "#FEFCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.931 168.599L347.781 144.749H347.831L347.981 168.599H347.931Z",
    fill: "#FEFCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.892 168.599L347.742 144.749H347.782L347.932 168.599H347.892Z",
    fill: "#FEFCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.837 168.599L347.688 144.749H347.737L347.888 168.599H347.837Z",
    fill: "#FEFBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.791 168.599L347.641 144.749H347.691L347.841 168.599H347.791Z",
    fill: "#FEFBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.754 168.599L347.594 144.749H347.644L347.794 168.599H347.754Z",
    fill: "#FEFBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.697 168.599L347.547 144.749H347.587L347.747 168.599H347.697Z",
    fill: "#FEFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.65 168.599L347.5 144.749H347.55L347.7 168.599H347.65Z",
    fill: "#FEFAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.613 168.599L347.453 144.749H347.503L347.653 168.599H347.613Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.564 168.599L347.414 144.749H347.454L347.614 168.599H347.564Z",
    fill: "#FDFAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.509 168.599L347.359 144.749H347.409L347.559 168.599H347.509Z",
    fill: "#FDF9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.473 168.599L347.312 144.749H347.362L347.513 168.599H347.473Z",
    fill: "#FDF9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.423 168.599L347.273 144.749H347.313L347.473 168.599H347.423Z",
    fill: "#FDF9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.369 168.599L347.219 144.749H347.269L347.419 168.599H347.369Z",
    fill: "#FDF8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.322 168.599L347.172 144.749H347.222L347.372 168.599H347.322Z",
    fill: "#FDF8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.283 168.599L347.133 144.749H347.173L347.323 168.599H347.283Z",
    fill: "#FDF8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.228 168.599L347.078 144.749H347.128L347.278 168.599H347.228Z",
    fill: "#FDF8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.181 168.599L347.031 144.749H347.081L347.231 168.599H347.181Z",
    fill: "#FDF7E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.142 168.599L346.992 144.749H347.032L347.182 168.599H347.142Z",
    fill: "#FDF7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.087 168.599L346.938 144.749H346.987L347.138 168.599H347.087Z",
    fill: "#FDF7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.041 168.599L346.891 144.749H346.941L347.091 168.599H347.041Z",
    fill: "#FDF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.002 168.599L346.852 144.749H346.892L347.042 168.599H347.002Z",
    fill: "#FDF6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.947 168.599L346.797 144.749H346.847L346.997 168.599H346.947Z",
    fill: "#FCF6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.9 168.599L346.75 144.749H346.8L346.95 168.599H346.9Z",
    fill: "#FCF6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.861 168.599L346.711 144.749H346.751L346.901 168.599H346.861Z",
    fill: "#FCF5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.814 168.599L346.664 144.749H346.714L346.864 168.599H346.814Z",
    fill: "#FCF5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.759 168.599L346.609 144.749H346.659L346.809 168.599H346.759Z",
    fill: "#FCF5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.72 168.599L346.57 144.749H346.61L346.76 168.599H346.72Z",
    fill: "#FCF5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.673 168.599L346.523 144.749H346.573L346.723 168.599H346.673Z",
    fill: "#FCF4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.619 168.599L346.469 144.749H346.519L346.669 168.599H346.619Z",
    fill: "#FCF4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.58 168.599L346.43 144.749H346.47L346.62 168.599H346.58Z",
    fill: "#FCF4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.533 168.599L346.383 144.749H346.433L346.583 168.599H346.533Z",
    fill: "#FCF3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.478 168.599L346.328 144.749H346.378L346.528 168.599H346.478Z",
    fill: "#FCF3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.439 168.599L346.289 144.749H346.329L346.479 168.599H346.439Z",
    fill: "#FCF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.392 168.599L346.242 144.749H346.292L346.442 168.599H346.392Z",
    fill: "#FBF3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.337 168.599L346.188 144.749H346.237L346.388 168.599H346.337Z",
    fill: "#FBF2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.298 168.599L346.148 144.749H346.188L346.338 168.599H346.298Z",
    fill: "#FBF2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.252 168.599L346.102 144.749H346.152L346.302 168.599H346.252Z",
    fill: "#FBF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.197 168.599L346.047 144.749H346.097L346.247 168.599H346.197Z",
    fill: "#FBF1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.158 168.599L346.008 144.749H346.048L346.198 168.599H346.158Z",
    fill: "#FBF1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.111 168.599L345.961 144.749H346.011L346.161 168.599H346.111Z",
    fill: "#FBF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.064 168.599L345.914 144.749H345.964L346.114 168.599H346.064Z",
    fill: "#FBF1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.017 168.599L345.867 144.749H345.907L346.057 168.599H346.017Z",
    fill: "#FBF0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.97 168.599L345.82 144.749H345.87L346.02 168.599H345.97Z",
    fill: "#FBF0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.923 168.599L345.773 144.749H345.823L345.973 168.599H345.923Z",
    fill: "#FBF0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.884 168.599L345.734 144.749H345.774L345.924 168.599H345.884Z",
    fill: "#FBEFC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.83 168.599L345.68 144.749H345.73L345.88 168.599H345.83Z",
    fill: "#FBEFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.783 168.599L345.633 144.749H345.683L345.833 168.599H345.783Z",
    fill: "#FAEFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.744 168.599L345.594 144.749H345.634L345.784 168.599H345.744Z",
    fill: "#FAEFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.689 168.599L345.539 144.749H345.589L345.739 168.599H345.689Z",
    fill: "#FAEEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.642 168.599L345.492 144.749H345.542L345.692 168.599H345.642Z",
    fill: "#FAEEC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.603 168.599L345.453 144.749H345.493L345.643 168.599H345.603Z",
    fill: "#FAEEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.548 168.599L345.398 144.749H345.448L345.598 168.599H345.548Z",
    fill: "#FAEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.502 168.599L345.352 144.749H345.402L345.552 168.599H345.502Z",
    fill: "#FAEDC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.462 168.599L345.312 144.749H345.353L345.503 168.599H345.462Z",
    fill: "#FAEDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.408 168.599L345.258 144.749H345.308L345.458 168.599H345.408Z",
    fill: "#FAEDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.361 168.599L345.211 144.749H345.261L345.411 168.599H345.361Z",
    fill: "#FAECBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.322 168.599L345.172 144.749H345.212L345.362 168.599H345.322Z",
    fill: "#FAECBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.267 168.599L345.117 144.749H345.167L345.317 168.599H345.267Z",
    fill: "#FAECBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.22 168.599L345.07 144.749H345.12L345.27 168.599H345.22Z",
    fill: "#FAEBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.181 168.599L345.031 144.749H345.071L345.221 168.599H345.181Z",
    fill: "#F9EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.134 168.599L344.984 144.749H345.034L345.184 168.599H345.134Z",
    fill: "#F9EBB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08 168.599L344.93 144.749H344.98L345.13 168.599H345.08Z",
    fill: "#F9EBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.041 168.599L344.891 144.749H344.931L345.081 168.599H345.041Z",
    fill: "#F9EAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.994 168.599L344.844 144.749H344.894L345.044 168.599H344.994Z",
    fill: "#F9EAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.939 168.599L344.789 144.749H344.839L344.989 168.599H344.939Z",
    fill: "#F9EAB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.9 168.599L344.75 144.749H344.79L344.94 168.599H344.9Z",
    fill: "#F9E9B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.853 168.599L344.703 144.749H344.753L344.903 168.599H344.853Z",
    fill: "#F9E9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.798 168.599L344.648 144.749H344.698L344.848 168.599H344.798Z",
    fill: "#F9E9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.762 168.599L344.602 144.749H344.652L344.802 168.599H344.762Z",
    fill: "#F9E9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.712 168.599L344.562 144.749H344.603L344.763 168.599H344.712Z",
    fill: "#F9E8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.658 168.599L344.508 144.749H344.558L344.708 168.599H344.658Z",
    fill: "#F9E8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.621 168.599L344.461 144.749H344.511L344.661 168.599H344.621Z",
    fill: "#F8E8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.572 168.599L344.422 144.749H344.462L344.622 168.599H344.572Z",
    fill: "#F8E7AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.517 168.599L344.367 144.749H344.417L344.567 168.599H344.517Z",
    fill: "#F8E7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.48 168.599L344.32 144.749H344.37L344.52 168.599H344.48Z",
    fill: "#F8E7AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.431 168.599L344.281 144.749H344.321L344.481 168.599H344.431Z",
    fill: "#F8E7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.384 168.599L344.234 144.749H344.284L344.434 168.599H344.384Z",
    fill: "#F8E6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33 168.599L344.18 144.749H344.23L344.38 168.599H344.33Z",
    fill: "#F8E6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.291 168.599L344.141 144.749H344.181L344.331 168.599H344.291Z",
    fill: "#F8E6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.244 168.599L344.094 144.749H344.144L344.294 168.599H344.244Z",
    fill: "#F8E6A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.189 168.599L344.039 144.749H344.089L344.239 168.599H344.189Z",
    fill: "#F8E5A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.15 168.599L344 144.749H344.04L344.19 168.599H344.15Z",
    fill: "#F8E5A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.103 168.599L343.953 144.749H344.003L344.153 168.599H344.103Z",
    fill: "#F8E5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.048 168.599L343.898 144.749H343.948L344.098 168.599H344.048Z",
    fill: "#F8E4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.009 168.599L343.859 144.749H343.899L344.049 168.599H344.009Z",
    fill: "#F7E4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.962 168.599L343.812 144.749H343.862L344.013 168.599H343.962Z",
    fill: "#F7E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.908 168.599L343.758 144.749H343.808L343.958 168.599H343.908Z",
    fill: "#F7E49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.869 168.599L343.719 144.749H343.759L343.909 168.599H343.869Z",
    fill: "#F7E39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.822 168.599L343.672 144.749H343.722L343.872 168.599H343.822Z",
    fill: "#F7E39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.767 168.599L343.617 144.749H343.667L343.817 168.599H343.767Z",
    fill: "#F7E39B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.728 168.599L343.578 144.749H343.618L343.768 168.599H343.728Z",
    fill: "#F7E29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.681 168.599L343.531 144.749H343.581L343.731 168.599H343.681Z",
    fill: "#F7E299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.634 168.599L343.484 144.749H343.534L343.684 168.599H343.634Z",
    fill: "#F7E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.587 168.599L343.438 144.749H343.478L343.628 168.599H343.587Z",
    fill: "#F7E297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.541 168.599L343.391 144.749H343.441L343.591 168.599H343.541Z",
    fill: "#F7E196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.494 168.599L343.344 144.749H343.394L343.544 168.599H343.494Z",
    fill: "#F7E195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.447 168.599L343.297 144.749H343.337L343.487 168.599H343.447Z",
    fill: "#F6E194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.4 168.599L343.25 144.749H343.3L343.45 168.599H343.4Z",
    fill: "#F6E093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.353 168.599L343.203 144.749H343.253L343.403 168.599H343.353Z",
    fill: "#F6E092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.314 168.599L343.164 144.749H343.204L343.354 168.599H343.314Z",
    fill: "#F6E091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.259 168.599L343.109 144.749H343.159L343.309 168.599H343.259Z",
    fill: "#F6E090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.212 168.599L343.062 144.749H343.112L343.263 168.599H343.212Z",
    fill: "#F6DF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.173 168.599L343.023 144.749H343.063L343.213 168.599H343.173Z",
    fill: "#F6DF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.119 168.599L342.969 144.749H343.019L343.169 168.599H343.119Z",
    fill: "#F6DF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.072 168.599L342.922 144.749H342.972L343.122 168.599H343.072Z",
    fill: "#F6DE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.033 168.599L342.883 144.749H342.923L343.073 168.599H343.033Z",
    fill: "#F6DE8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.978 168.599L342.828 144.749H342.878L343.028 168.599H342.978Z",
    fill: "#F6DE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.931 168.599L342.781 144.749H342.831L342.981 168.599H342.931Z",
    fill: "#F6DE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.892 168.599L342.742 144.749H342.782L342.932 168.599H342.892Z",
    fill: "#F6DD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.837 168.599L342.688 144.749H342.737L342.888 168.599H342.837Z",
    fill: "#F5DD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.791 168.599L342.641 144.749H342.691L342.841 168.599H342.791Z",
    fill: "#F5DD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.752 168.599L342.602 144.749H342.642L342.792 168.599H342.752Z",
    fill: "#F5DC84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.697 168.599L342.547 144.749H342.597L342.747 168.599H342.697Z",
    fill: "#F5DC83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.65 168.599L342.5 144.749H342.55L342.7 168.599H342.65Z",
    fill: "#F5DC82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.611 168.599L342.461 144.749H342.501L342.651 168.599H342.611Z",
    fill: "#F5DC81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.564 168.599L342.414 144.749H342.464L342.614 168.599H342.564Z",
    fill: "#F5DB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.509 168.599L342.359 144.749H342.409L342.559 168.599H342.509Z",
    fill: "#F5DB7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.47 168.599L342.32 144.749H342.36L342.51 168.599H342.47Z",
    fill: "#F5DB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.423 168.599L342.273 144.749H342.323L342.473 168.599H342.423Z",
    fill: "#F5DA7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.369 168.599L342.219 144.749H342.269L342.419 168.599H342.369Z",
    fill: "#F5DA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.33 168.599L342.18 144.749H342.22L342.37 168.599H342.33Z",
    fill: "#F5DA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.283 168.599L342.133 144.749H342.183L342.333 168.599H342.283Z",
    fill: "#F4DA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.228 168.599L342.078 144.749H342.128L342.278 168.599H342.228Z",
    fill: "#F4D979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.189 168.599L342.039 144.749H342.079L342.229 168.599H342.189Z",
    fill: "#F4D978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.142 168.599L341.992 144.749H342.042L342.192 168.599H342.142Z",
    fill: "#F4D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.087 168.599L341.938 144.749H341.987L342.138 168.599H342.087Z",
    fill: "#F4D876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.048 168.599L341.898 144.749H341.938L342.088 168.599H342.048Z",
    fill: "#F4D875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.002 168.599L341.852 144.749H341.902L342.052 168.599H342.002Z",
    fill: "#F4D874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.947 168.599L341.797 144.749H341.847L341.997 168.599H341.947Z",
    fill: "#F4D873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.91 168.599L341.75 144.749H341.8L341.95 168.599H341.91Z",
    fill: "#F4D772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.861 168.599L341.711 144.749H341.751L341.911 168.599H341.861Z",
    fill: "#F4D771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.814 168.599L341.664 144.749H341.714L341.864 168.599H341.814Z",
    fill: "#F4D770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.769 168.599L341.609 144.749H341.659L341.809 168.599H341.769Z",
    fill: "#F4D76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.72 168.599L341.57 144.749H341.61L341.77 168.599H341.72Z",
    fill: "#F4D66E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.673 168.599L341.523 144.749H341.573L341.723 168.599H341.673Z",
    fill: "#F3D66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.629 168.599L341.469 144.749H341.519L341.669 168.599H341.629Z",
    fill: "#F3D66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.58 168.599L341.43 144.749H341.47L341.63 168.599H341.58Z",
    fill: "#F3D56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.533 168.599L341.383 144.749H341.433L341.583 168.599H341.533Z",
    fill: "#F3D56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.478 168.599L341.328 144.749H341.378L341.528 168.599H341.478Z",
    fill: "#F3D569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.439 168.599L341.289 144.749H341.329L341.479 168.599H341.439Z",
    fill: "#F3D568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.392 168.599L341.242 144.749H341.292L341.442 168.599H341.392Z",
    fill: "#F3D467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.337 168.599L341.188 144.749H341.237L341.388 168.599H341.337Z",
    fill: "#F3D466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.298 168.599L341.148 144.749H341.188L341.338 168.599H341.298Z",
    fill: "#F3D465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.252 168.599L341.102 144.749H341.152L341.302 168.599H341.252Z",
    fill: "#F3D364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.197 168.599L341.047 144.749H341.097L341.247 168.599H341.197Z",
    fill: "#F3D363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.158 168.599L341.008 144.749H341.048L341.198 168.599H341.158Z",
    fill: "#F3D362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.111 168.599L340.961 144.749H341.011L341.161 168.599H341.111Z",
    fill: "#F2D361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.064 168.599L340.914 144.749H340.964L341.114 168.599H341.064Z",
    fill: "#F2D260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.017 168.599L340.867 144.749H340.907L341.057 168.599H341.017Z",
    fill: "#F2D25F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.97 168.599L340.82 144.749H340.87L341.02 168.599H340.97Z",
    fill: "#F2D25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.923 168.599L340.773 144.749H340.823L340.973 168.599H340.923Z",
    fill: "#F2D15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.884 168.599L340.734 144.749H340.774L340.924 168.599H340.884Z",
    fill: "#F2D15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.83 168.599L340.68 144.749H340.73L340.88 168.599H340.83Z",
    fill: "#F2D15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.783 168.599L340.633 144.749H340.683L340.833 168.599H340.783Z",
    fill: "#F2D15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.744 168.599L340.594 144.749H340.634L340.784 168.599H340.744Z",
    fill: "#F2D059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.689 168.599L340.539 144.749H340.589L340.739 168.599H340.689Z",
    fill: "#F2D058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.642 168.599L340.492 144.749H340.542L340.692 168.599H340.642Z",
    fill: "#F2D057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.603 168.599L340.453 144.749H340.493L340.643 168.599H340.603Z",
    fill: "#F2CF56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.548 168.599L340.398 144.749H340.448L340.598 168.599H340.548Z",
    fill: "#F2CF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.502 168.599L340.352 144.749H340.402L340.552 168.599H340.502Z",
    fill: "#F1CF54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.462 168.599L340.312 144.749H340.353L340.503 168.599H340.462Z",
    fill: "#F1CF53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.408 168.599L340.258 144.749H340.308L340.458 168.599H340.408Z",
    fill: "#F1CE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.361 168.599L340.211 144.749H340.261L340.411 168.599H340.361Z",
    fill: "#F1CE51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.322 168.599L340.172 144.749H340.212L340.362 168.599H340.322Z",
    fill: "#F1CE50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.267 168.599L340.117 144.749H340.167L340.317 168.599H340.267Z",
    fill: "#F1CD4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.22 168.599L340.07 144.749H340.12L340.27 168.599H340.22Z",
    fill: "#F1CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.181 168.599L340.031 144.749H340.071L340.221 168.599H340.181Z",
    fill: "#F1CD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.134 168.599L339.984 144.749H340.034L340.184 168.599H340.134Z",
    fill: "#F1CD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.08 168.599L339.93 144.749H339.98L340.13 168.599H340.08Z",
    fill: "#F1CC4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.041 168.599L339.891 144.749H339.931L340.081 168.599H340.041Z",
    fill: "#F1CC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.994 168.599L339.844 144.749H339.894L340.044 168.599H339.994Z",
    fill: "#F1CC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.939 168.599L339.789 144.749H339.839L339.989 168.599H339.939Z",
    fill: "#F1CB48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.9 168.599L339.75 144.749H339.79L339.94 168.599H339.9Z",
    fill: "#F0CB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.853 168.599L339.703 144.749H339.753L339.903 168.599H339.853Z",
    fill: "#F0CB46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.798 168.599L339.648 144.749H339.698L339.848 168.599H339.798Z",
    fill: "#F0CB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.759 168.599L339.609 144.749H339.649L339.799 168.599H339.759Z",
    fill: "#F0CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.712 168.599L339.562 144.749H339.612L339.763 168.599H339.712Z",
    fill: "#F0CA43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.658 168.599L339.508 144.749H339.558L339.708 168.599H339.658Z",
    fill: "#F0CA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.619 168.599L339.469 144.749H339.509L339.659 168.599H339.619Z",
    fill: "#F0C941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.572 168.599L339.422 144.749H339.472L339.622 168.599H339.572Z",
    fill: "#F0C940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.517 168.599L339.367 144.749H339.417L339.567 168.599H339.517Z",
    fill: "#F0C93F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.478 168.599L339.328 144.749H339.368L339.518 168.599H339.478Z",
    fill: "#F0C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.431 168.599L339.281 144.749H339.331L339.481 168.599H339.431Z",
    fill: "#F0C83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.384 168.599L339.234 144.749H339.284L339.434 168.599H339.384Z",
    fill: "#F0C83C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.337 168.599L339.188 144.749H339.228L339.378 168.599H339.337Z",
    fill: "#EFC83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.291 168.599L339.141 144.749H339.191L339.341 168.599H339.291Z",
    fill: "#EFC73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.244 168.599L339.094 144.749H339.144L339.294 168.599H339.244Z",
    fill: "#EFC739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.197 168.599L339.047 144.749H339.087L339.237 168.599H339.197Z",
    fill: "#EFC738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.15 168.599L339 144.749H339.05L339.2 168.599H339.15Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.103 168.599L338.953 144.749H339.003L339.153 168.599H339.103Z",
    fill: "#EFC636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.064 168.599L338.914 144.749H338.954L339.104 168.599H339.064Z",
    fill: "#EFC635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.009 168.599L338.859 144.749H338.909L339.059 168.599H339.009Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.962 168.599L338.812 144.749H338.862L339.013 168.599H338.962Z",
    fill: "#EFC633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.918 168.599L338.758 144.749H338.808L338.958 168.599H338.918Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.869 168.599L338.719 144.749H338.759L338.919 168.599H338.869Z",
    fill: "#EFC531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.822 168.599L338.672 144.749H338.722L338.872 168.599H338.822Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.777 168.599L338.617 144.749H338.667L338.817 168.599H338.777Z",
    fill: "#EFC42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.728 168.599L338.578 144.749H338.618L338.778 168.599H338.728Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.681 168.599L338.531 144.749H338.581L338.731 168.599H338.681Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.644 168.599L338.484 144.749H338.534L338.684 168.599H338.644Z",
    fill: "#EEC42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.587 168.599L338.438 144.749H338.478L338.638 168.599H338.587Z",
    fill: "#EEC32B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.541 168.599L338.391 144.749H338.441L338.591 168.599H338.541Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.494 168.599L338.344 144.749H338.394L338.544 168.599H338.494Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.447 168.599L338.297 144.749H338.337L338.487 168.599H338.447Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.4 168.599L338.25 144.749H338.3L338.45 168.599H338.4Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.353 168.599L338.203 144.749H338.253L338.403 168.599H338.353Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.314 168.599L338.164 144.749H338.204L338.354 168.599H338.314Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.259 168.599L338.109 144.749H338.159L338.309 168.599H338.259Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.212 168.599L338.062 144.749H338.112L338.263 168.599H338.212Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.173 168.599L338.023 144.749H338.063L338.213 168.599H338.173Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.119 168.599L337.969 144.749H338.019L338.169 168.599H338.119Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.072 168.599L337.922 144.749H337.972L338.122 168.599H338.072Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.031 168.599L337.891 146.349V144.749H337.921L338.071 168.599H338.031Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.981 168.599L337.891 153.749V146.349L338.031 168.599H337.981Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.931 168.599L337.891 161.149V153.749L337.981 168.599H337.931Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.891 168.599V168.559V161.149L337.931 168.599H337.891Z",
    fill: "#EDBF1C"
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M343.019 160.38C344.189 161.92 347.439 165.76 353.169 167.7C358.089 169.37 362.329 168.78 364.259 168.39C364.129 169.05 363.999 169.71 363.859 170.37C362.209 170.92 357.589 172.23 352.079 170.57C345.739 168.66 342.439 164.1 341.539 162.75C342.029 161.96 342.529 161.17 343.019 160.37V160.38Z",
    fill: "#EDBF1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 160,
    width: 24,
    height: 12
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M343.019 160.38C344.189 161.92 347.439 165.76 353.169 167.7C358.089 169.37 362.329 168.78 364.259 168.39C364.129 169.05 363.999 169.71 363.859 170.37C362.209 170.92 357.589 172.23 352.079 170.57C345.739 168.66 342.439 164.1 341.539 162.75C342.029 161.96 342.529 161.17 343.019 160.37V160.38Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1342_37795)"
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M363.832 169.98C361.542 170.46 356.942 171.1 351.582 169.46C347.892 168.33 345.202 166.53 343.562 165.23C344.192 166.93 345.503 169.58 348.163 171.69C348.713 172.12 354.922 176.9 360.112 174.14C362.242 173.01 363.333 171.07 363.823 169.98H363.832Z",
    fill: "#E9AB21"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 345,
    y: 162,
    width: 21,
    height: 8
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M351.319 162.611C349.479 162.301 345.559 161.621 345.079 162.751C344.609 163.861 347.679 166.381 350.309 167.731C353.719 169.471 356.949 169.531 359.409 169.551C362.199 169.571 364.789 169.591 365.009 168.741C365.399 167.261 358.279 163.811 351.309 162.611H351.319Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.98L355.109 169.58H344.609V163.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.911L355.239 169.581H355.109L344.609 163.981V163.911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.841L355.379 169.581H355.239L344.609 163.911V163.841Z",
    fill: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.761L355.519 169.581H355.379L344.609 163.841V163.761Z",
    fill: "#FEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.69L355.659 169.58H355.519L344.609 163.76V163.69Z",
    fill: "#FEFCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.611L355.789 169.581H355.659L344.609 163.691V163.611Z",
    fill: "#FEFBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.541L355.929 169.581H355.789L344.609 163.611V163.541Z",
    fill: "#FEFAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.471L356.069 169.581H355.929L344.609 163.541V163.471Z",
    fill: "#FDF9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.391L356.209 169.581H356.069L344.609 163.471V163.391Z",
    fill: "#FDF8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.321L356.349 169.581H356.209L344.609 163.391V163.321Z",
    fill: "#FDF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.251L356.479 169.581H356.349L344.609 163.321V163.251Z",
    fill: "#FCF6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.171L356.619 169.581H356.479L344.609 163.251V163.171Z",
    fill: "#FCF5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.101L356.759 169.581H356.619L344.609 163.171V163.101Z",
    fill: "#FCF4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.031L356.899 169.581H356.759L344.609 163.101V163.031Z",
    fill: "#FCF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.951L357.029 169.581H356.899L344.609 163.031V162.951Z",
    fill: "#FBF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.881L357.169 169.581H357.029L344.609 162.951V162.881Z",
    fill: "#FBF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.811L357.309 169.581H357.169L344.609 162.881V162.811Z",
    fill: "#FBF0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.73L357.449 169.58H357.309L344.609 162.81V162.73Z",
    fill: "#FBEFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.661L357.579 169.581H357.449L344.609 162.731V162.661Z",
    fill: "#FAEEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.591L357.719 169.581H357.579L344.609 162.661V162.591Z",
    fill: "#FAEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.511L357.859 169.581H357.719L344.609 162.591V162.511Z",
    fill: "#FAEDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.44L357.999 169.58H357.859L344.609 162.51V162.44Z",
    fill: "#FAECBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.371L358.139 169.581H357.999L344.609 162.441V162.371Z",
    fill: "#F9EBB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.291L358.269 169.581H358.139L344.609 162.371V162.291Z",
    fill: "#F9EAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.221L358.409 169.581H358.269L344.609 162.291V162.221Z",
    fill: "#F9E9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.15L358.549 169.58H358.409L344.609 162.22V162.15Z",
    fill: "#F9E8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.071L358.689 169.581H358.549L344.609 162.151V162.071Z",
    fill: "#F8E8AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.001L358.819 169.581H358.689L344.609 162.071V162.001Z",
    fill: "#F8E7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.921L358.959 169.581H358.819L344.609 162.001V161.921Z",
    fill: "#F8E6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.851L359.099 169.581H358.959L344.609 161.921V161.851Z",
    fill: "#F8E5A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.781L359.239 169.581H359.099L344.609 161.851V161.781Z",
    fill: "#F8E5A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.701L359.369 169.581H359.239L344.609 161.781V161.701Z",
    fill: "#F7E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.631L359.509 169.581H359.369L344.609 161.701V161.631Z",
    fill: "#F7E39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.739 161.631L359.649 169.581H359.509L344.609 161.631H344.739Z",
    fill: "#F7E29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.882 161.631L359.792 169.581H359.652L344.742 161.631H344.882Z",
    fill: "#F7E297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.023 161.631L359.933 169.581H359.793L344.883 161.631H345.023Z",
    fill: "#F7E195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.156 161.631L360.056 169.581H359.926L345.016 161.631H345.156Z",
    fill: "#F6E092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.286 161.631L360.196 169.581H360.056L345.156 161.631H345.286Z",
    fill: "#F6E090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.429 161.631L360.339 169.581H360.199L345.289 161.631H345.429Z",
    fill: "#F6DF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.57 161.631L360.48 169.581H360.34L345.43 161.631H345.57Z",
    fill: "#F6DE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.71 161.631L360.61 169.581H360.48L345.57 161.631H345.71Z",
    fill: "#F6DE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.841 161.631L360.751 169.581H360.611L345.711 161.631H345.841Z",
    fill: "#F5DD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.976 161.631L360.886 169.581H360.746L345.836 161.631H345.976Z",
    fill: "#F5DC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.117 161.631L361.027 169.581H360.887L345.977 161.631H346.117Z",
    fill: "#F5DC82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.257 161.631L361.157 169.581H361.027L346.117 161.631H346.257Z",
    fill: "#F5DB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.398 161.631L361.298 169.581H361.158L346.258 161.631H346.398Z",
    fill: "#F5DB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.528 161.631L361.438 169.581H361.298L346.398 161.631H346.528Z",
    fill: "#F5DA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.671 161.631L361.581 169.581H361.441L346.531 161.631H346.671Z",
    fill: "#F4DA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.812 161.631L361.722 169.581H361.582L346.672 161.631H346.812Z",
    fill: "#F4D978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.953 161.631L361.853 169.581H361.723L346.812 161.631H346.953Z",
    fill: "#F4D876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.083 161.631L361.993 169.581H361.853L346.953 161.631H347.083Z",
    fill: "#F4D874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.218 161.631L362.128 169.581H361.988L347.078 161.631H347.218Z",
    fill: "#F4D772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.359 161.631L362.269 169.581H362.129L347.219 161.631H347.359Z",
    fill: "#F4D770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.499 161.631L362.399 169.581H362.269L347.359 161.631H347.499Z",
    fill: "#F4D66E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.63 161.631L362.54 169.581H362.4L347.5 161.631H347.63Z",
    fill: "#F3D66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.773 161.631L362.683 169.581H362.543L347.633 161.631H347.773Z",
    fill: "#F3D56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.906 161.631L362.816 169.581H362.676L347.766 161.631H347.906Z",
    fill: "#F3D569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.046 161.631L362.946 169.581H362.816L347.906 161.631H348.046Z",
    fill: "#F3D467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.187 161.631L363.087 169.581H362.947L348.047 161.631H348.187Z",
    fill: "#F3D466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.318 161.631L363.228 169.581H363.087L348.188 161.631H348.318Z",
    fill: "#F3D364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.46 161.631L363.37 169.581H363.23L348.32 161.631H348.46Z",
    fill: "#F3D362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.601 161.631L363.511 169.581H363.371L348.461 161.631H348.601Z",
    fill: "#F2D261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.742 161.631L363.642 169.581H363.512L348.602 161.631H348.742Z",
    fill: "#F2D25F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.872 161.631L363.782 169.581H363.642L348.742 161.631H348.872Z",
    fill: "#F2D15E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.007 161.631L363.917 169.581H363.777L348.867 161.631H349.007Z",
    fill: "#F2D15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.148 161.631L364.058 169.581H363.918L349.008 161.631H349.148Z",
    fill: "#F2D15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.288 161.631L364.188 169.581H364.058L349.148 161.631H349.288Z",
    fill: "#F2D059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.419 161.631L364.329 169.581H364.189L349.289 161.631H349.419Z",
    fill: "#F2D058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.562 161.631L364.472 169.581H364.332L349.422 161.631H349.562Z",
    fill: "#F2CF56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.703 161.631L364.612 169.581H364.473L349.562 161.631H349.703Z",
    fill: "#F2CF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.843 161.631L364.743 169.581H364.613L349.703 161.631H349.843Z",
    fill: "#F1CF53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.976 161.631L364.876 169.581H364.736L349.836 161.631H349.976Z",
    fill: "#F1CE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.107 161.631L365.017 169.581H364.877L349.977 161.631H350.107Z",
    fill: "#F1CE51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.249 161.631L365.159 169.581H365.019L350.109 161.631H350.249Z",
    fill: "#F1CD4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.39 161.631L365.3 169.581H365.16L350.25 161.631H350.39Z",
    fill: "#F1CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.531 161.631L365.411 169.571V169.581H365.301L350.391 161.631H350.531Z",
    fill: "#F1CD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.661 161.631L365.411 169.501V169.571L350.531 161.631H350.661Z",
    fill: "#F1CC4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.796 161.631L365.406 169.421V169.501L350.656 161.631H350.796Z",
    fill: "#F1CC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.937 161.631L365.407 169.351V169.421L350.797 161.631H350.937Z",
    fill: "#F1CC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.077 161.631L365.408 169.281V169.351L350.938 161.631H351.077Z",
    fill: "#F0CB48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.208 161.631L365.408 169.201V169.281L351.078 161.631H351.208Z",
    fill: "#F0CB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.351 161.631L365.411 169.131V169.201L351.211 161.631H351.351Z",
    fill: "#F0CB46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.492 161.631L365.412 169.061V169.131L351.352 161.631H351.492Z",
    fill: "#F0CA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.632 161.631L365.412 168.981V169.061L351.492 161.631H351.632Z",
    fill: "#F0CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.773 161.631L365.413 168.911V168.981L351.633 161.631H351.773Z",
    fill: "#F0CA43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.896 161.631L365.406 168.841V168.911L351.766 161.631H351.896Z",
    fill: "#F0CA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.038 161.631L365.408 168.761V168.841L351.898 161.631H352.038Z",
    fill: "#F0C941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.179 161.631L365.409 168.691V168.761L352.039 161.631H352.179Z",
    fill: "#F0C940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.32 161.631L365.41 168.621V168.691L352.18 161.631H352.32Z",
    fill: "#F0C93F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.45 161.631L365.41 168.541V168.621L352.32 161.631H352.45Z",
    fill: "#F0C83E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.593 161.631L365.413 168.471V168.541L352.453 161.631H352.593Z",
    fill: "#F0C83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.726 161.631L365.406 168.391V168.471L352.586 161.631H352.726Z",
    fill: "#F0C83C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.867 161.631L365.407 168.321V168.391L352.727 161.631H352.867Z",
    fill: "#EFC83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.997 161.631L365.407 168.251V168.321L352.867 161.631H352.997Z",
    fill: "#EFC73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.14 161.631L365.41 168.171V168.251L353 161.631H353.14Z",
    fill: "#EFC739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.281 161.631L365.411 168.101V168.171L353.141 161.631H353.281Z",
    fill: "#EFC738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.421 161.631L365.411 168.031V168.101L353.281 161.631H353.421Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.562 161.631L365.412 167.951V168.031L353.422 161.631H353.562Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.693 161.631L365.413 167.881V167.951L353.562 161.631H353.693Z",
    fill: "#EFC636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.827 161.631L365.408 167.811V167.881L353.688 161.631H353.827Z",
    fill: "#EFC635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.968 161.631L365.408 167.731V167.811L353.828 161.631H353.968Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.109 161.631L365.409 167.661V167.731L353.969 161.631H354.109Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.239 161.631L365.409 167.591V167.661L354.109 161.631H354.239Z",
    fill: "#EFC533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.382 161.631L365.412 167.511V167.591L354.242 161.631H354.382Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.523 161.631L365.413 167.441V167.511L354.383 161.631H354.523Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.656 161.631L365.406 167.371V167.441L354.516 161.631H354.656Z",
    fill: "#EFC531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.786 161.631L365.406 167.291V167.371L354.656 161.631H354.786Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.929 161.631L365.409 167.221V167.291L354.789 161.631H354.929Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07 161.631L365.41 167.151V167.221L354.93 161.631H355.07Z",
    fill: "#EFC42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.21 161.631L365.41 167.071V167.151L355.07 161.631H355.21Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.351 161.631L365.411 167.001V167.071L355.211 161.631H355.351Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.482 161.631L365.412 166.931V167.001L355.352 161.631H355.482Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 161.631L365.407 166.851V166.931L355.477 161.631H355.617Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.757 161.631L365.407 166.781V166.851L355.617 161.631H355.757Z",
    fill: "#EEC42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.898 161.631L365.408 166.701V166.781L355.758 161.631H355.898Z",
    fill: "#EEC32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.028 161.631L365.408 166.631V166.701L355.898 161.631H356.028Z",
    fill: "#EEC32B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.171 161.631L365.411 166.561V166.631L356.031 161.631H356.171Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.312 161.631L365.412 166.481V166.561L356.172 161.631H356.312Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.453 161.631L365.413 166.411V166.481L356.312 161.631H356.453Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.583 161.631L365.413 166.341V166.411L356.453 161.631H356.583Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.718 161.631L365.408 166.261V166.341L356.578 161.631H356.718Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.859 161.631L365.409 166.191V166.261L356.719 161.631H356.859Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.999 161.631L365.409 166.121V166.191L356.859 161.631H356.999Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.14 161.631L365.41 166.041V166.121L357 161.631H357.14Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.271 161.631L365.411 165.971V166.041L357.141 161.631H357.271Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.406 161.631L365.406 165.901V165.971L357.266 161.631H357.406Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.546 161.631L365.406 165.821V165.901L357.406 161.631H357.546Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 161.631L365.407 165.751V165.821L357.547 161.631H357.687Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.818 161.631L365.408 165.681V165.751L357.688 161.631H357.818Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.96 161.631L365.41 165.601V165.681L357.82 161.631H357.96Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.101 161.631L365.411 165.531V165.601L357.961 161.631H358.101Z",
    fill: "#EEC125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.242 161.631L365.412 165.461V165.531L358.102 161.631H358.242Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.372 161.631L365.412 165.381V165.461L358.242 161.631H358.372Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.507 161.631L365.407 165.311V165.381L358.367 161.631H358.507Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.648 161.631L365.408 165.231V165.311L358.508 161.631H358.648Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.788 161.631L365.408 165.161V165.231L358.648 161.631H358.788Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.929 161.631L365.409 165.091V165.161L358.789 161.631H358.929Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.06 161.631L365.41 165.011V165.091L358.93 161.631H359.06Z",
    fill: "#EEC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.203 161.631L365.413 164.941V165.011L359.062 161.631H359.203Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.343 161.631L365.413 164.871V164.941L359.203 161.631H359.343Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.476 161.631L365.406 164.791V164.871L359.336 161.631H359.476Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.607 161.631L365.407 164.721V164.791L359.477 161.631H359.607Z",
    fill: "#EDC121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.749 161.631L365.409 164.651V164.721L359.609 161.631H359.749Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.89 161.631L365.41 164.571V164.651L359.75 161.631H359.89Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.031 161.631L365.411 164.501V164.571L359.891 161.631H360.031Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.161 161.631L365.411 164.431V164.501L360.031 161.631H360.161Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.296 161.631L365.406 164.351V164.431L360.156 161.631H360.296Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.437 161.631L365.407 164.281V164.351L360.297 161.631H360.437Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.577 161.631L365.408 164.211V164.281L360.438 161.631H360.577Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.718 161.631L365.408 164.131V164.211L360.578 161.631H360.718Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.849 161.631L365.409 164.061V164.131L360.719 161.631H360.849Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.992 161.631L365.412 163.991V164.061L360.852 161.631H360.992Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.132 161.631L365.412 163.911V163.991L360.992 161.631H361.132Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.273 161.631L365.413 163.841V163.911L361.133 161.631H361.273Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.396 161.631L365.406 163.771V163.841L361.266 161.631H361.396Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.538 161.631L365.408 163.691V163.771L361.398 161.631H361.538Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.679 161.631L365.409 163.621V163.691L361.539 161.631H361.679Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.82 161.631L365.41 163.541V163.621L361.68 161.631H361.82Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.95 161.631L365.41 163.471V163.541L361.82 161.631H361.95Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.093 161.631L365.413 163.401V163.471L361.953 161.631H362.093Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.226 161.631L365.406 163.321V163.401L362.086 161.631H362.226Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.367 161.631L365.407 163.251V163.321L362.227 161.631H362.367Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.507 161.631L365.407 163.181V163.251L362.367 161.631H362.507Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.638 161.631L365.408 163.101V163.181L362.508 161.631H362.638Z",
    fill: "#EDBF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.781 161.631L365.411 163.031V163.101L362.641 161.631H362.781Z",
    fill: "#EDBF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.921 161.631L365.411 162.961V163.031L362.781 161.631H362.921Z",
    fill: "#EDBF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.062 161.631L365.412 162.881V162.961L362.922 161.631H363.062Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.193 161.631L365.413 162.811V162.881L363.062 161.631H363.193Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.327 161.631L365.408 162.741V162.811L363.188 161.631H363.327Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.468 161.631L365.408 162.661V162.741L363.328 161.631H363.468Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.609 161.631L365.409 162.591V162.661L363.469 161.631H363.609Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.739 161.631L365.409 162.521V162.591L363.609 161.631H363.739Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.882 161.631L365.412 162.441V162.521L363.742 161.631H363.882Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.023 161.631L365.413 162.371V162.441L363.883 161.631H364.023Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.156 161.631L365.406 162.301V162.371L364.016 161.631H364.156Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.296 161.631L365.406 162.221V162.301L364.156 161.631H364.296Z",
    fill: "#EDBF1D"
  }))))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M366.211 171.31C368.254 170.547 369.542 168.939 369.086 167.718C368.63 166.497 366.604 166.125 364.56 166.888C362.516 167.651 361.229 169.259 361.685 170.481C362.141 171.702 364.167 172.073 366.211 171.31Z",
    fill: "#E9AB21"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M366.108 171.352C368.043 170.63 369.242 169.054 368.786 167.833C368.33 166.612 366.392 166.208 364.457 166.93C362.522 167.653 361.323 169.228 361.778 170.449C362.234 171.67 364.173 172.075 366.108 171.352Z",
    fill: "#EDBF1C"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.628 167.51C368.698 167.62 368.807 167.82 368.857 168.07C368.907 168.34 368.877 168.55 368.857 168.7C368.847 168.79 368.798 169.03 368.668 169.32C368.608 169.45 368.427 169.82 367.987 170.24C367.357 170.85 366.607 171.17 366.188 171.32C366.528 171.17 367.578 170.64 368.198 169.42C368.598 168.62 368.638 167.89 368.628 167.49V167.51Z",
    fill: "#F4F3F9"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.573 211.699C343.263 211.349 345.813 214.079 347.463 216.829C348.473 218.509 348.693 219.439 349.893 220.159C351.153 220.919 351.953 220.519 353.763 220.899C356.583 221.489 359.273 223.459 359.053 224.379C358.843 225.269 355.973 224.779 351.863 225.519C351.233 225.639 350.623 225.769 350.033 225.919C350.003 225.919 349.973 225.939 349.943 225.939C349.943 225.999 349.943 226.049 349.943 226.109C349.933 226.499 349.873 226.909 349.763 227.319C349.583 228.039 349.263 228.789 348.813 229.549C346.753 233.129 342.023 237.119 335.883 240.099C335.263 240.399 334.653 240.679 334.033 240.939C325.143 244.759 316.813 244.869 314.943 240.989C314.583 240.239 314.483 239.399 314.623 238.499C315.253 234.369 320.793 228.909 328.633 225.109C330.373 224.269 332.103 223.569 333.773 223.009C337.553 221.749 341.073 221.209 343.863 221.399C343.803 219.899 343.633 218.299 343.313 216.619C342.833 214.129 342.053 211.959 342.603 211.679L342.573 211.699Z",
    fill: "#090E16"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M342.253 211.05C342.943 210.7 345.493 213.43 347.143 216.18C348.153 217.86 348.373 218.79 349.573 219.51C350.833 220.27 351.633 219.87 353.443 220.25C356.263 220.84 358.953 222.81 358.733 223.73C358.523 224.62 355.653 224.13 351.543 224.87C350.913 224.99 350.303 225.12 349.713 225.27C349.683 225.27 349.653 225.29 349.623 225.29C349.623 225.35 349.623 225.4 349.623 225.46C349.613 225.85 349.553 226.26 349.443 226.67C349.263 227.39 348.943 228.14 348.493 228.9C346.433 232.48 341.703 236.47 335.563 239.45C334.943 239.75 334.333 240.03 333.713 240.29C324.823 244.11 316.493 244.22 314.623 240.34C314.263 239.59 314.163 238.75 314.303 237.85C314.933 233.72 320.473 228.26 328.313 224.46C330.053 223.62 331.783 222.92 333.453 222.36C337.233 221.1 340.753 220.56 343.543 220.75C343.483 219.25 343.313 217.65 342.993 215.97C342.513 213.48 341.733 211.31 342.283 211.03L342.253 211.05Z",
    fill: "#858F9E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 333,
    y: 211,
    width: 26,
    height: 19
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M342.271 211.079C342.961 210.729 345.511 213.459 347.161 216.209C348.171 217.889 348.391 218.819 349.591 219.539C350.851 220.299 351.651 219.899 353.461 220.279C356.281 220.869 358.971 222.839 358.751 223.759C358.541 224.649 355.671 224.159 351.561 224.899C350.931 225.019 350.321 225.149 349.731 225.299C349.691 225.369 349.661 225.429 349.631 225.489C349.621 225.879 349.561 226.289 349.451 226.699C349.271 227.419 348.951 228.169 348.501 228.929C345.331 229.329 342.311 229.009 339.771 228.059C339.661 228.019 339.551 227.979 339.451 227.929C336.661 226.809 334.511 224.919 333.461 222.389C337.241 221.129 340.761 220.589 343.551 220.779C343.491 219.279 343.321 217.679 343.001 215.999C342.521 213.509 341.741 211.339 342.291 211.059L342.271 211.079Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.969 221.799L334.819 218.919L350.079 228.749L338.939 234.139L332.969 221.799Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.82 218.919L334.91 218.789L350.25 228.659L350.08 228.749L334.82 218.919Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.906 218.788L334.996 218.648L350.416 228.578L350.246 228.658L334.906 218.788Z",
    fill: "#848E9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 218.649L335.08 218.509L350.59 228.499L350.42 228.579L335 218.649Z",
    fill: "#838D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.078 218.509L335.168 218.369L350.758 228.409L350.588 228.499L335.078 218.509Z",
    fill: "#828B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.172 218.369L335.262 218.239L350.932 228.329L350.762 228.409L335.172 218.369Z",
    fill: "#808A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.258 218.239L335.348 218.099L351.108 228.249L350.928 228.329L335.258 218.239Z",
    fill: "#7F8998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.352 218.099L335.442 217.959L351.282 228.169L351.112 228.249L335.352 218.099Z",
    fill: "#7E8896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.438 217.959L335.527 217.829L351.448 228.079L351.277 228.169L335.438 217.959Z",
    fill: "#7D8795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.531 217.828L335.611 217.688L351.621 227.998L351.451 228.078L335.531 217.828Z",
    fill: "#7C8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.609 217.689L335.699 217.549L351.789 227.919L351.619 227.999L335.609 217.689Z",
    fill: "#7B8493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.695 217.549L335.785 217.419L351.955 227.829L351.785 227.919L335.695 217.549Z",
    fill: "#798391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.789 217.418L335.879 217.278L352.139 227.748L351.959 227.828L335.789 217.418Z",
    fill: "#788290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.875 217.279L335.965 217.139L352.305 227.669L352.135 227.749L335.875 217.279Z",
    fill: "#77818F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.969 217.139L336.049 217.009L352.479 227.579L352.309 227.669L335.969 217.139Z",
    fill: "#767F8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.047 217.009L336.137 216.869L352.647 227.499L352.477 227.579L336.047 217.009Z",
    fill: "#757E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.141 216.869L336.231 216.729L352.821 227.419L352.651 227.499L336.141 216.869Z",
    fill: "#747D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.227 216.729L336.317 216.599L352.987 227.329L352.817 227.419L336.227 216.729Z",
    fill: "#737C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.32 216.599L336.41 216.459L353.16 227.249L352.99 227.329L336.32 216.599Z",
    fill: "#727B89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.406 216.458L336.486 216.318L353.336 227.168L353.156 227.248L336.406 216.458Z",
    fill: "#707A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.492 216.318L336.582 216.188L353.512 227.088L353.342 227.168L336.492 216.318Z",
    fill: "#6F7886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.578 216.189L336.668 216.049L353.678 226.999L353.508 227.089L336.578 216.189Z",
    fill: "#6E7785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.672 216.049L336.762 215.909L353.852 226.919L353.682 226.999L336.672 216.049Z",
    fill: "#6D7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.758 215.908L336.848 215.778L354.018 226.838L353.848 226.918L336.758 215.908Z",
    fill: "#6C7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.852 215.779L336.942 215.639L354.192 226.749L354.022 226.839L336.852 215.779Z",
    fill: "#6B7481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.938 215.639L337.017 215.499L354.367 226.669L354.188 226.749L336.938 215.639Z",
    fill: "#6A7380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.016 215.498L337.106 215.358L354.536 226.588L354.366 226.668L337.016 215.498Z",
    fill: "#69717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.109 215.359L337.199 215.229L354.709 226.499L354.539 226.589L337.109 215.359Z",
    fill: "#68707E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.195 215.229L337.285 215.089L354.875 226.419L354.705 226.499L337.195 215.229Z",
    fill: "#666F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.289 215.089L337.379 214.949L355.049 226.339L354.879 226.419L337.289 215.089Z",
    fill: "#656E7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.375 214.948L337.455 214.818L355.215 226.248L355.045 226.338L337.375 214.948Z",
    fill: "#646D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.461 214.819L337.551 214.679L355.391 226.169L355.221 226.249L337.461 214.819Z",
    fill: "#636C79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.547 214.679L337.637 214.539L355.567 226.089L355.387 226.169L337.547 214.679Z",
    fill: "#626B78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.641 214.539L337.731 214.409L355.741 226.009L355.571 226.089L337.641 214.539Z",
    fill: "#616A76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.727 214.409L337.817 214.269L355.907 225.919L355.737 226.009L337.727 214.409Z",
    fill: "#606875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.82 214.269L337.9 214.129L356.08 225.839L355.91 225.919L337.82 214.269Z",
    fill: "#5F6774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.898 214.129L337.988 213.999L356.248 225.759L356.078 225.839L337.898 214.129Z",
    fill: "#5E6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.992 213.998L338.082 213.858L356.422 225.668L356.252 225.758L337.992 213.998Z",
    fill: "#5D6572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.078 213.859L338.168 213.719L356.598 225.589L356.418 225.669L338.078 213.859Z",
    fill: "#5C6471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.172 213.719L338.262 213.589L356.772 225.509L356.602 225.589L338.172 213.719Z",
    fill: "#5B636F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.258 213.589L338.338 213.449L356.938 225.419L356.768 225.509L338.258 213.589Z",
    fill: "#59626E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.336 213.449L338.426 213.309L357.106 225.339L356.936 225.419L338.336 213.449Z",
    fill: "#58616D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.43 213.309L338.52 213.179L357.28 225.259L357.11 225.339L338.43 213.309Z",
    fill: "#575F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.516 213.179L338.606 213.039L357.446 225.169L357.276 225.259L338.516 213.179Z",
    fill: "#565E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.609 213.038L338.699 212.898L357.619 225.088L357.449 225.168L338.609 213.038Z",
    fill: "#555D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.695 212.899L338.785 212.769L357.795 225.009L357.615 225.089L338.695 212.899Z",
    fill: "#545C68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.789 212.769V212.749L338.949 212.679L357.969 224.929L357.799 225.009L338.789 212.769Z",
    fill: "#535B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.115 212.589L358.135 224.839L357.965 224.929L338.945 212.679L339.115 212.589Z",
    fill: "#525A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.287 212.509L358.307 224.759L358.137 224.839L339.117 212.589L339.287 212.509Z",
    fill: "#515965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.459 212.429L358.479 224.679L358.309 224.759L339.289 212.509L339.459 212.429Z",
    fill: "#505864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.631 212.339L358.651 224.589L358.481 224.679L339.461 212.429L339.631 212.339Z",
    fill: "#4F5763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.805 212.259L358.825 224.509L358.645 224.589L339.625 212.339L339.805 212.259Z",
    fill: "#4E5662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.983 212.179L359.003 224.429L358.832 224.509L339.812 212.259L339.983 212.179Z",
    fill: "#4D5560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.147 212.089L359.167 224.339L358.997 224.429L339.977 212.179L340.147 212.089Z",
    fill: "#4C545F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.318 212.009L359.338 224.259L359.168 224.339L340.148 212.089L340.318 212.009Z",
    fill: "#4B535E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.49 211.929L359.51 224.179L359.34 224.259L340.32 212.009L340.49 211.929Z",
    fill: "#4A515D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.662 211.849L359.522 223.989L359.592 224.139L359.512 224.179L340.492 211.929L340.662 211.849Z",
    fill: "#49505C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.826 211.759L359.376 223.709L359.516 223.989L340.656 211.849L340.826 211.759Z",
    fill: "#484F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.008 211.679L359.238 223.419L359.378 223.709L340.828 211.759L341.008 211.679Z",
    fill: "#474E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.178 211.599L359.108 223.139L359.238 223.419L341.008 211.679L341.178 211.599Z",
    fill: "#464D59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.35 211.509L358.97 222.859L359.11 223.139L341.18 211.599L341.35 211.509Z",
    fill: "#454C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.522 211.429L358.842 222.579L358.972 222.859L341.352 211.509L341.522 211.429Z",
    fill: "#444B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.686 211.349L358.696 222.299L358.836 222.579L341.516 211.429L341.686 211.349Z",
    fill: "#434A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.857 211.259L358.557 222.019L358.698 222.299L341.688 211.349L341.857 211.259Z",
    fill: "#424954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.039 211.179L358.429 221.739L358.559 222.019L341.859 211.259L342.039 211.179Z",
    fill: "#414853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.209 211.099L358.289 221.459L358.429 221.739L342.039 211.179L342.209 211.099Z",
    fill: "#404752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.381 211.009L358.151 221.169L358.291 221.459L342.211 211.099L342.381 211.009Z",
    fill: "#3F4651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.545 210.929L358.015 220.889L358.145 221.169L342.375 211.009L342.545 210.929Z",
    fill: "#3E4550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.717 210.849L357.877 220.609L358.017 220.889L342.547 210.929L342.717 210.849Z",
    fill: "#3D444F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.889 210.769L357.749 220.329L357.879 220.609L342.719 210.849L342.889 210.769Z",
    fill: "#3C434E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.061 210.679L357.611 220.049L357.751 220.329L342.891 210.769L343.061 210.679Z",
    fill: "#3B424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.242 210.599L357.473 219.769L357.612 220.049L343.062 210.679L343.242 210.599Z",
    fill: "#3A414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.412 210.519L357.342 219.489L357.472 219.769L343.242 210.599L343.412 210.519Z",
    fill: "#39404B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.576 210.429L357.196 219.209L357.336 219.489L343.406 210.519L343.576 210.429Z",
    fill: "#383F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.748 210.349L357.058 218.919L357.198 219.209L343.578 210.429L343.748 210.349Z",
    fill: "#373E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.92 210.269L356.93 218.639L357.06 218.919L343.75 210.349L343.92 210.269Z",
    fill: "#363D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.092 210.179L356.792 218.359L356.932 218.639L343.922 210.269L344.092 210.179Z",
    fill: "#353C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.266 210.099L356.656 218.079L356.786 218.359L344.086 210.179L344.266 210.099Z",
    fill: "#343B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.436 210.019L356.516 217.799L356.656 218.079L344.266 210.099L344.436 210.019Z",
    fill: "#333A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.607 209.929L356.378 217.519L356.517 217.799L344.438 210.019L344.607 209.929Z",
    fill: "#333944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.779 209.849L356.249 217.239L356.379 217.519L344.609 209.929L344.779 209.849Z",
    fill: "#323843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.951 209.769L356.111 216.949L356.251 217.239L344.781 209.849L344.951 209.769Z",
    fill: "#313742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.115 209.688L355.965 216.668L356.105 216.948L344.945 209.768L345.115 209.688Z",
    fill: "#303641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.297 209.599L355.837 216.389L355.967 216.669L345.117 209.689L345.297 209.599Z",
    fill: "#2F3540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.467 209.519L355.697 216.109L355.837 216.389L345.297 209.599L345.467 209.519Z",
    fill: "#2E343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.639 209.438L355.569 215.828L355.699 216.108L345.469 209.518L345.639 209.438Z",
    fill: "#2D343E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 209.349L355.431 215.549L355.571 215.829L345.641 209.439L345.811 209.349Z",
    fill: "#2C333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.983 209.269L355.293 215.269L355.432 215.549L345.812 209.349L345.983 209.269Z",
    fill: "#2B323C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.147 209.188L355.157 214.988L355.287 215.268L345.977 209.268L346.147 209.188Z",
    fill: "#2A313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.318 209.099L355.018 214.699L355.158 214.989L346.148 209.189L346.318 209.099Z",
    fill: "#2A303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.5 209.019L354.88 214.419L355.02 214.699L346.32 209.099L346.5 209.019Z",
    fill: "#292F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.67 208.938L354.75 214.138L354.88 214.418L346.5 209.018L346.67 208.938Z",
    fill: "#282E38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.842 208.849L354.612 213.859L354.752 214.139L346.672 208.939L346.842 208.849Z",
    fill: "#272D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.006 208.769L354.476 213.579L354.606 213.859L346.836 208.849L347.006 208.769Z",
    fill: "#262C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.178 208.688L354.338 213.298L354.478 213.578L347.008 208.768L347.178 208.688Z",
    fill: "#252B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.35 208.608L354.2 213.018L354.34 213.298L347.18 208.688L347.35 208.608Z",
    fill: "#242A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.532 208.519L354.072 212.739L354.202 213.019L347.352 208.609L347.532 208.519Z",
    fill: "#232A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.701 208.438L353.931 212.448L354.071 212.738L347.531 208.518L347.701 208.438Z",
    fill: "#232932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.865 208.358L353.795 212.168L353.925 212.448L347.695 208.438L347.865 208.358Z",
    fill: "#222831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.037 208.269L353.657 211.889L353.797 212.169L347.867 208.359L348.037 208.269Z",
    fill: "#212730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.209 208.188L353.519 211.608L353.659 211.888L348.039 208.268L348.209 208.188Z",
    fill: "#20262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.381 208.108L353.391 211.328L353.521 211.608L348.211 208.188L348.381 208.108Z",
    fill: "#1F252F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.545 208.019L353.245 211.049L353.385 211.329L348.375 208.109L348.545 208.019Z",
    fill: "#1F242E"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M314.272 237.87C315.452 237.54 316.902 237.52 318.082 238.01C319.862 238.75 319.852 240.18 321.302 241.31C325.262 244.4 333.022 239.68 333.682 240.3C324.792 244.12 316.462 244.22 314.592 240.35C314.232 239.6 314.132 238.76 314.272 237.86V237.87Z",
    fill: "#090E16"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.52 233.26C322.846 233.26 323.11 232.996 323.11 232.67C323.11 232.344 322.846 232.08 322.52 232.08C322.194 232.08 321.93 232.344 321.93 232.67C321.93 232.996 322.194 233.26 322.52 233.26Z",
    fill: "#090E16"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.613 235.64C327.353 235.64 327.953 235.04 327.953 234.3C327.953 233.56 327.353 232.96 326.613 232.96C325.873 232.96 325.273 233.56 325.273 234.3C325.273 235.04 325.873 235.64 326.613 235.64Z",
    fill: "#090E16"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.809 230.41C328.058 230.41 328.259 230.208 328.259 229.96C328.259 229.711 328.058 229.51 327.809 229.51C327.561 229.51 327.359 229.711 327.359 229.96C327.359 230.208 327.561 230.41 327.809 230.41Z",
    fill: "#090E16"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.258 230.759C332.358 230.759 332.438 230.679 332.438 230.579C332.438 230.48 332.358 230.399 332.258 230.399C332.159 230.399 332.078 230.48 332.078 230.579C332.078 230.679 332.159 230.759 332.258 230.759Z",
    fill: "#090E16"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.349 233.369C338.559 233.369 338.729 233.199 338.729 232.989C338.729 232.78 338.559 232.609 338.349 232.609C338.139 232.609 337.969 232.78 337.969 232.989C337.969 233.199 338.139 233.369 338.349 233.369Z",
    fill: "#090E16"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.144 228.089C341 228.089 341.694 227.395 341.694 226.539C341.694 225.683 341 224.989 340.144 224.989C339.288 224.989 338.594 225.683 338.594 226.539C338.594 227.395 339.288 228.089 340.144 228.089Z",
    fill: "#090E16"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 314,
    y: 211,
    width: 32,
    height: 32
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M342.252 211.05C341.702 211.32 342.482 213.5 342.962 215.99C343.292 217.67 343.462 219.26 343.512 220.77C340.722 220.58 337.192 221.13 333.422 222.38C331.742 222.94 330.012 223.64 328.282 224.48C320.442 228.28 314.912 233.74 314.272 237.87C314.132 238.78 314.232 239.62 314.592 240.36C314.982 241.16 315.652 241.79 316.532 242.25C321.572 231.33 334.422 225.77 345.742 223.98C344.122 220.22 343.972 216.52 345.172 213.4C343.912 211.88 342.692 210.82 342.252 211.04V211.05Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.969 225.386L315.625 242.502L315.708 242.673L351.051 225.557L350.969 225.386Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.914 225.259L315.57 242.375L315.627 242.492L350.971 225.376L350.914 225.259Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.851 225.155L315.508 242.271L315.564 242.388L350.908 225.272L350.851 225.155Z",
    fill: "#87909F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.797 225.034L315.453 242.15L315.51 242.267L350.853 225.151L350.797 225.034Z",
    fill: "#8892A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.734 224.907L315.391 242.023L315.447 242.14L350.791 225.024L350.734 224.907Z",
    fill: "#8A93A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.68 224.796L315.336 241.912L315.393 242.029L350.736 224.913L350.68 224.796Z",
    fill: "#8B95A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.617 224.683L315.273 241.799L315.33 241.916L350.674 224.8L350.617 224.683Z",
    fill: "#8D96A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.57 224.566L315.227 241.683L315.283 241.8L350.627 224.683L350.57 224.566Z",
    fill: "#8E97A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.508 224.444L315.164 241.561L315.221 241.678L350.564 224.561L350.508 224.444Z",
    fill: "#9099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.453 224.332L315.109 241.448L315.166 241.565L350.51 224.449L350.453 224.332Z",
    fill: "#919AA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 224.216L315.055 241.332L315.111 241.449L350.455 224.333L350.398 224.216Z",
    fill: "#939BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.344 224.094L315 241.21L315.057 241.327L350.4 224.211L350.344 224.094Z",
    fill: "#949DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.281 223.981L314.938 241.098L314.994 241.215L350.338 224.098L350.281 223.981Z",
    fill: "#969EAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.234 223.865L314.891 240.981L314.947 241.098L350.291 223.982L350.234 223.865Z",
    fill: "#97A0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.164 223.743L314.82 240.859L314.877 240.976L350.221 223.86L350.164 223.743Z",
    fill: "#98A1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.125 223.626L314.781 240.742L314.838 240.859L350.181 223.743L350.125 223.626Z",
    fill: "#9AA2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.062 223.514L314.719 240.63L314.775 240.747L350.119 223.631L350.062 223.514Z",
    fill: "#9BA4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 223.392L314.656 240.508L314.713 240.625L350.056 223.509L350 223.392Z",
    fill: "#9DA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.953 223.285L314.609 240.401L314.666 240.518L350.01 223.402L349.953 223.285Z",
    fill: "#9EA6B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.89 223.163L314.547 240.279L314.604 240.396L349.947 223.28L349.89 223.163Z",
    fill: "#A0A7B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.836 223.041L314.492 240.157L314.549 240.274L349.892 223.158L349.836 223.041Z",
    fill: "#A1A9B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.781 222.934L314.438 240.05L314.494 240.167L349.838 223.051L349.781 222.934Z",
    fill: "#A2AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.726 222.813L314.383 239.929L314.439 240.046L349.783 222.93L349.726 222.813Z",
    fill: "#A4ABB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.656 222.69L314.312 239.807L314.369 239.924L349.713 222.807L349.656 222.69Z",
    fill: "#A5ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.617 222.583L314.273 239.699L314.33 239.816L349.674 222.7L349.617 222.583Z",
    fill: "#A7AEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.547 222.461L314.203 239.577L314.26 239.694L349.603 222.578L349.547 222.461Z",
    fill: "#A8AFBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.492 222.339L314.148 239.455L314.205 239.572L349.549 222.456L349.492 222.339Z",
    fill: "#A9B0BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.437 222.232L314.094 239.349L314.15 239.466L349.494 222.349L349.437 222.232Z",
    fill: "#ABB2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.383 222.11L314.039 239.227L314.096 239.344L349.439 222.227L349.383 222.11Z",
    fill: "#ACB3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.32 221.998L313.977 239.114L314.033 239.231L349.377 222.115L349.32 221.998Z",
    fill: "#ADB4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.273 221.872L313.93 238.988L313.986 239.105L349.33 221.989L349.273 221.872Z",
    fill: "#AFB5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.211 221.76L313.867 238.876L313.924 238.993L349.267 221.877L349.211 221.76Z",
    fill: "#B0B7C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.148 221.647L313.805 238.764L313.861 238.881L349.205 221.764L349.148 221.647Z",
    fill: "#B1B8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.094 221.521L313.75 238.638L313.807 238.755L349.15 221.639L349.094 221.521Z",
    fill: "#B3B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.039 221.408L313.695 238.524L313.752 238.641L349.096 221.525L349.039 221.408Z",
    fill: "#B4BAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.976 221.297L313.633 238.413L313.689 238.53L349.033 221.414L348.976 221.297Z",
    fill: "#B5BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.93 221.17L313.586 238.286L313.643 238.403L348.986 221.287L348.93 221.17Z",
    fill: "#B7BDC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.875 221.058L313.531 238.174L313.588 238.291L348.931 221.175L348.875 221.058Z",
    fill: "#B8BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.812 220.945L313.469 238.062L313.525 238.179L348.869 221.062L348.812 220.945Z",
    fill: "#B9BFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.765 220.819L313.422 237.936L313.479 238.053L348.822 220.936L348.765 220.819Z",
    fill: "#BAC0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.703 220.717L313.359 237.833L313.416 237.95L348.76 220.834L348.703 220.717Z",
    fill: "#BCC1C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.648 220.595L313.305 237.711L313.361 237.828L348.705 220.712L348.648 220.595Z",
    fill: "#BDC2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.586 220.469L313.242 237.585L313.299 237.702L348.642 220.586L348.586 220.469Z",
    fill: "#BEC3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.539 220.365L313.195 237.481L313.252 237.598L348.596 220.482L348.539 220.365Z",
    fill: "#BFC5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.469 220.244L313.125 237.36L313.182 237.477L348.525 220.361L348.469 220.244Z",
    fill: "#C1C6CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.422 220.117L313.078 237.233L313.135 237.35L348.478 220.234L348.422 220.117Z",
    fill: "#C2C7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.359 220.015L313.016 237.131L313.072 237.248L348.416 220.132L348.359 220.015Z",
    fill: "#C3C8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.312 219.889L312.969 237.005L313.025 237.122L348.369 220.006L348.312 219.889Z",
    fill: "#C4C9D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.25 219.776L312.906 236.893L312.963 237.01L348.306 219.893L348.25 219.776Z",
    fill: "#C5CAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.195 219.664L312.852 236.78L312.908 236.897L348.252 219.781L348.195 219.664Z",
    fill: "#C7CBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.14 219.538L312.797 236.654L312.854 236.771L348.197 219.655L348.14 219.538Z",
    fill: "#C8CCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.078 219.426L312.734 236.542L312.791 236.659L348.135 219.543L348.078 219.426Z",
    fill: "#C9CDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.015 219.312L312.672 236.429L312.729 236.546L348.072 219.429L348.015 219.312Z",
    fill: "#CACED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.969 219.187L312.625 236.303L312.682 236.42L348.025 219.304L347.969 219.187Z",
    fill: "#CBD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.906 219.075L312.562 236.191L312.619 236.308L347.963 219.192L347.906 219.075Z",
    fill: "#CCD1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.851 218.953L312.508 236.069L312.564 236.186L347.908 219.07L347.851 218.953Z",
    fill: "#CED2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.805 218.836L312.461 235.952L312.518 236.069L347.861 218.953L347.805 218.836Z",
    fill: "#CFD3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.742 218.724L312.398 235.84L312.455 235.957L347.799 218.841L347.742 218.724Z",
    fill: "#D0D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.68 218.603L312.336 235.719L312.393 235.836L347.736 218.72L347.68 218.603Z",
    fill: "#D1D5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.633 218.495L312.289 235.611L312.346 235.728L347.689 218.612L347.633 218.495Z",
    fill: "#D2D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.578 218.373L312.234 235.489L312.291 235.606L347.635 218.49L347.578 218.373Z",
    fill: "#D3D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.508 218.251L312.164 235.367L312.221 235.484L347.564 218.368L347.508 218.251Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.469 218.144L312.125 235.26L312.182 235.377L347.525 218.261L347.469 218.144Z",
    fill: "#D5D9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.398 218.022L312.055 235.139L312.111 235.256L347.455 218.139L347.398 218.022Z",
    fill: "#D6DADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.344 217.9L312 235.017L312.057 235.134L347.4 218.017L347.344 217.9Z",
    fill: "#D7DBDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.289 217.793L311.945 234.909L312.002 235.026L347.346 217.91L347.289 217.793Z",
    fill: "#D8DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.234 217.671L311.891 234.787L311.947 234.904L347.291 217.788L347.234 217.671Z",
    fill: "#D9DCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.164 217.55L311.82 234.666L311.877 234.783L347.221 217.667L347.164 217.55Z",
    fill: "#DADDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.125 217.442L311.781 234.559L311.838 234.676L347.181 217.559L347.125 217.442Z",
    fill: "#DBDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.055 217.32L311.711 234.437L311.768 234.554L347.111 217.437L347.055 217.32Z",
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 217.209L311.656 234.325L311.713 234.442L347.056 217.326L347 217.209Z",
    fill: "#DDE0E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.945 217.091L311.602 234.207L311.658 234.324L347.002 217.208L346.945 217.091Z",
    fill: "#DEE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.89 216.97L311.547 234.086L311.604 234.203L346.947 217.087L346.89 216.97Z",
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.828 216.857L311.484 233.974L311.541 234.091L346.885 216.974L346.828 216.857Z",
    fill: "#E0E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.781 216.74L311.438 233.856L311.494 233.973L346.838 216.857L346.781 216.74Z",
    fill: "#E1E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.726 216.618L311.383 233.734L311.439 233.851L346.783 216.735L346.726 216.618Z",
    fill: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.656 216.507L311.312 233.623L311.369 233.74L346.713 216.624L346.656 216.507Z",
    fill: "#E3E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.617 216.39L311.273 233.506L311.33 233.623L346.674 216.507L346.617 216.39Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.555 216.277L311.211 233.394L311.268 233.511L346.611 216.394L346.555 216.277Z",
    fill: "#E5E7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.492 216.156L311.148 233.272L311.205 233.389L346.549 216.273L346.492 216.156Z",
    fill: "#E6E8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.437 216.029L311.094 233.146L311.15 233.263L346.494 216.146L346.437 216.029Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.383 215.927L311.039 233.043L311.096 233.16L346.439 216.044L346.383 215.927Z",
    fill: "#E8EAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.328 215.801L310.984 232.917L311.041 233.034L346.385 215.918L346.328 215.801Z",
    fill: "#E9EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.273 215.679L310.93 232.795L310.986 232.912L346.33 215.796L346.273 215.679Z",
    fill: "#E9EBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.211 215.576L310.867 232.692L310.924 232.809L346.267 215.693L346.211 215.576Z",
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.164 215.449L310.82 232.565L310.877 232.682L346.221 215.566L346.164 215.449Z",
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.094 215.328L310.75 232.444L310.807 232.561L346.15 215.445L346.094 215.328Z",
    fill: "#ECEDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.047 215.225L310.703 232.341L310.76 232.458L346.103 215.342L346.047 215.225Z",
    fill: "#EDEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.984 215.099L310.641 232.215L310.697 232.332L346.041 215.216L345.984 215.099Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.93 214.987L310.586 232.104L310.643 232.221L345.986 215.104L345.93 214.987Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.867 214.874L310.523 231.99L310.58 232.107L345.924 214.991L345.867 214.874Z",
    fill: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.82 214.748L310.477 231.864L310.533 231.981L345.877 214.865L345.82 214.748Z",
    fill: "#F0F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.758 214.636L310.414 231.752L310.471 231.869L345.814 214.753L345.758 214.636Z",
    fill: "#F1F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.703 214.523L310.359 231.64L310.416 231.757L345.76 214.64L345.703 214.523Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.648 214.396L310.305 231.513L310.361 231.63L345.705 214.513L345.648 214.396Z",
    fill: "#F2F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.586 214.285L310.242 231.401L310.299 231.518L345.642 214.402L345.586 214.285Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.539 214.172L310.195 231.288L310.252 231.405L345.596 214.289L345.539 214.172Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.476 214.046L310.133 231.162L310.189 231.279L345.533 214.163L345.476 214.046Z",
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.422 213.935L310.078 231.051L310.135 231.168L345.478 214.052L345.422 213.935Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.359 213.821L310.016 230.938L310.072 231.055L345.416 213.938L345.359 213.821Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.312 213.705L309.969 230.821L310.025 230.938L345.369 213.822L345.312 213.705Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.25 213.583L309.906 230.699L309.963 230.816L345.306 213.7L345.25 213.583Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.195 213.471L309.852 230.587L309.908 230.704L345.252 213.588L345.195 213.471Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.14 213.354L309.797 230.471L309.854 230.588L345.197 213.471L345.14 213.354Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.086 213.232L309.742 230.349L309.799 230.466L345.142 213.349L345.086 213.232Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.023 213.119L309.68 230.235L309.736 230.352L345.08 213.236L345.023 213.119Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.976 213.003L309.633 230.119L309.689 230.236L345.033 213.12L344.976 213.003Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.906 212.882L309.562 229.998L309.619 230.115L344.963 212.999L344.906 212.882Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.851 212.77L309.508 229.886L309.564 230.003L344.908 212.887L344.851 212.77Z",
    fill: "#FAFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.797 212.652L309.453 229.769L309.51 229.886L344.853 212.769L344.797 212.652Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.742 212.53L309.398 229.646L309.455 229.763L344.799 212.647L344.742 212.53Z",
    fill: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.672 212.419L309.328 229.535L309.385 229.652L344.728 212.536L344.672 212.419Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.633 212.302L309.289 229.418L309.346 229.535L344.689 212.419L344.633 212.302Z",
    fill: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.562 212.18L309.219 229.296L309.275 229.413L344.619 212.297L344.562 212.18Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.515 212.063L309.172 229.18L309.229 229.297L344.572 212.18L344.515 212.063Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.469 211.95L309.125 229.066L309.182 229.183L344.525 212.067L344.469 211.95Z",
    fill: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.398 211.829L309.055 228.945L309.111 229.062L344.455 211.946L344.398 211.829Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.351 211.713L309.008 228.829L309.064 228.946L344.408 211.83L344.351 211.713Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.289 211.6L308.945 228.716L309.002 228.833L344.346 211.717L344.289 211.6Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.234 211.487L308.891 228.604L308.947 228.721L344.291 211.604L344.234 211.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.18 211.361L308.836 228.478L308.893 228.595L344.236 211.478L344.18 211.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.125 211.249L308.781 228.365L308.838 228.482L344.181 211.366L344.125 211.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.062 211.137L308.719 228.253L308.775 228.37L344.119 211.254L344.062 211.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.687 210.359L308.344 227.476L308.719 228.25L344.062 211.133L343.687 210.359Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M318.501 234.79L319.001 235.82L317.971 236.32C317.851 236.38 317.801 236.52 317.861 236.64C317.921 236.76 318.061 236.81 318.181 236.75L319.211 236.25L319.711 237.28C319.771 237.4 319.911 237.45 320.031 237.39C320.151 237.33 320.201 237.19 320.141 237.07L319.641 236.04L320.671 235.54C320.791 235.48 320.841 235.34 320.781 235.22C320.721 235.1 320.581 235.05 320.461 235.11L319.431 235.61L318.931 234.58C318.871 234.46 318.731 234.41 318.611 234.47C318.491 234.53 318.441 234.67 318.501 234.79Z",
    fill: "#090E16"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M318.15 234.66L318.65 235.69L317.62 236.19C317.5 236.25 317.45 236.39 317.51 236.51C317.57 236.63 317.71 236.68 317.83 236.62L318.86 236.12L319.36 237.15C319.42 237.27 319.56 237.32 319.68 237.26C319.8 237.2 319.85 237.06 319.79 236.94L319.29 235.91L320.32 235.41C320.44 235.35 320.49 235.21 320.43 235.09C320.37 234.97 320.23 234.92 320.11 234.98L319.08 235.48L318.58 234.45C318.52 234.33 318.38 234.28 318.26 234.34C318.14 234.4 318.09 234.54 318.15 234.66Z",
    fill: "#090E16"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.326 231.58C308.996 232.21 311.516 234.58 314.056 236.13C315.606 237.07 316.466 237.28 317.126 238.39C317.826 239.56 317.446 240.3 317.796 241.97C318.336 244.58 320.136 247.08 320.986 246.88C321.806 246.69 321.366 244.03 322.076 240.23C322.186 239.64 322.316 239.08 322.456 238.54C322.456 238.51 322.476 238.48 322.476 238.45C322.526 238.45 322.586 238.45 322.636 238.45C322.996 238.44 323.376 238.39 323.756 238.29C324.416 238.12 325.116 237.83 325.826 237.42C329.146 235.53 332.856 231.17 335.636 225.5C335.916 224.93 336.176 224.36 336.426 223.79C339.996 215.58 340.126 207.88 336.556 206.13C335.866 205.79 335.086 205.7 334.256 205.82C330.436 206.39 325.356 211.48 321.816 218.72C321.026 220.32 320.376 221.92 319.846 223.47C318.666 226.96 318.146 230.22 318.306 232.8C316.916 232.74 315.436 232.58 313.886 232.27C311.586 231.81 309.576 231.09 309.316 231.59L309.326 231.58Z",
    fill: "#090E16"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M308.717 231.279C308.387 231.909 310.907 234.279 313.447 235.829C314.997 236.769 315.857 236.979 316.517 238.089C317.217 239.259 316.837 239.999 317.187 241.669C317.727 244.279 319.527 246.779 320.377 246.579C321.197 246.389 320.757 243.729 321.467 239.929C321.577 239.339 321.707 238.779 321.847 238.239C321.847 238.209 321.867 238.179 321.867 238.149C321.917 238.149 321.977 238.149 322.027 238.149C322.387 238.139 322.767 238.089 323.147 237.989C323.807 237.819 324.507 237.529 325.217 237.119C328.537 235.229 332.247 230.869 335.027 225.199C335.307 224.629 335.567 224.059 335.817 223.489C339.387 215.279 339.517 207.579 335.947 205.829C335.257 205.489 334.477 205.399 333.647 205.519C329.827 206.089 324.747 211.179 321.207 218.419C320.417 220.019 319.767 221.619 319.237 223.169C318.057 226.659 317.537 229.919 317.697 232.499C316.307 232.439 314.827 232.279 313.277 231.969C310.977 231.509 308.967 230.789 308.707 231.289L308.717 231.279Z",
    fill: "#858F9E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 223,
    width: 18,
    height: 24
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M308.748 231.299C308.418 231.929 310.938 234.299 313.478 235.849C315.028 236.789 315.888 236.999 316.548 238.109C317.248 239.279 316.868 240.019 317.218 241.689C317.758 244.299 319.558 246.799 320.408 246.599C321.228 246.409 320.788 243.749 321.498 239.949C321.608 239.359 321.738 238.799 321.878 238.259C321.938 238.229 321.998 238.199 322.058 238.169C322.418 238.159 322.798 238.109 323.178 238.009C323.838 237.839 324.538 237.549 325.248 237.139C325.628 234.209 325.348 231.409 324.478 229.059C324.438 228.959 324.408 228.859 324.358 228.759C323.338 226.169 321.598 224.179 319.258 223.189C318.078 226.679 317.558 229.939 317.718 232.519C316.328 232.459 314.848 232.299 313.298 231.989C310.998 231.529 308.988 230.809 308.728 231.309L308.748 231.299Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.709 222.739L316.039 224.439L325.059 238.589L330.099 228.319L318.709 222.739Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.044 224.439L315.914 224.519L324.984 238.749L325.064 238.589L316.044 224.439Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.911 224.52L315.781 224.6L324.901 238.91L324.981 238.75L315.911 224.52Z",
    fill: "#848E9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.778 224.6L315.648 224.68L324.828 239.07L324.898 238.91L315.778 224.6Z",
    fill: "#838D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.651 224.68L315.531 224.76L324.751 239.23L324.831 239.07L315.651 224.68Z",
    fill: "#828B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.528 224.759L315.398 224.839L324.668 239.389L324.748 239.229L315.528 224.759Z",
    fill: "#808A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.403 224.839L315.273 224.919L324.593 239.539L324.673 239.389L315.403 224.839Z",
    fill: "#7F8998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.268 224.919L315.148 224.999L324.518 239.699L324.588 239.539L315.268 224.919Z",
    fill: "#7E8896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.153 224.999L315.023 225.089L324.443 239.859L324.523 239.699L315.153 224.999Z",
    fill: "#7D8795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.021 225.089L314.891 225.169L324.361 240.019L324.441 239.859L315.021 225.089Z",
    fill: "#7C8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.893 225.169L314.773 225.249L324.283 240.179L324.363 240.019L314.893 225.169Z",
    fill: "#7B8493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.771 225.249L314.641 225.329L324.211 240.339L324.281 240.179L314.771 225.249Z",
    fill: "#798391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.638 225.329L314.508 225.409L324.128 240.489L324.208 240.339L314.638 225.329Z",
    fill: "#788290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.511 225.409L314.391 225.489L324.051 240.649L324.131 240.489L314.511 225.409Z",
    fill: "#77818F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.388 225.489L314.258 225.569L323.968 240.809L324.048 240.649L314.388 225.489Z",
    fill: "#767F8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.263 225.569L314.133 225.649L323.903 240.969L323.973 240.809L314.263 225.569Z",
    fill: "#757E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.13 225.649L314 225.729L323.82 241.129L323.9 240.969L314.13 225.649Z",
    fill: "#747D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.003 225.729L313.883 225.809L323.743 241.289L323.823 241.13L314.003 225.729Z",
    fill: "#737C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88 225.81L313.75 225.89L323.66 241.44L323.74 241.29L313.88 225.81Z",
    fill: "#727B89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.747 225.89L313.617 225.98L323.587 241.6L323.657 241.44L313.747 225.89Z",
    fill: "#707A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.62 225.979L313.5 226.059L323.51 241.759L323.59 241.6L313.62 225.979Z",
    fill: "#6F7886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.497 226.06L313.367 226.14L323.427 241.92L323.507 241.76L313.497 226.06Z",
    fill: "#6E7785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.372 226.14L313.242 226.22L323.352 242.08L323.432 241.92L313.372 226.14Z",
    fill: "#6D7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.237 226.22L313.117 226.3L323.267 242.24L323.347 242.08L313.237 226.22Z",
    fill: "#6C7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.122 226.299L312.992 226.379L323.202 242.389L323.272 242.239L313.122 226.299Z",
    fill: "#6B7481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.989 226.379L312.859 226.459L323.119 242.549L323.199 242.389L312.989 226.379Z",
    fill: "#6A7380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.862 226.459L312.742 226.539L323.042 242.709L323.122 242.549L312.862 226.459Z",
    fill: "#69717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.739 226.539L312.609 226.619L322.959 242.869L323.039 242.709L312.739 226.539Z",
    fill: "#68707E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.614 226.619L312.484 226.699L322.894 243.029L322.964 242.869L312.614 226.619Z",
    fill: "#666F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.482 226.699L312.352 226.779L322.812 243.189L322.892 243.029L312.482 226.699Z",
    fill: "#656E7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.354 226.779L312.234 226.869L322.734 243.339L322.814 243.189L312.354 226.779Z",
    fill: "#646D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.232 226.869L312.102 226.949L322.652 243.499L322.732 243.339L312.232 226.869Z",
    fill: "#636C79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.099 226.949L311.969 227.029L322.579 243.659L322.649 243.499L312.099 226.949Z",
    fill: "#626B78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.972 227.029L311.852 227.109L322.502 243.819L322.582 243.659L311.972 227.029Z",
    fill: "#616A76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.849 227.109L311.719 227.189L322.419 243.979L322.499 243.819L311.849 227.109Z",
    fill: "#606875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.724 227.189L311.594 227.269L322.344 244.139L322.424 243.979L311.724 227.189Z",
    fill: "#5F6774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.589 227.27L311.469 227.35L322.269 244.29L322.339 244.14L311.589 227.27Z",
    fill: "#5E6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.474 227.35L311.344 227.43L322.194 244.45L322.274 244.29L311.474 227.35Z",
    fill: "#5D6572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.341 227.43L311.211 227.51L322.111 244.61L322.191 244.45L311.341 227.43Z",
    fill: "#5C6471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.214 227.509L311.094 227.589L322.034 244.769L322.114 244.609L311.214 227.509Z",
    fill: "#5B636F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.091 227.589L310.961 227.669L321.961 244.929L322.031 244.769L311.091 227.589Z",
    fill: "#59626E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.958 227.669L310.828 227.759L321.878 245.089L321.958 244.929L310.958 227.669Z",
    fill: "#58616D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.833 227.759L310.703 227.839L321.803 245.239L321.883 245.089L310.833 227.759Z",
    fill: "#575F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.698 227.839L310.578 227.919L321.718 245.399L321.798 245.239L310.698 227.839Z",
    fill: "#565E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.583 227.919L310.453 227.999L321.653 245.559L321.723 245.399L310.583 227.919Z",
    fill: "#555D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45 227.999L310.32 228.079L321.57 245.719L321.65 245.559L310.45 227.999Z",
    fill: "#545C68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.322 228.079L310.312 228.089L310.242 228.229L321.492 245.879L321.572 245.719L310.322 228.079Z",
    fill: "#535B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.164 228.389L321.414 246.039L321.494 245.88L310.244 228.229L310.164 228.389Z",
    fill: "#525A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.094 228.55L321.334 246.19L321.414 246.04L310.164 228.39L310.094 228.55Z",
    fill: "#515965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.008 228.699L321.258 246.349L321.328 246.189L310.088 228.549L310.008 228.699Z",
    fill: "#505864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.93 228.859L321.18 246.509L321.26 246.349L310.01 228.699L309.93 228.859Z",
    fill: "#4F5763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.852 229.019L321.102 246.669L321.182 246.509L309.932 228.859L309.852 229.019Z",
    fill: "#4E5662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.773 229.18L321.023 246.83L321.103 246.67L309.853 229.02L309.773 229.18Z",
    fill: "#4D5560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.703 229.34L320.953 246.99L321.023 246.83L309.773 229.18L309.703 229.34Z",
    fill: "#4C545F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.617 229.499L320.867 247.139L320.947 246.989L309.697 229.339L309.617 229.499Z",
    fill: "#4B535E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.539 229.649L320.789 247.299L320.869 247.139L309.619 229.499L309.539 229.649Z",
    fill: "#4A515D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.461 229.809L320.621 247.309L320.761 247.369L320.791 247.299L309.541 229.649L309.461 229.809Z",
    fill: "#49505C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.391 229.97L320.361 247.18L320.621 247.31L309.461 229.81L309.391 229.97Z",
    fill: "#484F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.312 230.13L320.103 247.05L320.362 247.18L309.393 229.97L309.312 230.13Z",
    fill: "#474E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.234 230.289L319.844 246.919L320.104 247.049L309.314 230.129L309.234 230.289Z",
    fill: "#464D59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.148 230.449L319.578 246.799L319.838 246.919L309.228 230.289L309.148 230.449Z",
    fill: "#454C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.078 230.599L319.318 246.669L319.578 246.799L309.148 230.449L309.078 230.599Z",
    fill: "#444B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 230.76L319.06 246.54L319.32 246.67L309.08 230.6L309 230.76Z",
    fill: "#434A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.922 230.919L318.802 246.419L319.062 246.539L309.002 230.759L308.922 230.919Z",
    fill: "#424954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.844 231.079L318.544 246.289L318.804 246.419L308.924 230.919L308.844 231.079Z",
    fill: "#414853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.773 231.239L318.283 246.159L318.543 246.289L308.843 231.079L308.773 231.239Z",
    fill: "#404752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.688 231.399L318.017 246.029L318.277 246.159L308.767 231.239L308.688 231.399Z",
    fill: "#3F4651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.609 231.549L317.759 245.909L318.019 246.029L308.689 231.399L308.609 231.549Z",
    fill: "#3E4550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.531 231.709L317.501 245.779L317.761 245.909L308.611 231.549L308.531 231.709Z",
    fill: "#3D444F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.461 231.869L317.241 245.649L317.501 245.779L308.531 231.709L308.461 231.869Z",
    fill: "#3C434E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.383 232.029L316.983 245.519L317.243 245.649L308.463 231.869L308.383 232.029Z",
    fill: "#3B424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.305 232.189L316.725 245.399L316.985 245.519L308.385 232.029L308.305 232.189Z",
    fill: "#3A414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.219 232.349L316.459 245.269L316.719 245.399L308.299 232.189L308.219 232.349Z",
    fill: "#39404B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.148 232.5L316.198 245.14L316.458 245.27L308.218 232.35L308.148 232.5Z",
    fill: "#383F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07 232.659L315.94 245.019L316.2 245.139L308.15 232.499L308.07 232.659Z",
    fill: "#373E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.992 232.819L315.682 244.889L315.942 245.019L308.072 232.659L307.992 232.819Z",
    fill: "#363D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.914 232.979L315.424 244.759L315.684 244.889L307.994 232.819L307.914 232.979Z",
    fill: "#353C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.844 233.139L315.164 244.63L315.424 244.759L307.914 232.979L307.844 233.139Z",
    fill: "#343B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.758 233.3L314.898 244.51L315.158 244.63L307.838 233.14L307.758 233.3Z",
    fill: "#333A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.68 233.449L314.64 244.379L314.9 244.509L307.76 233.299L307.68 233.449Z",
    fill: "#333944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.602 233.609L314.382 244.249L314.642 244.379L307.682 233.449L307.602 233.609Z",
    fill: "#323843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.523 233.769L314.123 244.129L314.383 244.249L307.603 233.609L307.523 233.769Z",
    fill: "#313742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.453 233.93L313.873 244L314.123 244.13L307.523 233.77L307.453 233.93Z",
    fill: "#303641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.367 234.09L313.607 243.87L313.867 244L307.447 233.93L307.367 234.09Z",
    fill: "#2F3540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.289 234.249L313.349 243.739L313.609 243.869L307.369 234.089L307.289 234.249Z",
    fill: "#2E343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.211 234.399L313.091 243.619L313.351 243.739L307.291 234.249L307.211 234.399Z",
    fill: "#2D343E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.141 234.559L312.831 243.489L313.091 243.619L307.211 234.399L307.141 234.559Z",
    fill: "#2C333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.062 234.72L312.573 243.36L312.832 243.49L307.143 234.56L307.062 234.72Z",
    fill: "#2B323C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.984 234.88L312.314 243.23L312.574 243.36L307.064 234.72L306.984 234.88Z",
    fill: "#2A313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.898 235.039L312.048 243.109L312.308 243.229L306.978 234.879L306.898 235.039Z",
    fill: "#2A303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.828 235.199L311.788 242.979L312.048 243.109L306.898 235.039L306.828 235.199Z",
    fill: "#292F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75 235.349L311.53 242.849L311.79 242.979L306.83 235.199L306.75 235.349Z",
    fill: "#282E38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.672 235.51L311.272 242.73L311.532 242.85L306.752 235.35L306.672 235.51Z",
    fill: "#272D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.594 235.669L311.014 242.599L311.274 242.729L306.674 235.509L306.594 235.669Z",
    fill: "#262C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.523 235.829L310.753 242.469L311.013 242.599L306.593 235.669L306.523 235.829Z",
    fill: "#252B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.438 235.989L310.487 242.339L310.747 242.469L306.517 235.829L306.438 235.989Z",
    fill: "#242A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.359 236.149L310.229 242.219L310.489 242.339L306.439 235.989L306.359 236.149Z",
    fill: "#232A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.281 236.299L309.971 242.089L310.231 242.219L306.361 236.149L306.281 236.299Z",
    fill: "#232932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.211 236.459L309.711 241.959L309.971 242.089L306.281 236.299L306.211 236.459Z",
    fill: "#222831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.133 236.619L309.453 241.829L309.713 241.959L306.213 236.459L306.133 236.619Z",
    fill: "#212730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.055 236.779L309.195 241.709L309.455 241.829L306.135 236.619L306.055 236.779Z",
    fill: "#20262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.969 236.939L308.929 241.579L309.189 241.709L306.049 236.779L305.969 236.939Z",
    fill: "#1F252F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.898 237.099L308.668 241.449L308.928 241.579L305.968 236.939L305.898 237.099Z",
    fill: "#1F242E"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M333.648 205.51C333.338 206.6 333.318 207.94 333.768 209.03C334.448 210.68 335.768 210.68 336.808 212.02C339.648 215.69 335.248 222.85 335.828 223.47C339.398 215.26 339.528 207.56 335.958 205.81C335.268 205.47 334.488 205.38 333.658 205.5L333.648 205.51Z",
    fill: "#090E16"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.808 213.669C329.112 213.669 329.358 213.423 329.358 213.119C329.358 212.816 329.112 212.569 328.808 212.569C328.504 212.569 328.258 212.816 328.258 213.119C328.258 213.423 328.504 213.669 328.808 213.669Z",
    fill: "#090E16"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.287 218.15C330.972 218.15 331.527 217.595 331.527 216.91C331.527 216.225 330.972 215.67 330.287 215.67C329.602 215.67 329.047 216.225 329.047 216.91C329.047 217.595 329.602 218.15 330.287 218.15Z",
    fill: "#090E16"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.279 218.42C326.511 218.42 326.699 218.232 326.699 218C326.699 217.768 326.511 217.58 326.279 217.58C326.047 217.58 325.859 217.768 325.859 218C325.859 218.232 326.047 218.42 326.279 218.42Z",
    fill: "#090E16"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.826 222.29C326.92 222.29 326.996 222.214 326.996 222.12C326.996 222.026 326.92 221.95 326.826 221.95C326.732 221.95 326.656 222.026 326.656 222.12C326.656 222.214 326.732 222.29 326.826 222.29Z",
    fill: "#090E16"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.038 228.11C329.231 228.11 329.388 227.953 329.388 227.76C329.388 227.567 329.231 227.41 329.038 227.41C328.844 227.41 328.688 227.567 328.688 227.76C328.688 227.953 328.844 228.11 329.038 228.11Z",
    fill: "#090E16"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.057 230.83C323.852 230.83 324.497 230.185 324.497 229.39C324.497 228.595 323.852 227.95 323.057 227.95C322.262 227.95 321.617 228.595 321.617 229.39C321.617 230.185 322.262 230.83 323.057 230.83Z",
    fill: "#090E16"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 205,
    width: 30,
    height: 30
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M308.716 231.28C308.976 230.77 310.976 231.5 313.286 231.96C314.836 232.27 316.316 232.43 317.706 232.49C317.546 229.91 318.066 226.65 319.246 223.16C319.776 221.61 320.426 220.01 321.216 218.41C324.766 211.17 329.846 206.08 333.656 205.51C334.496 205.39 335.276 205.48 335.956 205.82C336.696 206.18 337.276 206.8 337.696 207.63C327.566 212.25 322.376 224.11 320.666 234.57C317.196 233.05 313.776 232.9 310.886 234C309.486 232.83 308.506 231.7 308.716 231.29V231.28Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.918 206.798L321.93 239.421L322.082 239.496L338.071 206.873L337.918 206.798Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.801 206.738L321.812 239.36L321.92 239.413L337.909 206.791L337.801 206.738Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.7 206.694L321.711 239.316L321.819 239.369L337.807 206.747L337.7 206.694Z",
    fill: "#87909F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.598 206.632L321.609 239.255L321.717 239.308L337.706 206.685L337.598 206.632Z",
    fill: "#8892A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.481 206.575L321.492 239.197L321.6 239.25L337.589 206.628L337.481 206.575Z",
    fill: "#8A93A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.379 206.531L321.391 239.153L321.498 239.206L337.487 206.584L337.379 206.531Z",
    fill: "#8B95A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.27 206.478L321.281 239.101L321.389 239.153L337.378 206.531L337.27 206.478Z",
    fill: "#8D96A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.168 206.435L321.18 239.058L321.287 239.11L337.276 206.488L337.168 206.435Z",
    fill: "#8E97A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.051 206.368L321.062 238.99L321.17 239.043L337.159 206.421L337.051 206.368Z",
    fill: "#9099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.95 206.315L320.961 238.938L321.069 238.99L337.057 206.368L336.95 206.315Z",
    fill: "#919AA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.848 206.272L320.859 238.895L320.967 238.947L336.956 206.325L336.848 206.272Z",
    fill: "#939BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.723 206.214L320.734 238.837L320.842 238.89L336.831 206.267L336.723 206.214Z",
    fill: "#949DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.622 206.152L320.633 238.774L320.741 238.827L336.729 206.205L336.622 206.152Z",
    fill: "#969EAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.52 206.109L320.531 238.731L320.639 238.784L336.628 206.162L336.52 206.109Z",
    fill: "#97A0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.418 206.055L320.43 238.678L320.537 238.731L336.526 206.108L336.418 206.055Z",
    fill: "#98A1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.293 205.998L320.305 238.62L320.412 238.673L336.401 206.05L336.293 205.998Z",
    fill: "#9AA2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.192 205.955L320.203 238.577L320.311 238.63L336.3 206.007L336.192 205.955Z",
    fill: "#9BA4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09 205.892L320.102 238.515L320.209 238.567L336.198 205.945L336.09 205.892Z",
    fill: "#9DA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.973 205.834L319.984 238.457L320.092 238.51L336.081 205.887L335.973 205.834Z",
    fill: "#9EA6B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.864 205.792L319.875 238.414L319.983 238.467L335.971 205.844L335.864 205.792Z",
    fill: "#A0A7B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.762 205.738L319.773 238.36L319.881 238.413L335.87 205.791L335.762 205.738Z",
    fill: "#A1A9B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.661 205.686L319.672 238.309L319.78 238.361L335.768 205.739L335.661 205.686Z",
    fill: "#A2AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.543 205.628L319.555 238.251L319.662 238.304L335.651 205.681L335.543 205.628Z",
    fill: "#A4ABB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.442 205.575L319.453 238.197L319.561 238.25L335.55 205.628L335.442 205.575Z",
    fill: "#A5ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.332 205.532L319.344 238.154L319.452 238.207L335.44 205.585L335.332 205.532Z",
    fill: "#A7AEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.215 205.474L319.227 238.097L319.334 238.149L335.323 205.527L335.215 205.474Z",
    fill: "#A8AFBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.114 205.412L319.125 238.034L319.233 238.087L335.221 205.464L335.114 205.412Z",
    fill: "#A9B0BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.012 205.369L319.023 237.991L319.131 238.044L335.12 205.421L335.012 205.369Z",
    fill: "#ABB2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.895 205.316L318.906 237.938L319.014 237.991L335.003 205.369L334.895 205.316Z",
    fill: "#ACB3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.786 205.258L318.797 237.881L318.905 237.934L334.893 205.311L334.786 205.258Z",
    fill: "#ADB4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.684 205.206L318.695 237.828L318.803 237.881L334.792 205.258L334.684 205.206Z",
    fill: "#AFB5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.582 205.153L318.594 237.775L318.701 237.828L334.69 205.206L334.582 205.153Z",
    fill: "#B0B7C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.457 205.105L318.469 237.728L318.576 237.78L334.565 205.158L334.457 205.105Z",
    fill: "#B1B8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.356 205.051L318.367 237.674L318.475 237.727L334.464 205.104L334.356 205.051Z",
    fill: "#B3B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.254 204.999L318.266 237.621L318.373 237.674L334.362 205.051L334.254 204.999Z",
    fill: "#B4BAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.145 204.946L318.156 237.568L318.264 237.621L334.253 204.999L334.145 204.946Z",
    fill: "#B5BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.036 204.888L318.047 237.511L318.155 237.564L334.143 204.941L334.036 204.888Z",
    fill: "#B7BDC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.926 204.835L317.938 237.458L318.045 237.511L334.034 204.888L333.926 204.835Z",
    fill: "#B8BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.825 204.792L317.836 237.415L317.944 237.468L333.932 204.845L333.825 204.792Z",
    fill: "#B9BFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.707 204.735L317.719 237.357L317.826 237.41L333.815 204.788L333.707 204.735Z",
    fill: "#BAC0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.606 204.672L317.617 237.295L317.725 237.348L333.714 204.725L333.606 204.672Z",
    fill: "#BCC1C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.504 204.629L317.516 237.252L317.623 237.305L333.612 204.682L333.504 204.629Z",
    fill: "#BDC2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.387 204.576L317.398 237.198L317.506 237.251L333.495 204.629L333.387 204.576Z",
    fill: "#BEC3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.278 204.528L317.289 237.15L317.397 237.203L333.385 204.581L333.278 204.528Z",
    fill: "#BFC5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.176 204.466L317.188 237.089L317.295 237.142L333.284 204.519L333.176 204.466Z",
    fill: "#C1C6CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.067 204.413L317.078 237.035L317.186 237.088L333.175 204.465L333.067 204.413Z",
    fill: "#C2C7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.957 204.37L316.969 236.992L317.076 237.045L333.065 204.422L332.957 204.37Z",
    fill: "#C3C8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.848 204.312L316.859 236.935L316.967 236.987L332.956 204.365L332.848 204.312Z",
    fill: "#C4C9D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.746 204.258L316.758 236.881L316.866 236.934L332.854 204.311L332.746 204.258Z",
    fill: "#C5CAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.637 204.207L316.648 236.829L316.756 236.882L332.745 204.259L332.637 204.207Z",
    fill: "#C7CBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.528 204.149L316.539 236.771L316.647 236.824L332.635 204.202L332.528 204.149Z",
    fill: "#C8CCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.418 204.095L316.43 236.718L316.537 236.771L332.526 204.148L332.418 204.095Z",
    fill: "#C9CDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.309 204.052L316.32 236.675L316.428 236.728L332.417 204.105L332.309 204.052Z",
    fill: "#CACED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.207 203.99L316.219 236.612L316.327 236.665L332.315 204.043L332.207 203.99Z",
    fill: "#CBD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.098 203.932L316.109 236.555L316.217 236.608L332.206 203.985L332.098 203.932Z",
    fill: "#CCD1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.996 203.889L316.008 236.512L316.116 236.565L332.104 203.942L331.996 203.889Z",
    fill: "#CED2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.879 203.836L315.891 236.459L315.998 236.512L331.987 203.889L331.879 203.836Z",
    fill: "#CFD3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.77 203.789L315.781 236.411L315.889 236.464L331.878 203.841L331.77 203.789Z",
    fill: "#D0D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.668 203.726L315.68 236.349L315.787 236.401L331.776 203.779L331.668 203.726Z",
    fill: "#D1D5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.551 203.673L315.562 236.296L315.67 236.349L331.659 203.726L331.551 203.673Z",
    fill: "#D2D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.45 203.629L315.461 236.252L315.569 236.305L331.557 203.682L331.45 203.629Z",
    fill: "#D3D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.34 203.572L315.352 236.194L315.459 236.247L331.448 203.625L331.34 203.572Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.239 203.51L315.25 236.133L315.358 236.186L331.346 203.563L331.239 203.51Z",
    fill: "#D5D9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.129 203.466L315.141 236.089L315.248 236.142L331.237 203.519L331.129 203.466Z",
    fill: "#D6DADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.012 203.409L315.023 236.031L315.131 236.084L331.12 203.462L331.012 203.409Z",
    fill: "#D7DBDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.911 203.356L314.922 235.979L315.03 236.031L331.018 203.409L330.911 203.356Z",
    fill: "#D8DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.801 203.313L314.812 235.936L314.92 235.988L330.909 203.366L330.801 203.313Z",
    fill: "#D9DCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.7 203.25L314.711 235.873L314.819 235.926L330.807 203.303L330.7 203.25Z",
    fill: "#DADDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.59 203.203L314.602 235.825L314.709 235.878L330.698 203.255L330.59 203.203Z",
    fill: "#DBDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.473 203.15L314.484 235.772L314.592 235.825L330.581 203.203L330.473 203.15Z",
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.371 203.096L314.383 235.719L314.491 235.772L330.479 203.149L330.371 203.096Z",
    fill: "#DDE0E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.262 203.04L314.273 235.662L314.381 235.715L330.37 203.092L330.262 203.04Z",
    fill: "#DEE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.161 202.987L314.172 235.609L314.28 235.662L330.268 203.04L330.161 202.987Z",
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.043 202.933L314.055 235.556L314.162 235.608L330.151 202.986L330.043 202.933Z",
    fill: "#E0E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.942 202.89L313.953 235.513L314.061 235.566L330.05 202.943L329.942 202.89Z",
    fill: "#E1E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.832 202.833L313.844 235.455L313.952 235.508L329.94 202.885L329.832 202.833Z",
    fill: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.723 202.77L313.734 235.393L313.842 235.445L329.831 202.823L329.723 202.77Z",
    fill: "#E3E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.621 202.727L313.633 235.35L313.741 235.402L329.729 202.78L329.621 202.727Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.504 202.669L313.516 235.292L313.623 235.345L329.612 202.722L329.504 202.669Z",
    fill: "#E5E7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.403 202.626L313.414 235.249L313.522 235.302L329.51 202.679L329.403 202.626Z",
    fill: "#E6E8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.286 202.573L313.297 235.195L313.405 235.248L329.393 202.626L329.286 202.573Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.192 202.51L313.203 235.133L313.311 235.186L329.3 202.563L329.192 202.51Z",
    fill: "#E8EAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.075 202.463L313.086 235.086L313.194 235.139L329.182 202.516L329.075 202.463Z",
    fill: "#E9EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.965 202.41L312.977 235.032L313.084 235.085L329.073 202.462L328.965 202.41Z",
    fill: "#E9EBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.864 202.357L312.875 234.979L312.983 235.032L328.971 202.41L328.864 202.357Z",
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.754 202.3L312.766 234.923L312.873 234.976L328.862 202.353L328.754 202.3Z",
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.653 202.247L312.664 234.869L312.772 234.922L328.761 202.299L328.653 202.247Z",
    fill: "#ECEDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.536 202.194L312.547 234.816L312.655 234.869L328.643 202.247L328.536 202.194Z",
    fill: "#EDEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.434 202.15L312.445 234.772L312.553 234.825L328.542 202.203L328.434 202.15Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.325 202.092L312.336 234.715L312.444 234.768L328.432 202.145L328.325 202.092Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.215 202.031L312.227 234.653L312.334 234.706L328.323 202.084L328.215 202.031Z",
    fill: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.106 201.987L312.117 234.609L312.225 234.662L328.214 202.04L328.106 201.987Z",
    fill: "#F0F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.996 201.929L312.008 234.552L312.116 234.605L328.104 201.982L327.996 201.929Z",
    fill: "#F1F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.887 201.886L311.898 234.509L312.006 234.562L327.995 201.939L327.887 201.886Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.786 201.824L311.797 234.446L311.905 234.499L327.893 201.877L327.786 201.824Z",
    fill: "#F2F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.684 201.771L311.695 234.394L311.803 234.446L327.792 201.824L327.684 201.771Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.567 201.723L311.578 234.346L311.686 234.399L327.675 201.776L327.567 201.723Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.457 201.67L311.469 234.293L311.577 234.346L327.565 201.723L327.457 201.67Z",
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.356 201.617L311.367 234.239L311.475 234.292L327.464 201.67L327.356 201.617Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.254 201.565L311.266 234.188L311.373 234.24L327.362 201.618L327.254 201.565Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.129 201.507L311.141 234.13L311.248 234.183L327.237 201.56L327.129 201.507Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.028 201.454L311.039 234.076L311.147 234.129L327.135 201.506L327.028 201.454Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.926 201.411L310.938 234.033L311.045 234.086L327.034 201.463L326.926 201.411Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.817 201.344L310.828 233.967L310.936 234.02L326.925 201.397L326.817 201.344Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.7 201.3L310.711 233.923L310.819 233.976L326.807 201.353L326.7 201.3Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.598 201.248L310.609 233.87L310.717 233.923L326.706 201.3L326.598 201.248Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.496 201.194L310.508 233.816L310.616 233.869L326.604 201.247L326.496 201.194Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.372 201.147L310.383 233.77L310.491 233.822L326.479 201.2L326.372 201.147Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.278 201.084L310.289 233.707L310.397 233.76L326.385 201.137L326.278 201.084Z",
    fill: "#FAFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.168 201.031L310.18 233.653L310.287 233.706L326.276 201.084L326.168 201.031Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.051 200.984L310.062 233.606L310.17 233.659L326.159 201.037L326.051 200.984Z",
    fill: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.95 200.93L309.961 233.553L310.069 233.606L326.057 200.983L325.95 200.93Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.848 200.868L309.859 233.49L309.967 233.543L325.956 200.92L325.848 200.868Z",
    fill: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.746 200.825L309.758 233.447L309.866 233.5L325.854 200.878L325.746 200.825Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.622 200.767L309.633 233.39L309.741 233.442L325.729 200.82L325.622 200.767Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.52 200.724L309.531 233.347L309.639 233.399L325.628 200.777L325.52 200.724Z",
    fill: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.418 200.67L309.43 233.293L309.537 233.346L325.526 200.723L325.418 200.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.301 200.604L309.312 233.227L309.42 233.279L325.409 200.657L325.301 200.604Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.192 200.561L309.203 233.184L309.311 233.236L325.3 200.614L325.192 200.561Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.09 200.507L309.102 233.13L309.209 233.183L325.198 200.56L325.09 200.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.989 200.455L309 233.077L309.108 233.13L325.096 200.507L324.989 200.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.864 200.407L308.875 233.029L308.983 233.082L324.971 200.46L324.864 200.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.77 200.344L308.781 232.967L308.889 233.02L324.878 200.397L324.77 200.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.051 199.995L308.062 232.617L308.781 232.969L324.77 200.347L324.051 199.995Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M330.772 209.41L331.722 209.88L332.192 208.93C332.242 208.82 332.382 208.78 332.482 208.83C332.582 208.88 332.632 209.02 332.582 209.12L332.112 210.07L333.062 210.54C333.172 210.59 333.212 210.73 333.162 210.83C333.112 210.93 332.972 210.98 332.872 210.93L331.922 210.46L331.452 211.41C331.402 211.52 331.262 211.56 331.162 211.51C331.062 211.46 331.012 211.32 331.062 211.22L331.532 210.27L330.582 209.8C330.472 209.75 330.432 209.61 330.482 209.51C330.532 209.41 330.672 209.36 330.772 209.41Z",
    fill: "#090E16"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M330.655 209.08L331.605 209.55L332.075 208.6C332.125 208.49 332.265 208.45 332.365 208.5C332.465 208.55 332.515 208.69 332.465 208.79L331.995 209.74L332.945 210.21C333.055 210.26 333.095 210.4 333.045 210.5C332.995 210.6 332.855 210.65 332.755 210.6L331.805 210.13L331.335 211.08C331.285 211.19 331.145 211.23 331.045 211.18C330.945 211.13 330.895 210.99 330.945 210.89L331.415 209.94L330.465 209.47C330.355 209.42 330.315 209.28 330.365 209.18C330.415 209.08 330.555 209.03 330.655 209.08Z",
    fill: "#090E16"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M348.781 241.17C342.961 238.22 334.271 232.82 327.061 223.34C317.271 210.48 315.371 196.89 312.971 179.84C311.481 169.26 311.371 160.8 311.371 143.87C311.371 130.82 311.901 118.56 312.971 107.1C314.301 95.3796 316.431 85.1196 319.361 76.3296C322.561 67.5396 327.221 60.6096 333.351 55.5496C338.181 51.5596 344.181 49.1496 351.331 48.2996C346.791 32.5096 340.441 17.2096 331.801 2.59961C325.021 4.12961 318.871 6.31961 313.371 9.18961C301.911 15.3196 292.591 23.4396 285.391 33.5696C278.201 43.6896 272.741 55.0196 269.001 67.5396C265.541 80.0596 263.141 92.8496 261.811 105.9C260.741 118.69 260.211 130.81 260.211 142.27C260.211 153.73 260.881 166.51 262.211 179.84C263.541 193.16 265.941 206.08 269.401 218.6C273.131 231.12 278.591 242.58 285.791 252.97C292.981 263.09 302.441 271.22 314.161 277.35C316.861 278.76 319.711 280.01 322.711 281.09C324.801 280.65 337.521 277.77 344.881 265.33C351.311 254.47 349.301 243.67 348.771 241.16L348.781 241.17Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 260,
    y: 2,
    width: 92,
    height: 280
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M348.781 241.17C342.961 238.22 334.271 232.82 327.061 223.34C317.271 210.48 315.371 196.89 312.971 179.84C311.481 169.26 311.371 160.8 311.371 143.87C311.371 130.82 311.901 118.56 312.971 107.1C314.301 95.3796 316.431 85.1196 319.361 76.3296C322.561 67.5396 327.221 60.6096 333.351 55.5496C338.181 51.5596 344.181 49.1496 351.331 48.2996C346.791 32.5096 340.441 17.2096 331.801 2.59961C325.021 4.12961 318.871 6.31961 313.371 9.18961C301.911 15.3196 292.591 23.4396 285.391 33.5696C278.201 43.6896 272.741 55.0196 269.001 67.5396C265.541 80.0596 263.141 92.8496 261.811 105.9C260.741 118.69 260.211 130.81 260.211 142.27C260.211 153.73 260.881 166.51 262.211 179.84C263.541 193.16 265.941 206.08 269.401 218.6C273.131 231.12 278.591 242.58 285.791 252.97C292.981 263.09 302.441 271.22 314.161 277.35C316.861 278.76 319.711 280.01 322.711 281.09C324.801 280.65 337.521 277.77 344.881 265.33C351.311 254.47 349.301 243.67 348.771 241.16L348.781 241.17Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M343.984 222.529C342.284 221.029 340.184 220.109 337.824 220.159C336.954 219.319 335.944 218.619 334.834 218.169C333.624 215.399 331.264 213.249 327.864 213.159C323.704 213.059 318.584 216.319 318.804 221.059C319.034 225.809 319.504 231.369 323.824 234.309C324.904 235.049 326.104 235.539 327.354 235.789C328.694 237.459 330.384 238.769 332.524 239.349C335.114 240.059 337.754 239.849 340.114 238.569C340.424 238.399 340.714 238.209 341.004 238.009C341.064 238.009 341.124 238.009 341.184 237.999C345.624 237.619 348.904 232.159 347.904 228.029C347.284 225.459 345.864 223.619 343.964 222.519L343.984 222.529Z",
    fill: "url(#paint2_radial_1342_37795)"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M381.668 244.44C381.118 244.4 378.378 244.13 374.708 244.59C370.718 245.09 367.908 246.18 367.378 246.37C363.868 247.59 355.418 245.47 333.898 231.11C335.138 234.61 339.588 245.82 351.458 252.81C353.748 254.16 371.328 264.11 388.568 254.37C399.858 247.99 406.698 235.59 406.498 222.22C392.388 240.54 385.418 244.69 381.688 244.44H381.668Z",
    fill: "url(#paint3_radial_1342_37795)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M408.917 239.63C406.577 243.03 402.977 243.97 398.747 245.08C393.217 246.54 383.817 249.01 378.397 243.54C372.887 237.99 373.967 226.77 377.167 225.19C377.737 224.91 378.687 224.78 379.577 224.96C382.187 225.5 383.047 228.49 384.027 228.22C385.057 227.93 384.107 224.66 386.057 223.15C386.877 222.51 387.937 222.42 388.977 222.32C389.387 222.28 390.877 222.13 392.207 222.64C395.267 223.79 395.547 227.57 396.537 227.41C397.257 227.29 396.807 225.37 398.427 223.51C398.557 223.36 400.457 221.24 403.077 221.19C405.207 221.15 406.647 222.48 407.317 223.1C411.117 226.61 412.447 234.49 408.907 239.62L408.917 239.63Z",
    fill: "#EDBF1C"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.665 240.671C385.865 242.511 379.385 241.261 376.195 240.421C376.765 241.571 377.485 242.641 378.395 243.551C383.825 249.021 393.215 246.541 398.745 245.091C402.965 243.981 406.575 243.031 408.915 239.641C410.625 237.151 411.195 234.021 410.905 231.051C408.555 233.391 402.775 238.521 393.665 240.671Z",
    fill: "white"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M384.281 229.67C384.401 229.25 385.261 226.43 388.001 225.34C389.541 224.72 390.911 224.96 391.441 225.06C394.671 225.67 396.321 228.5 396.611 229C396.911 227.99 397.621 226.18 399.281 224.61C399.731 224.18 400.581 223.38 401.671 223C405.211 221.77 409.171 225.77 409.341 225.94C409.051 225.26 408.471 224.13 407.341 223.11C406.711 222.54 405.231 221.21 403.101 221.2C400.701 221.19 399.081 222.86 398.451 223.52C397.001 225.03 396.511 226.72 396.341 227.51C396.201 227.03 395.151 223.7 392.221 222.65C390.861 222.16 389.441 222.29 388.991 222.33C388.201 222.4 387.041 222.51 386.071 223.16C383.901 224.61 384.021 227.87 384.041 228.23C383.621 227.51 382.561 225.96 380.611 225.22C380.021 225 379.171 224.68 378.111 224.89C376.311 225.24 375.381 226.8 375.171 227.17C374.131 228.93 374.511 230.74 374.611 231.17C374.611 230.61 374.701 229.45 375.501 228.5C377.231 226.46 380.601 227.39 381.001 227.5C382.671 227.98 383.741 229.03 384.281 229.67Z",
    fill: "#E9AB21"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M344.273 245.47C344.273 245.47 345.363 250.5 351.663 253.42C352.683 253.89 353.413 253.96 354.043 253.79C355.253 253.47 355.963 252.37 356.133 252.1C356.713 251.15 356.453 250.69 356.983 249.85C357.593 248.88 358.573 248.51 359.073 248.31C363.723 246.41 371.643 243.18 372.023 240.19C372.373 237.4 366.213 234.16 362.643 233.01C360.483 232.32 358.693 232.2 357.903 232.18C354.673 232.08 352.303 232.93 351.763 233.13C350.313 233.67 348.253 234.44 346.563 236.39C344.573 238.69 343.553 242.1 344.283 245.47H344.273Z",
    fill: "#E9AB21"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M348.435 236.58C351.165 231.68 356.325 232.06 361.535 232.44C366.235 232.78 370.725 233.11 373.035 237.51C376.285 243.69 372.785 253.4 370.385 254.3C369.955 254.46 369.195 254.48 368.595 254.13C367.345 253.4 367.655 251.46 366.935 251.37C366.105 251.28 365.705 253.83 363.785 254.62C362.955 254.96 362.095 254.88 361.725 254.84C361.455 254.81 360.455 254.72 359.615 254.16C357.685 252.86 357.725 249.78 357.045 249.79C356.555 249.79 356.755 251.42 355.615 252.65C355.525 252.75 354.265 254.08 352.635 253.77C351.335 253.52 350.435 252.36 350.005 251.8C347.685 248.78 345.525 241.73 348.405 236.57L348.435 236.58Z",
    fill: "#EDBF1C"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.359 245.4C347.909 248.69 349.219 250.75 350.029 251.81C350.409 252.31 351.089 253.26 352.279 253.69C352.889 253.91 353.329 253.89 353.419 253.89C354.669 253.84 355.519 252.9 355.689 252.71C356.879 251.4 356.639 249.84 357.049 249.8C357.629 249.74 357.599 252.81 359.619 254.17C360.449 254.73 361.449 254.83 361.729 254.85C362.089 254.89 362.949 254.97 363.789 254.63C365.709 253.84 366.109 251.29 366.939 251.38C367.659 251.46 367.349 253.41 368.599 254.14C369.299 254.54 370.079 254.39 370.329 254.32C370.329 254.32 370.359 254.32 370.389 254.31C371.379 254.03 372.189 252.43 372.369 252.06C372.769 251.26 373.269 250.08 373.659 248.54C373.449 249.2 373.009 250.33 372.049 251.38C371.499 251.99 370.909 252.63 370.139 252.73C368.919 252.9 367.569 251.69 366.789 249.76C366.679 249.89 364.669 252.25 361.629 251.8C358.539 251.35 357.349 248.46 357.289 248.3C357.079 248.55 355.309 250.64 352.669 250.52C350.139 250.41 347.879 248.32 347.359 245.39V245.4Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.086 167.171C442.426 167.861 439.656 170.361 436.866 171.971C435.166 172.951 434.236 173.161 433.496 174.341C432.716 175.591 433.106 176.401 432.696 178.191C432.056 181.001 430.046 183.661 429.136 183.421C428.246 183.191 428.796 180.331 428.116 176.211C428.006 175.581 427.886 174.961 427.746 174.371C427.746 174.341 427.726 174.311 427.726 174.281C427.666 174.281 427.616 174.281 427.556 174.281C427.166 174.261 426.756 174.191 426.346 174.081C425.636 173.881 424.886 173.551 424.126 173.091C420.586 170.971 416.666 166.181 413.796 159.981C413.506 159.361 413.236 158.741 412.986 158.121C409.316 149.161 409.356 140.841 413.256 139.031C414.006 138.681 414.846 138.601 415.756 138.751C419.866 139.451 425.246 145.081 428.906 152.981C429.716 154.731 430.386 156.471 430.926 158.161C432.116 161.961 432.606 165.491 432.366 168.281C433.866 168.251 435.466 168.111 437.156 167.811C439.656 167.371 441.846 166.631 442.106 167.181L442.086 167.171Z",
    fill: "#090E16"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M442.742 166.86C443.082 167.55 440.312 170.05 437.522 171.66C435.822 172.64 434.892 172.85 434.152 174.03C433.372 175.28 433.762 176.09 433.352 177.88C432.712 180.69 430.702 183.35 429.792 183.11C428.902 182.88 429.452 180.02 428.772 175.9C428.662 175.27 428.542 174.65 428.402 174.06C428.402 174.03 428.382 174 428.382 173.97C428.322 173.97 428.272 173.97 428.212 173.97C427.822 173.95 427.412 173.88 427.002 173.77C426.292 173.57 425.542 173.24 424.782 172.78C421.242 170.66 417.322 165.87 414.452 159.67C414.162 159.05 413.892 158.43 413.642 157.81C409.972 148.85 410.012 140.53 413.912 138.72C414.662 138.37 415.502 138.29 416.412 138.44C420.522 139.14 425.902 144.77 429.562 152.67C430.372 154.42 431.042 156.16 431.582 157.85C432.772 161.65 433.262 165.18 433.022 167.97C434.522 167.94 436.122 167.8 437.812 167.5C440.312 167.06 442.502 166.32 442.762 166.87L442.742 166.86Z",
    fill: "#858F9E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 424,
    y: 157,
    width: 19,
    height: 27
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M442.708 166.88C443.048 167.57 440.278 170.07 437.488 171.68C435.788 172.66 434.858 172.87 434.118 174.05C433.338 175.3 433.728 176.11 433.318 177.9C432.678 180.71 430.668 183.37 429.758 183.13C428.868 182.9 429.418 180.04 428.738 175.92C428.628 175.29 428.508 174.67 428.368 174.08C428.298 174.04 428.238 174.01 428.178 173.98C427.788 173.96 427.378 173.89 426.968 173.78C426.258 173.58 425.508 173.25 424.748 172.79C424.408 169.61 424.778 166.6 425.768 164.08C425.808 163.97 425.848 163.86 425.898 163.76C427.058 160.99 428.988 158.87 431.538 157.86C432.728 161.66 433.218 165.19 432.978 167.98C434.478 167.95 436.078 167.81 437.768 167.51C440.268 167.07 442.458 166.33 442.718 166.88H442.708Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.149 157.4L434.999 159.3L424.919 174.39L419.719 163.16L432.149 157.4Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.002 159.301L435.142 159.391L425.002 174.561L424.922 174.391L435.002 159.301Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.14 159.391L435.27 159.481L425.08 174.731L425 174.561L435.14 159.391Z",
    fill: "#848E9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.268 159.48L435.408 159.57L425.158 174.91L425.078 174.73L435.268 159.48Z",
    fill: "#838D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.406 159.57L435.536 159.66L425.236 175.08L425.156 174.91L435.406 159.57Z",
    fill: "#828B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.542 159.66L435.682 159.75L425.322 175.25L425.242 175.08L435.542 159.66Z",
    fill: "#808A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.68 159.75L435.81 159.84L425.4 175.42L425.32 175.25L435.68 159.75Z",
    fill: "#7F8998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.808 159.841L435.948 159.931L425.478 175.601L425.398 175.421L435.808 159.841Z",
    fill: "#7E8896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.947 159.931L436.077 160.021L425.557 175.771L425.477 175.601L435.947 159.931Z",
    fill: "#7D8795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.082 160.021L436.223 160.111L425.643 175.941L425.562 175.771L436.082 160.021Z",
    fill: "#7C8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.221 160.11L436.351 160.2L425.721 176.12L425.641 175.94L436.221 160.11Z",
    fill: "#7B8493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.349 160.2L436.489 160.29L425.799 176.29L425.719 176.12L436.349 160.2Z",
    fill: "#798391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.487 160.29L436.617 160.38L425.877 176.46L425.797 176.29L436.487 160.29Z",
    fill: "#788290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.615 160.381L436.755 160.471L425.955 176.631L425.875 176.461L436.615 160.381Z",
    fill: "#77818F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.761 160.471L436.901 160.561L426.041 176.811L425.961 176.631L436.761 160.471Z",
    fill: "#767F8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.899 160.561L437.029 160.651L426.119 176.981L426.039 176.811L436.899 160.561Z",
    fill: "#757E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.027 160.65L437.167 160.74L426.197 177.15L426.117 176.98L437.027 160.65Z",
    fill: "#747D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.165 160.74L437.295 160.83L426.275 177.33L426.195 177.15L437.165 160.74Z",
    fill: "#737C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.301 160.83L437.441 160.92L426.371 177.5L426.281 177.33L437.301 160.83Z",
    fill: "#727B89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.437 160.92L437.567 161.01L426.447 177.67L426.367 177.5L437.437 160.92Z",
    fill: "#707A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.565 161.011L437.705 161.101L426.525 177.841L426.445 177.671L437.565 161.011Z",
    fill: "#6F7886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.711 161.101L437.841 161.201L426.611 178.021L426.531 177.841L437.711 161.101Z",
    fill: "#6E7785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.839 161.2L437.979 161.29L426.689 178.19L426.609 178.02L437.839 161.2Z",
    fill: "#6D7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.978 161.29L438.107 161.38L426.767 178.36L426.688 178.19L437.978 161.29Z",
    fill: "#6C7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.106 161.381L438.246 161.471L426.846 178.541L426.766 178.361L438.106 161.381Z",
    fill: "#6B7481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.252 161.471L438.382 161.561L426.932 178.711L426.852 178.541L438.252 161.471Z",
    fill: "#6A7380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.38 161.561L438.52 161.651L427.01 178.881L426.93 178.711L438.38 161.561Z",
    fill: "#69717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.518 161.65L438.648 161.74L427.088 179.06L427.008 178.88L438.518 161.65Z",
    fill: "#68707E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.646 161.74L438.786 161.83L427.166 179.23L427.086 179.06L438.646 161.74Z",
    fill: "#666F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.792 161.83L438.932 161.92L427.252 179.4L427.172 179.23L438.792 161.83Z",
    fill: "#656E7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.93 161.92L439.06 162.01L427.33 179.57L427.25 179.4L438.93 161.92Z",
    fill: "#646D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.058 162.011L439.198 162.101L427.408 179.751L427.328 179.571L439.058 162.011Z",
    fill: "#636C79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.196 162.101L439.326 162.191L427.486 179.921L427.406 179.751L439.196 162.101Z",
    fill: "#626B78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.332 162.19L439.472 162.28L427.572 180.09L427.492 179.92L439.332 162.19Z",
    fill: "#616A76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.47 162.28L439.6 162.37L427.65 180.27L427.57 180.09L439.47 162.28Z",
    fill: "#606875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.598 162.37L439.738 162.46L427.728 180.44L427.648 180.27L439.598 162.37Z",
    fill: "#5F6774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.737 162.46L439.867 162.55L427.807 180.61L427.727 180.44L439.737 162.46Z",
    fill: "#5E6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.872 162.551L440.013 162.641L427.893 180.781L427.812 180.611L439.872 162.551Z",
    fill: "#5D6572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.011 162.641L440.141 162.731L427.971 180.961L427.891 180.781L440.011 162.641Z",
    fill: "#5C6471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.139 162.73L440.279 162.82L428.049 181.13L427.969 180.96L440.139 162.73Z",
    fill: "#5B636F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.277 162.82L440.407 162.91L428.127 181.3L428.047 181.13L440.277 162.82Z",
    fill: "#59626E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.405 162.91L440.545 163L428.205 181.48L428.125 181.3L440.405 162.91Z",
    fill: "#58616D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.551 163L440.681 163.09L428.291 181.65L428.211 181.48L440.551 163Z",
    fill: "#575F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.679 163.091L440.819 163.181L428.369 181.821L428.289 181.651L440.679 163.091Z",
    fill: "#565E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.817 163.181L440.947 163.271L428.447 181.991L428.367 181.821L440.817 163.181Z",
    fill: "#555D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.945 163.271L441.085 163.361L428.525 182.171L428.445 181.991L440.945 163.271Z",
    fill: "#545C68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.091 163.36L441.101 163.37L441.181 163.53L428.611 182.34L428.531 182.17L441.091 163.36Z",
    fill: "#535B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.259 163.7L428.689 182.51L428.609 182.34L441.179 163.53L441.259 163.7Z",
    fill: "#525A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.337 163.87L428.767 182.69L428.688 182.51L441.258 163.7L441.337 163.87Z",
    fill: "#515965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.416 164.05L428.846 182.86L428.766 182.69L441.336 163.87L441.416 164.05Z",
    fill: "#505864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.502 164.221L428.932 183.031L428.852 182.861L441.422 164.051L441.502 164.221Z",
    fill: "#4F5763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.58 164.391L429.01 183.211L428.93 183.031L441.5 164.221L441.58 164.391Z",
    fill: "#4E5662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.658 164.571L429.088 183.381L429.008 183.211L441.578 164.391L441.658 164.571Z",
    fill: "#4D5560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.736 164.74L429.166 183.55L429.086 183.38L441.656 164.57L441.736 164.74Z",
    fill: "#4C545F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.822 164.91L429.252 183.72L429.172 183.55L441.742 164.74L441.822 164.91Z",
    fill: "#4B535E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.9 165.08L429.33 183.9L429.25 183.72L441.82 164.91L441.9 165.08Z",
    fill: "#4A515D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.978 165.26L429.518 183.91L429.368 183.98L429.328 183.9L441.898 165.08L441.978 165.26Z",
    fill: "#49505C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.056 165.431L429.806 183.771L429.516 183.911L441.976 165.261L442.056 165.431Z",
    fill: "#484F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.143 165.601L430.092 183.641L429.812 183.771L442.062 165.431L442.143 165.601Z",
    fill: "#474E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.216 165.781L430.366 183.511L430.086 183.641L442.136 165.601L442.216 165.781Z",
    fill: "#464D59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.297 165.95L430.657 183.38L430.367 183.51L442.217 165.78L442.297 165.95Z",
    fill: "#454C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.376 166.12L430.936 183.25L430.656 183.38L442.296 165.95L442.376 166.12Z",
    fill: "#444B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.457 166.3L431.217 183.12L430.938 183.25L442.378 166.12L442.457 166.3Z",
    fill: "#434A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.539 166.471L431.509 182.981L431.219 183.121L442.459 166.301L442.539 166.471Z",
    fill: "#424954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.618 166.641L431.788 182.851L431.508 182.981L442.538 166.471L442.618 166.641Z",
    fill: "#414853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.699 166.811L432.069 182.721L431.789 182.851L442.619 166.641L442.699 166.811Z",
    fill: "#404752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.78 166.991L432.36 182.591L432.07 182.721L442.7 166.811L442.78 166.991Z",
    fill: "#3F4651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.859 167.16L432.639 182.46L432.359 182.59L442.779 166.99L442.859 167.16Z",
    fill: "#3E4550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.941 167.33L432.921 182.33L432.641 182.46L442.861 167.16L442.941 167.33Z",
    fill: "#3D444F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.022 167.51L433.212 182.2L432.922 182.33L442.942 167.33L443.022 167.51Z",
    fill: "#3C434E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.101 167.681L433.491 182.061L433.211 182.201L443.021 167.511L443.101 167.681Z",
    fill: "#3B424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.182 167.851L433.782 181.931L433.492 182.061L443.102 167.681L443.182 167.851Z",
    fill: "#3A414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.261 168.021L434.061 181.801L433.781 181.931L443.181 167.851L443.261 168.021Z",
    fill: "#39404B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.342 168.201L434.342 181.671L434.062 181.801L443.263 168.021L443.342 168.201Z",
    fill: "#383F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.416 168.37L434.626 181.54L434.336 181.67L443.336 168.2L443.416 168.37Z",
    fill: "#373E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.495 168.54L434.905 181.41L434.625 181.54L443.415 168.37L443.495 168.54Z",
    fill: "#363D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.576 168.72L435.186 181.28L434.906 181.41L443.496 168.54L443.576 168.72Z",
    fill: "#353C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.658 168.891L435.478 181.141L435.188 181.281L443.577 168.721L443.658 168.891Z",
    fill: "#343B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.737 169.061L435.757 181.011L435.477 181.141L443.657 168.891L443.737 169.061Z",
    fill: "#333A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.818 169.231L436.038 180.881L435.758 181.011L443.738 169.061L443.818 169.231Z",
    fill: "#333944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.899 169.41L436.329 180.75L436.039 180.88L443.819 169.23L443.899 169.41Z",
    fill: "#323843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.978 169.58L436.608 180.62L436.328 180.75L443.898 169.41L443.978 169.58Z",
    fill: "#313742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.059 169.75L436.889 180.49L436.609 180.62L443.979 169.58L444.059 169.75Z",
    fill: "#303641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.141 169.93L437.181 180.35L436.891 180.49L444.061 169.75L444.141 169.93Z",
    fill: "#2F3540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.22 170.101L437.46 180.221L437.18 180.351L444.14 169.931L444.22 170.101Z",
    fill: "#2E343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.301 170.271L437.741 180.091L437.461 180.221L444.221 170.101L444.301 170.271Z",
    fill: "#2D343E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.382 170.451L438.032 179.961L437.742 180.09L444.302 170.271L444.382 170.451Z",
    fill: "#2C333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.461 170.62L438.311 179.83L438.031 179.96L444.381 170.45L444.461 170.62Z",
    fill: "#2B323C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.543 170.79L438.603 179.7L438.312 179.83L444.462 170.62L444.543 170.79Z",
    fill: "#2A313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.622 170.96L438.882 179.57L438.602 179.7L444.542 170.79L444.622 170.96Z",
    fill: "#2A303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.695 171.14L439.155 179.43L438.875 179.57L444.615 170.96L444.695 171.14Z",
    fill: "#292F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.786 171.311L439.446 179.301L439.156 179.431L444.696 171.141L444.786 171.311Z",
    fill: "#282E38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.865 171.481L439.725 179.171L439.445 179.301L444.785 171.311L444.865 171.481Z",
    fill: "#272D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.947 171.66L440.007 179.04L439.727 179.17L444.867 171.48L444.947 171.66Z",
    fill: "#262C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.028 171.83L440.298 178.91L440.008 179.04L444.948 171.66L445.028 171.83Z",
    fill: "#252B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.107 172L440.577 178.78L440.297 178.91L445.027 171.83L445.107 172Z",
    fill: "#242A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.188 172.17L440.858 178.65L440.578 178.78L445.108 172L445.188 172.17Z",
    fill: "#232A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.269 172.35L441.149 178.51L440.859 178.65L445.189 172.17L445.269 172.35Z",
    fill: "#232932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.348 172.521L441.428 178.381L441.148 178.511L445.268 172.351L445.348 172.521Z",
    fill: "#222831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.43 172.691L441.71 178.251L441.43 178.381L445.35 172.521L445.43 172.691Z",
    fill: "#212730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.511 172.87L442.001 178.12L441.711 178.25L445.431 172.69L445.511 172.87Z",
    fill: "#20262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.59 173.04L442.28 177.99L442 178.12L445.51 172.87L445.59 173.04Z",
    fill: "#1F252F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.671 173.21L442.561 177.86L442.281 177.99L445.591 173.04L445.671 173.21Z",
    fill: "#1F242E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.753 173.38L442.853 177.72L442.562 177.86L445.673 173.21L445.753 173.38Z",
    fill: "#1E242D"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M416.397 138.43C416.707 139.62 416.697 141.07 416.187 142.23C415.417 144 413.987 143.97 412.827 145.4C409.667 149.3 414.267 157.14 413.627 157.8C409.957 148.85 409.997 140.52 413.897 138.71C414.647 138.36 415.487 138.28 416.397 138.43Z",
    fill: "#090E16"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.457 147.361C421.783 147.361 422.047 147.097 422.047 146.771C422.047 146.445 421.783 146.181 421.457 146.181C421.131 146.181 420.867 146.445 420.867 146.771C420.867 147.097 421.131 147.361 421.457 147.361Z",
    fill: "#090E16"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.77 152.17C420.51 152.17 421.11 151.57 421.11 150.83C421.11 150.09 420.51 149.49 419.77 149.49C419.03 149.49 418.43 150.09 418.43 150.83C418.43 151.57 419.03 152.17 419.77 152.17Z",
    fill: "#090E16"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.075 152.55C424.324 152.55 424.525 152.349 424.525 152.1C424.525 151.852 424.324 151.65 424.075 151.65C423.826 151.65 423.625 151.852 423.625 152.1C423.625 152.349 423.826 152.55 424.075 152.55Z",
    fill: "#090E16"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.383 156.72C423.483 156.72 423.563 156.64 423.563 156.54C423.563 156.441 423.483 156.36 423.383 156.36C423.284 156.36 423.203 156.441 423.203 156.54C423.203 156.64 423.284 156.72 423.383 156.72Z",
    fill: "#090E16"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.864 162.971C421.074 162.971 421.244 162.801 421.244 162.591C421.244 162.381 421.074 162.211 420.864 162.211C420.655 162.211 420.484 162.381 420.484 162.591C420.484 162.801 420.655 162.971 420.864 162.971Z",
    fill: "#090E16"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.3 166.031C428.156 166.031 428.85 165.337 428.85 164.481C428.85 163.625 428.156 162.931 427.3 162.931C426.444 162.931 425.75 163.625 425.75 164.481C425.75 165.337 426.444 166.031 427.3 166.031Z",
    fill: "#090E16"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1342_37795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 411,
    y: 138,
    width: 32,
    height: 33
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M442.747 166.86C442.487 166.31 440.297 167.04 437.797 167.49C436.117 167.79 434.517 167.93 433.007 167.96C433.247 165.17 432.757 161.64 431.567 157.84C431.037 156.15 430.367 154.41 429.547 152.66C425.877 144.76 420.507 139.13 416.397 138.43C415.497 138.28 414.647 138.36 413.897 138.71C413.087 139.08 412.447 139.74 411.977 140.62C422.817 145.85 428.157 158.78 429.757 170.13C433.547 168.57 437.247 168.49 440.337 169.74C441.877 168.51 442.957 167.31 442.737 166.86H442.747Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1342_37795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.766 139.711L411.594 139.791L428.115 175.416L428.288 175.336L411.766 139.711Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.876 139.661L411.758 139.716L428.279 175.341L428.397 175.287L411.876 139.661Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.993 139.605L411.875 139.66L428.397 175.286L428.515 175.231L411.993 139.605Z",
    fill: "#87909F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11 139.555L411.992 139.609L428.514 175.235L428.632 175.18L412.11 139.555Z",
    fill: "#8892A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.227 139.499L412.109 139.554L428.631 175.179L428.749 175.124L412.227 139.499Z",
    fill: "#8A93A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.345 139.443L412.227 139.498L428.748 175.123L428.866 175.069L412.345 139.443Z",
    fill: "#8B95A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.47 139.388L412.352 139.442L428.873 175.068L428.991 175.013L412.47 139.388Z",
    fill: "#8D96A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.587 139.332L412.469 139.387L428.99 175.012L429.108 174.957L412.587 139.332Z",
    fill: "#8E97A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.704 139.281L412.586 139.336L429.108 174.961L429.226 174.907L412.704 139.281Z",
    fill: "#9099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.821 139.226L412.703 139.28L429.225 174.906L429.343 174.851L412.821 139.226Z",
    fill: "#919AA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.93 139.171L412.812 139.226L429.334 174.851L429.452 174.796L412.93 139.171Z",
    fill: "#939BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.063 139.115L412.945 139.17L429.467 174.795L429.585 174.741L413.063 139.115Z",
    fill: "#949DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.165 139.064L413.047 139.119L429.569 174.745L429.686 174.69L413.165 139.064Z",
    fill: "#969EAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.29 139.009L413.172 139.063L429.694 174.689L429.811 174.634L413.29 139.009Z",
    fill: "#97A0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.407 138.943L413.289 138.998L429.811 174.623L429.929 174.569L413.407 138.943Z",
    fill: "#98A1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.524 138.897L413.406 138.952L429.928 174.578L430.046 174.523L413.524 138.897Z",
    fill: "#9AA2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.649 138.833L413.531 138.888L430.053 174.513L430.171 174.458L413.649 138.833Z",
    fill: "#9BA4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.759 138.791L413.641 138.846L430.162 174.471L430.28 174.416L413.759 138.791Z",
    fill: "#9DA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.884 138.735L413.766 138.79L430.287 174.415L430.405 174.361L413.884 138.735Z",
    fill: "#9EA6B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.001 138.681L413.883 138.735L430.404 174.361L430.522 174.306L414.001 138.681Z",
    fill: "#A0A7B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.118 138.624L414 138.679L430.522 174.304L430.64 174.249L414.118 138.624Z",
    fill: "#A1A9B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.227 138.574L414.109 138.629L430.631 174.254L430.749 174.2L414.227 138.574Z",
    fill: "#A2AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.345 138.518L414.227 138.572L430.748 174.198L430.866 174.143L414.345 138.518Z",
    fill: "#A4ABB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.462 138.453L414.344 138.508L430.865 174.133L430.983 174.079L414.462 138.453Z",
    fill: "#A5ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.587 138.407L414.469 138.462L430.99 174.087L431.108 174.033L414.587 138.407Z",
    fill: "#A7AEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.696 138.347L414.578 138.401L431.1 174.027L431.218 173.972L414.696 138.347Z",
    fill: "#A8AFBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.821 138.301L414.703 138.355L431.225 173.981L431.343 173.926L414.821 138.301Z",
    fill: "#A9B0BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.938 138.235L414.82 138.29L431.342 173.915L431.46 173.861L414.938 138.235Z",
    fill: "#ABB2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.055 138.189L414.938 138.244L431.459 173.87L431.577 173.815L415.055 138.189Z",
    fill: "#ACB3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.173 138.125L415.055 138.18L431.576 173.805L431.694 173.75L415.173 138.125Z",
    fill: "#ADB4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.282 138.083L415.164 138.138L431.686 173.763L431.804 173.708L415.282 138.083Z",
    fill: "#AFB5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.415 138.027L415.297 138.082L431.819 173.707L431.936 173.653L415.415 138.027Z",
    fill: "#B0B7C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.524 137.973L415.406 138.027L431.928 173.653L432.046 173.598L415.524 137.973Z",
    fill: "#B1B8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.641 137.917L415.523 137.972L432.045 173.597L432.163 173.542L415.641 137.917Z",
    fill: "#B3B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.759 137.855L415.641 137.91L432.162 173.536L432.28 173.481L415.759 137.855Z",
    fill: "#B4BAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.876 137.811L415.758 137.865L432.279 173.491L432.397 173.436L415.876 137.811Z",
    fill: "#B5BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.001 137.745L415.883 137.8L432.404 173.425L432.522 173.371L416.001 137.745Z",
    fill: "#B7BDC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.118 137.699L416 137.754L432.522 173.379L432.64 173.325L416.118 137.699Z",
    fill: "#B8BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.235 137.635L416.117 137.689L432.639 173.315L432.757 173.26L416.235 137.635Z",
    fill: "#B9BFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.352 137.593L416.234 137.647L432.756 173.273L432.874 173.218L416.352 137.593Z",
    fill: "#BAC0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.462 137.528L416.344 137.583L432.865 173.208L432.983 173.154L416.462 137.528Z",
    fill: "#BCC1C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.594 137.482L416.477 137.537L432.998 173.163L433.116 173.108L416.594 137.482Z",
    fill: "#BDC2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.712 137.426L416.594 137.48L433.115 173.106L433.233 173.051L416.712 137.426Z",
    fill: "#BEC3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.813 137.365L416.695 137.42L433.217 173.045L433.335 172.991L416.813 137.365Z",
    fill: "#BFC5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.946 137.319L416.828 137.374L433.35 172.999L433.468 172.945L416.946 137.319Z",
    fill: "#C1C6CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.055 137.255L416.938 137.31L433.459 172.935L433.577 172.88L417.055 137.255Z",
    fill: "#C2C7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.173 137.209L417.055 137.264L433.576 172.889L433.694 172.834L417.173 137.209Z",
    fill: "#C3C8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.29 137.148L417.172 137.203L433.694 172.829L433.811 172.774L417.29 137.148Z",
    fill: "#C4C9D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.407 137.103L417.289 137.157L433.811 172.783L433.929 172.728L417.407 137.103Z",
    fill: "#C5CAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.532 137.037L417.414 137.092L433.936 172.717L434.054 172.663L417.532 137.037Z",
    fill: "#C7CBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.649 136.991L417.531 137.046L434.053 172.671L434.171 172.617L417.649 136.991Z",
    fill: "#C8CCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.759 136.927L417.641 136.981L434.162 172.607L434.28 172.552L417.759 136.927Z",
    fill: "#C9CDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.884 136.875L417.766 136.93L434.287 172.555L434.405 172.5L417.884 136.875Z",
    fill: "#CACED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.993 136.82L417.875 136.875L434.397 172.5L434.515 172.446L417.993 136.82Z",
    fill: "#CBD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.118 136.765L418 136.819L434.522 172.445L434.64 172.39L418.118 136.765Z",
    fill: "#CCD1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.243 136.719L418.125 136.773L434.647 172.399L434.765 172.344L418.243 136.719Z",
    fill: "#CED2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.345 136.657L418.227 136.712L434.748 172.337L434.866 172.283L418.345 136.657Z",
    fill: "#CFD3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.47 136.611L418.352 136.666L434.873 172.291L434.991 172.237L418.47 136.611Z",
    fill: "#D0D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.587 136.547L418.469 136.602L434.99 172.227L435.108 172.172L418.587 136.547Z",
    fill: "#D1D5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.712 136.501L418.594 136.556L435.115 172.181L435.233 172.126L418.712 136.501Z",
    fill: "#D2D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.829 136.437L418.711 136.491L435.233 172.117L435.351 172.062L418.829 136.437Z",
    fill: "#D3D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.938 136.385L418.82 136.439L435.342 172.065L435.46 172.01L418.938 136.385Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.055 136.329L418.938 136.384L435.459 172.009L435.577 171.954L419.055 136.329Z",
    fill: "#D5D9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.18 136.273L419.062 136.328L435.584 171.954L435.702 171.899L419.18 136.273Z",
    fill: "#D6DADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.29 136.219L419.172 136.273L435.694 171.899L435.811 171.844L419.29 136.219Z",
    fill: "#D7DBDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.407 136.167L419.289 136.222L435.811 171.847L435.929 171.792L419.407 136.167Z",
    fill: "#D8DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.524 136.112L419.406 136.167L435.928 171.792L436.046 171.738L419.524 136.112Z",
    fill: "#D9DCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.649 136.057L419.531 136.111L436.053 171.737L436.171 171.682L419.649 136.057Z",
    fill: "#DADDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.766 136.011L419.648 136.065L436.17 171.691L436.288 171.636L419.766 136.011Z",
    fill: "#DBDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.876 135.95L419.758 136.005L436.279 171.63L436.397 171.576L419.876 135.95Z",
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.001 135.894L419.883 135.948L436.404 171.574L436.522 171.519L420.001 135.894Z",
    fill: "#DDE0E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.118 135.839L420 135.894L436.522 171.519L436.64 171.464L420.118 135.839Z",
    fill: "#DEE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.243 135.783L420.125 135.838L436.647 171.463L436.765 171.409L420.243 135.783Z",
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.352 135.729L420.234 135.783L436.756 171.409L436.874 171.354L420.352 135.729Z",
    fill: "#E0E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.462 135.677L420.344 135.731L436.865 171.357L436.983 171.302L420.462 135.677Z",
    fill: "#E1E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.587 135.622L420.469 135.677L436.99 171.302L437.108 171.247L420.587 135.622Z",
    fill: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.704 135.565L420.586 135.62L437.108 171.246L437.226 171.191L420.704 135.565Z",
    fill: "#E3E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.829 135.511L420.711 135.565L437.233 171.191L437.351 171.136L420.829 135.511Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.938 135.459L420.82 135.514L437.342 171.139L437.46 171.084L420.938 135.459Z",
    fill: "#E5E7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.055 135.395L420.938 135.449L437.459 171.075L437.577 171.02L421.055 135.395Z",
    fill: "#E6E8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.18 135.349L421.062 135.403L437.584 171.029L437.702 170.974L421.18 135.349Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.298 135.293L421.18 135.348L437.701 170.973L437.819 170.918L421.298 135.293Z",
    fill: "#E8EAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.423 135.238L421.305 135.293L437.826 170.918L437.944 170.864L421.423 135.238Z",
    fill: "#E9EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.532 135.187L421.414 135.241L437.936 170.867L438.054 170.812L421.532 135.187Z",
    fill: "#E9EBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.641 135.131L421.523 135.186L438.045 170.811L438.163 170.756L421.641 135.131Z",
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.774 135.075L421.656 135.13L438.178 170.755L438.296 170.701L421.774 135.075Z",
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.884 135.02L421.766 135.075L438.287 170.701L438.405 170.646L421.884 135.02Z",
    fill: "#ECEDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.993 134.969L421.875 135.023L438.397 170.649L438.515 170.594L421.993 134.969Z",
    fill: "#EDEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.118 134.914L422 134.969L438.522 170.594L438.64 170.539L422.118 134.914Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.235 134.858L422.117 134.913L438.639 170.538L438.757 170.484L422.235 134.858Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.36 134.793L422.242 134.848L438.764 170.473L438.882 170.418L422.36 134.793Z",
    fill: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.47 134.752L422.352 134.807L438.873 170.432L438.991 170.377L422.47 134.752Z",
    fill: "#F0F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.579 134.687L422.461 134.741L438.983 170.367L439.1 170.312L422.579 134.687Z",
    fill: "#F1F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.712 134.641L422.594 134.695L439.115 170.321L439.233 170.266L422.712 134.641Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.829 134.585L422.711 134.64L439.233 170.265L439.351 170.21L422.829 134.585Z",
    fill: "#F2F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.954 134.53L422.836 134.585L439.358 170.21L439.476 170.156L422.954 134.53Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.063 134.479L422.945 134.533L439.467 170.159L439.585 170.104L423.063 134.479Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.173 134.424L423.055 134.479L439.576 170.104L439.694 170.049L423.173 134.424Z",
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.298 134.367L423.18 134.422L439.701 170.047L439.819 169.993L423.298 134.367Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.415 134.303L423.297 134.357L439.819 169.983L439.936 169.928L423.415 134.303Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.532 134.261L423.414 134.315L439.936 169.941L440.054 169.886L423.532 134.261Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.649 134.196L423.531 134.251L440.053 169.876L440.171 169.822L423.649 134.196Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.766 134.15L423.648 134.205L440.17 169.83L440.288 169.776L423.766 134.15Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.891 134.085L423.773 134.14L440.295 169.765L440.413 169.71L423.891 134.085Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.009 134.039L423.891 134.094L440.412 169.719L440.53 169.664L424.009 134.039Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.118 133.988L424 134.043L440.522 169.668L440.64 169.614L424.118 133.988Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.235 133.933L424.117 133.987L440.639 169.613L440.757 169.558L424.235 133.933Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.36 133.877L424.242 133.932L440.764 169.557L440.882 169.502L424.36 133.877Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.477 133.812L424.359 133.867L440.881 169.493L440.999 169.438L424.477 133.812Z",
    fill: "#FAFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.587 133.771L424.469 133.825L440.99 169.451L441.108 169.396L424.587 133.771Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.704 133.706L424.586 133.761L441.108 169.386L441.226 169.331L424.704 133.706Z",
    fill: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.829 133.66L424.711 133.715L441.233 169.34L441.351 169.286L424.829 133.66Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.946 133.595L424.828 133.649L441.35 169.275L441.468 169.22L424.946 133.595Z",
    fill: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.063 133.554L424.945 133.608L441.467 169.234L441.585 169.179L425.063 133.554Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.173 133.488L425.055 133.543L441.576 169.168L441.694 169.114L425.173 133.488Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.298 133.442L425.18 133.497L441.701 169.122L441.819 169.068L425.298 133.442Z",
    fill: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.415 133.378L425.297 133.433L441.819 169.058L441.936 169.003L425.415 133.378Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.532 133.321L425.414 133.376L441.936 169.001L442.054 168.947L425.532 133.321Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.657 133.28L425.539 133.335L442.061 168.96L442.179 168.906L425.657 133.28Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.766 133.215L425.648 133.27L442.17 168.895L442.288 168.84L425.766 133.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.884 133.169L425.766 133.224L442.287 168.849L442.405 168.794L425.884 133.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.009 133.104L425.891 133.159L442.412 168.785L442.53 168.73L426.009 133.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.118 133.062L426 133.117L442.522 168.743L442.64 168.688L426.118 133.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.905 132.697L426.125 133.059L442.647 168.684L443.427 168.322L426.905 132.697Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M419.409 142.71L418.369 143.19L417.889 142.15C417.829 142.03 417.689 141.98 417.569 142.03C417.449 142.08 417.399 142.23 417.449 142.35L417.929 143.39L416.889 143.87C416.769 143.93 416.719 144.07 416.769 144.19C416.819 144.31 416.969 144.36 417.089 144.31L418.129 143.83L418.609 144.87C418.669 144.99 418.809 145.04 418.929 144.99C419.049 144.94 419.099 144.79 419.049 144.67L418.569 143.63L419.609 143.15C419.729 143.09 419.779 142.95 419.729 142.83C419.679 142.71 419.529 142.66 419.409 142.71Z",
    fill: "#090E16"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M419.55 142.36L418.51 142.84L418.03 141.8C417.97 141.68 417.83 141.63 417.71 141.68C417.59 141.73 417.54 141.88 417.59 142L418.07 143.04L417.03 143.52C416.91 143.58 416.86 143.72 416.91 143.84C416.96 143.96 417.11 144.01 417.23 143.96L418.27 143.48L418.75 144.52C418.81 144.64 418.95 144.69 419.07 144.64C419.19 144.59 419.24 144.44 419.19 144.32L418.71 143.28L419.75 142.8C419.87 142.74 419.92 142.6 419.87 142.48C419.82 142.36 419.67 142.31 419.55 142.36Z",
    fill: "#090E16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1342_37795",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(404.781 184.35) rotate(-90) scale(29.71 29.71)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#737577",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AFB0B1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DADBDB",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1342_37795",
    x1: 373.783,
    y1: 252.14,
    x2: 374.173,
    y2: 183.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19124C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#807C9C",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DCDBE3",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1342_37795",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(332.833 226.07) rotate(120.97) scale(10.89 32.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1342_37795",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(370.188 240.41) scale(24.74 24.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#737577",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AFB0B1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DADBDB",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1342_37795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 689.66,
    height: 286.54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenguinErrorLight);
export default __webpack_public_path__ + "static/media/PenguinErrorLight.ecbfee387abca220d9713b2aa11a63e9.svg";
export { ForwardRef as ReactComponent };